import React, { useState, useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithCustomToken, signOut, deleteUser } from 'firebase/auth';
import { getFirestore, collection, addDoc, doc, getDoc, getDocs, deleteDoc, query, where, onSnapshot, updateDoc, deleteField } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { format, addMonths, subMonths, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, getDay, isSameMonth, isSameDay, parseISO, differenceInHours, differenceInDays, isTomorrow, isWithinInterval, addYears, subDays } from 'date-fns';
import { es } from 'date-fns/locale';
import imageCompression from 'browser-image-compression';

// --- CONFIGURACIÓN DE FIREBASE ---
const firebaseConfig = {
    apiKey: "AIzaSyCoQoKPJ1hT9rbCHeuZ84a8UlHzlWDxTZc",
    authDomain: "dashboard-alquiler.firebaseapp.com",
    projectId: "dashboard-alquiler",
    storageBucket: "dashboard-alquiler.firebasestorage.app",
    messagingSenderId: "217077757818",
    appId: "1:217077757818:web:f5fc57360f82f1b26c48c3"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const appId = 'furgolaser-rental-data';

// --- FUNCIÓN DE UTILIDAD PARA RUTAS DE BASE DE DATOS ---
const getCollectionPath = (userId, collectionName) => {
    if (!userId) throw new Error("User ID is required to build collection path.");
    return `artifacts/${appId}/users/${userId}/${collectionName}`;
};
const MANTENIMIENTO_TIPOS_FURGOS = [
    'ITV', 'Neumáticos', 'Aceite', 'Filtro de Aire', 'Filtro de Aceite',
    'Pastillas de Freno', 'Discos de Freno', 'Reparación', 'Impuestos', 'Filtro Gasoil', 'Otros'
];

const MANTENIMIENTO_TIPOS_EQUIPOS = [
    'Revisión Anual', 'Cambio de Lámpara', 'Calibración', 'Reparación', 'Limpieza', 'Otros'
];


const BookOpenIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z" clipRule="evenodd" /></svg>;
const MenuIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>;
const HomeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" /></svg>;
const CarIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M18 8a2 2 0 00-2-2H4a2 2 0 00-2 2v4a1 1 0 001 1h1v1a2 2 0 002 2h8a2 2 0 002-2v-1h1a1 1 0 001-1V8zm-2 4h-2v-2h2v2zm-4 0H8v-2h4v2z" clipRule="evenodd" /></svg>;
const WrenchIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0L7.86 5.45a7.96 7.96 0 00-2.02.63l-2.25-1.02c-1.45-.66-3.03.92-2.37 2.37l1.02 2.25A7.96 7.96 0 003 11.49l-2.24 1.34c-1.56.93-.83 3.37 1.25 3.37H4.5c.34 0 .68-.05 1-.15l1.82-.61a8.03 8.03 0 001.96 1.96l-.61 1.82c-.1.32-.15.66-.15 1v1.75c0 2.08 2.44 2.81 3.37 1.25l1.34-2.24a7.96 7.96 0 002.02-.63l2.25 1.02c1.45.66 3.03-.92 2.37-2.37l-1.02-2.25a7.96 7.96 0 00-.63-2.02l2.24-1.34c1.56-.93.83-3.37-1.25-3.37H15.5c-.34 0-.68.05-1 .15l-1.82.61a8.03 8.03 0 00-1.96-1.96l.61-1.82c.1-.32.15-.66.15-1V4.5c0-2.08-2.44-2.81-3.37-1.25l-1.34 2.24zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" /></svg>;
const BellIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor"><path d="M10 2a6 6 0 00-6 6v3.586l-1.707 1.707A1 1 0 003 15h14a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" /></svg>;
const BellAlertIcon = ({ count }) => (
    <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500 animate-bell" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 2a6 6 0 00-6 6v3.586l-1.707 1.707A1 1 0 003 15h14a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
        </svg>
        {count > 0 && (
            <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold rounded-full h-4 w-4 flex items-center justify-center">
                {count}
            </span>
        )}
    </div>
);
const BriefcaseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm10 2a1 1 0 10-2 0v1a1 1 0 102 0V6zM4 12a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1z" clipRule="evenodd" /></svg>;
const SparklesIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5 2a1 1 0 00-1 1v1.586l-1.293 1.293a1 1 0 001.414 1.414L5 6.414V8a1 1 0 002 0V6.414l.293.293a1 1 0 001.414-1.414L7.414 4.586V3a1 1 0 00-1-1H5zM15 2a1 1 0 00-1 1v1.586l-1.293 1.293a1 1 0 101.414 1.414L15 6.414V8a1 1 0 102 0V6.414l.293.293a1 1 0 101.414-1.414L17.414 4.586V3a1 1 0 00-1-1h-1zM5 12a1 1 0 00-1 1v1.586l-1.293 1.293a1 1 0 101.414 1.414L5 16.414V18a1 1 0 102 0v-1.586l.293.293a1 1 0 101.414-1.414L7.414 14.586V13a1 1 0 00-1-1H5zM15 12a1 1 0 00-1 1v1.586l-1.293 1.293a1 1 0 101.414 1.414L15 16.414V18a1 1 0 102 0v-1.586l.293.293a1 1 0 101.414-1.414L17.414 14.586V13a1 1 0 00-1-1h-1z" clipRule="evenodd" /></svg>;
const LightBulbIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor"><path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.657a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 14.95a1 1 0 001.414 1.414l.707-.707a1 1 0 00-1.414-1.414l-.707.707zM4 10a1 1 0 01-1 1H2a1 1 0 110-2h1a1 1 0 011 1zM10 18a1 1 0 01-1-1v-1a1 1 0 112 0v1a1 1 0 01-1 1zM10 6a4 4 0 100 8 4 4 0 000-8z" /></svg>;
const CalendarIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" /></svg>;
const PlusCircleIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" /></svg>;
const FileIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" /></svg>;
const XIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm4 0a1 1 0 012 0v6a1 1 0 11-2 0V8z" clipRule="evenodd" /></svg>;
const PencilIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" /><path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" /></svg>;
const ChevronLeftIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>;
const ChevronRightIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>;
const ChevronDownIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /></svg>;
const DotsVerticalIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" /></svg>;
const SpeedIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>;
const UserIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>;
const GarageIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>;
const ShieldCheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 1.944A11.954 11.954 0 012.166 5.02.964.964 0 002 5.941V14.5a.964.964 0 00.41 1.253l7 4.5a.964.964 0 001.18 0l7-4.5a.964.964 0 00.41-1.253V5.941a.964.964 0 00-.166-.921A11.954 11.954 0 0110 1.944zM9 13.093l-3-3.093a1 1 0 011.414-1.414l2.293 2.293 4.293-4.293a1 1 0 011.414 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" /></svg>;
const CheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>;
const ReportIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M8.257 3.099A.75.75 0 019 2.5h2a.75.75 0 01.743.599l.482 2.41A.75.75 0 0111.743 6H14a1 1 0 011 1v1.5a1 1 0 00.816.983l1.83.457a.75.75 0 01.554.734V15.5a.75.75 0 01-.554.734l-1.83.457A1 1 0 0015 17.5V19a1 1 0 01-1 1H6a1 1 0 01-1-1v-1.5a1 1 0 00-.816-.983l-1.83-.457a.75.75 0 01-.554-.734V10.67a.75.75 0 01.554-.734l1.83-.457A1 1 0 005 8.5V7a1 1 0 011-1h2.257a.75.75 0 01.482-.901l.482-1.206zM10 12a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" /></svg>;
const MicrophoneIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8h-1a6 6 0 11-12 0H3a7.001 7.001 0 006 6.93V17H7a1 1 0 100 2h6a1 1 0 100-2h-2v-2.07z" clipRule="evenodd" /></svg>;
const CubeTransparentIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9.5 3.5a1 1 0 011 0l5 2.5a1 1 0 01.5.866V14.5a1 1 0 01-1.5.866L10 12.594l-4.5 2.772a1 1 0 01-1.5-.866V6.866a1 1 0 01.5-.866l5-2.5zM10 5.406L6.5 7.156v4.688l3.5-2.156V5.406zm4 1.75v4.688l-3.5 2.156V7.156L14 7.156z" clipRule="evenodd" /></svg>;
// --- HOOKS PERSONALIZADOS ---
const useInView = (options) => {
    const containerRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                    observer.unobserve(entry.target);
                }
            },
            options
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, [containerRef, options]);

    return [containerRef, isInView];
};

// --- FUNCIÓN DE UTILIDAD PARA MANEJO Y COMPRESIÓN DE ARCHIVOS ---
const handleFileProcessing = async (e, setFile, setError, options = {}) => {
    const { maxSizeMB = 5, compress = false } = options;

    if (!e.target.files || !e.target.files[0]) {
        return;
    }

    let file = e.target.files[0];

    // 1. Validar tamaño máximo
    if (file.size > maxSizeMB * 1024 * 1024) {
        setError(`El archivo no puede superar los ${maxSizeMB}MB.`);
        e.target.value = null; // Limpia el input
        setFile(null);
        return;
    }

    // 2. Comprimir si es una imagen y se ha solicitado
    if (compress && file.type.startsWith('image/')) {
        try {
            const compressionOptions = {
                maxSizeMB: 1,          // Objetivo de tamaño
                maxWidthOrHeight: 1920, // Redimensionar si es muy grande
                useWebWorker: true,
            };
            const compressedFile = await imageCompression(file, compressionOptions);
            setFile(compressedFile);
            setError('');
        } catch (compressionError) {
            console.error('Error al comprimir la imagen, se usará el original:', compressionError);
            setFile(file); // Fallback: si la compresión falla, usa el original
            setError('');
        }
    } else { // Para PDFs, videos, o si no se solicita compresión
        setFile(file);
        setError('');
    }
};
// --- COMPONENTES DE LA UI ---

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 md:p-8 shadow-xl w-full max-w-md mx-4">
                <h3 className="text-lg md:text-xl font-bold mb-4">{title}</h3>
                <p className="text-gray-600 mb-6">{message}</p>
                <div className="flex justify-end gap-4">
                    <button onClick={onClose} className="px-4 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300">
                        Cancelar
                    </button>
                    <button onClick={onConfirm} className="px-4 py-2 rounded-lg text-white bg-red-600 hover:bg-red-700">
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
};

const InfoModal = ({ isOpen, onClose, title, content }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 md:p-8 shadow-xl w-full max-w-md mx-4">
                <h3 className="text-lg md:text-xl font-bold mb-4">{title}</h3>
                <p className="text-gray-600 whitespace-pre-wrap">{content}</p>
                <div className="flex justify-end mt-6">
                    <button onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

const Lightbox = ({ content, onClose }) => {
    if (!content) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-[100] p-4"
            onClick={onClose}
        >
            <button
                className="absolute top-4 right-4 text-white text-5xl font-bold"
                onClick={onClose}
            >
                &times;
            </button>
            <div className="max-w-4xl max-h-full" onClick={(e) => e.stopPropagation()}>
                {content.type.startsWith('image/') ? (
                    <img src={content.url} alt="Vista ampliada" className="max-w-full max-h-[90vh] object-contain" />
                ) : (
                    <video src={content.url} controls autoPlay className="max-w-full max-h-[90vh]"></video>
                )}
            </div>
        </div>
    );
};

const UpcomingEventBanner = ({ events, onOpenItvAppointmentModal, onCancelItvAppointment, onDismiss, onDeleteInsuranceReminder }) => {
    const [expandedBannerId, setExpandedBannerId] = useState(null);
    const [confirmingDismissalId, setConfirmingDismissalId] = useState(null);

    if (!events || events.length === 0) {
        return null;
    }

    const handleBannerClick = (event) => {
        // Acción directa para el banner de vencimiento de ITV
        if (event.eventType === 'itv-due') {
            onOpenItvAppointmentModal(event.furgoneta);
            onDismiss(event.id); // Oculta el banner una vez que se ha interactuado
            return;
        }

        // Lógica de expansión/contracción para otros banners
        if (expandedBannerId !== event.id) {
            setExpandedBannerId(event.id);
            setConfirmingDismissalId(null);
        } else {
            // Para estos tipos, el segundo clic no hace nada, las acciones están en los botones
            if (event.eventType === 'itv-appointment' || event.eventType === 'insurance-due') {
                return;
            }
            // Para otros banners, el segundo clic muestra la confirmación
            setConfirmingDismissalId(event.id);
        }
    };

    const handleConfirmDismissal = (eventId) => {
        onDismiss(eventId);
        setConfirmingDismissalId(null);
        setExpandedBannerId(null);
    };

    const handleCancelDismissal = () => {
        setConfirmingDismissalId(null);
        setExpandedBannerId(null);
    };

    const handleCancelAppointmentClick = (e, event) => {
        e.stopPropagation(); // Evita que el clic en el botón active el handleBannerClick del div padre
        onCancelItvAppointment(event.furgoneta); // Pasamos el objeto furgoneta completo
        onDismiss(event.id); // Oculta el banner de recordatorio de cita
        setExpandedBannerId(null); // Resetea el estado para que los otros banners no se queden atenuados
    };

    const handleInsuranceReminderDelete = (e, event) => {
        e.stopPropagation();
        onDeleteInsuranceReminder(event);
        onDismiss(event.id);
        setExpandedBannerId(null); // Resetea el estado para que los otros banners no se queden atenuados
    };

    return (
        <div className="fixed top-0 left-0 right-0 z-[60] flex flex-row flex-wrap justify-center items-center pt-4 gap-2 pointer-events-none">
            {events.map(event => (
                <div
                    key={event.id}
                    className={`relative transition-all duration-300 ease-in-out ${(expandedBannerId !== null && expandedBannerId !== event.id)
                        ? 'pointer-events-none opacity-50'
                        : 'cursor-pointer pointer-events-auto'
                        }`}
                    onClick={() => handleBannerClick(event)}
                >
                    {expandedBannerId === event.id ? (
                        // --- Vista de Banner Expandido ---
                        <div className="bg-red-600 text-white p-4 rounded-lg shadow-lg w-80 max-w-sm overflow-hidden">
                            <p className="text-sm font-semibold">{event.title}</p>

                            {/* Botón específico para el banner de recordatorio de cita */}
                            {event.eventType === 'itv-appointment' && (
                                <div className="mt-2 flex gap-4 justify-center">
                                    <button
                                        onClick={(e) => handleCancelAppointmentClick(e, event)}
                                        className="bg-green-600 px-6 py-2 rounded-lg hover:bg-green-700 font-semibold"
                                    >
                                        ITV Pasada
                                    </button>
                                </div>
                            )}

                            {/* NUEVO: Botones para el banner de vencimiento de seguro */}
                            {event.eventType === 'insurance-due' && (
                                <div className="mt-2 flex gap-4 justify-center">
                                    <button
                                        onClick={(e) => { e.stopPropagation(); onDismiss(event.id); setExpandedBannerId(null); }}
                                        className="bg-gray-700 px-4 py-2 rounded-lg hover:bg-gray-800 font-semibold text-sm"
                                    >
                                        Borrar Banner
                                    </button>
                                    <button
                                        onClick={(e) => handleInsuranceReminderDelete(e, event)}
                                        className="bg-red-800 px-4 py-2 rounded-lg hover:bg-red-900 font-semibold text-sm"
                                    >
                                        Borrar Recordatorio
                                    </button>
                                </div>
                            )}

                            {/* Superposición de Confirmación */}
                            {confirmingDismissalId === event.id && event.eventType !== 'itv-appointment' && event.eventType !== 'insurance-due' && (
                                <div className="absolute inset-0 bg-black bg-opacity-75 flex flex-col items-center justify-center gap-4 p-4" onClick={(e) => e.stopPropagation()}>
                                    <p className="text-lg font-bold text-white text-center">¿Quieres eliminar este banner?</p>
                                    <div className="flex gap-4">
                                        <button onClick={() => handleConfirmDismissal(event.id)} className="bg-green-500 px-6 py-2 rounded-lg hover:bg-green-600 font-semibold">SÍ</button>
                                        <button onClick={handleCancelDismissal} className="bg-gray-500 px-6 py-2 rounded-lg hover:bg-gray-600 font-semibold">NO</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        // --- Vista de Círculo Contraído ---
                        <div className={`w-12 h-12 rounded-full flex items-center justify-center shadow-lg animate-pulse ${event.eventType === 'itv-appointment' ? 'bg-blue-600' : 'bg-red-600'}`}>
                            <span className="text-white font-bold text-2xl">{event.eventType === 'itv-appointment' ? 'C' : 'R'}</span>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

const SetItvAppointmentModal = ({ isOpen, onClose, onSave, furgoneta }) => {
    const [fechaCita, setFechaCita] = useState('');
    const [horaCita, setHoraCita] = useState('');

    if (!isOpen) return null;

    const handleSave = () => {
        if (fechaCita && horaCita) {
            onSave(furgoneta.id, fechaCita, horaCita);
            onClose();
        } else {
            alert("Por favor, selecciona una fecha y una hora.");
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
                <div className="p-6 md:p-8 space-y-6">
                    <h2 className="text-xl font-bold text-gray-800">Agendar Cita ITV para {furgoneta?.matricula}</h2>
                    <p className="text-sm text-gray-600">Introduce la fecha y hora en la que tienes la cita para pasar la ITV.</p>
                    <div className="space-y-4">
                        <InputField label="Fecha de la Cita" type="date" value={fechaCita} onChange={e => setFechaCita(e.target.value)} required />
                        <InputField label="Hora de la Cita" type="time" value={horaCita} onChange={e => setHoraCita(e.target.value)} required />
                    </div>
                    <div className="flex justify-end gap-4 pt-4">
                        <button onClick={onClose} className="px-6 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 font-semibold">Cancelar</button>
                        <button onClick={handleSave} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold">Guardar Cita</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AccessDeniedPage = () => (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
        <div className="text-center">
            <h1 className="text-4xl font-bold text-red-600 uppercase" style={{ letterSpacing: '0.1em' }}>
                ACCESO DENEGADO
            </h1>
            <p className="mt-4 text-lg text-gray-500">
                No tienes permiso para ver este contenido.
            </p>
        </div>
    </div>
);

const LoginPage = ({ authError }) => (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
            <h1 className="text-4xl font-bold text-orange-500">Furgoláser</h1>
            <p className="text-gray-500 mt-2 mb-8">Control de Furgonetas y Láseres</p>
            {authError && <p className="text-red-500 font-bold mt-4 px-4">{authError}</p>}
            {!authError && <p className="text-gray-700">Por favor, accede desde el panel de administración.</p>}
        </div>
    </div>
);

const ManualPage = () => {
    return (
        <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">Manual de Usuario: Furgoláser</h2>
            <div className="prose prose-sm sm:prose-base max-w-none prose-headings:font-bold prose-headings:text-orange-600 prose-a:text-blue-600 prose-strong:text-gray-700 space-y-4">
                <p>
                    Bienvenido al manual de la aplicación Furgoláser. Esta guía te ayudará a entender y utilizar todas las funciones disponibles para gestionar tu flota de vehículos y equipos.
                </p>

                <hr className="my-6" />

                <h3>Gestión de Furgonetas y Equipos</h3>
                <p>
                    Las secciones de <strong>Furgonetas</strong> y <strong>Equipos</strong> son el núcleo de la aplicación. Ambas funcionan de manera muy similar.
                </p>
                <ul>
                    <li><strong>Vista de Listado:</strong> En la página de inicio, verás tarjetas resumen de cada vehículo o equipo. Desde aquí puedes añadir uno nuevo con el botón "Añadir Furgoneta/Equipo".</li>
                    <li><strong>Añadir/Editar:</strong> Al añadir o editar, se abrirá un formulario (modal) donde puedes rellenar todos los datos: marca, modelo, matrícula, número de serie, etc. Los campos con * son obligatorios. En la ficha de la furgoneta, puedes editar la fecha de vencimiento de la ITV directamente haciendo clic en el icono del lápiz.</li>
                    <li><strong>Vista de Detalles:</strong> Al hacer clic en "Ver Detalles", accederás a la ficha completa. Aquí puedes ver toda la información, la foto principal, y gestionar sus mantenimientos, recordatorios y contratos asociados.</li>
                </ul>

                <hr className="my-6" />

                <h3>El Calendario: Tu Centro de Mando Visual</h3>
                <p>
                    El calendario es tu centro de operaciones visual. Muestra una vista de 6 meses de todos los eventos importantes, codificados por colores para una fácil identificación:
                </p>
                <ul>
                    <li><span className="inline-block w-3 h-3 rounded-full mr-2" style={{ backgroundColor: '#ef4444' }}></span><strong className="text-red-600">Rojo:</strong> Vencimientos de ITV.</li>
                    <li><span className="inline-block w-3 h-3 rounded-full mr-2" style={{ backgroundColor: '#4f46e5' }}></span><strong className="text-indigo-600">Morado:</strong> Vencimientos de Pólizas de Seguro.</li>
                    <li><span className="inline-block w-3 h-3 rounded-full mr-2" style={{ backgroundColor: '#f59e0b' }}></span><strong className="text-amber-600">Amarillo:</strong> Recordatorios manuales que has creado.</li>
                    <li><span className="inline-block w-3 h-3 rounded-full mr-2" style={{ backgroundColor: '#3b82f6' }}></span><strong className="text-blue-600">Azul:</strong> Mantenimientos ya realizados.</li>
                </ul>
                <p>
                    Puedes hacer clic en cualquier día para ver los eventos correspondientes en la barra lateral derecha. Si haces clic en un evento, te llevará directamente a la ficha del vehículo o equipo correspondiente.
                </p>

                <hr className="my-6" />

                <h3>El Sistema de Recordatorios (¡La Clave de Todo!)</h3>
                <p>
                    Esta es una de las funciones más potentes para no olvidar nunca una fecha importante. El sistema te avisará mediante <strong>banners en la parte superior de la pantalla</strong>. Existen varios tipos:
                </p>

                <h4>1. Recordatorios Manuales</h4>
                <p>
                    Son aquellos que tú creas para cualquier evento futuro que no sea una ITV o un seguro.
                </p>
                <ul>
                    <li><strong>¿Cómo funcionan?:</strong> Cuando marcas un recordatorio manual como <strong>"Hecho"</strong>, la aplicación te abre directamente la ventana para <strong>"Añadir Mantenimiento"</strong> con los datos ya rellenados. Al guardar el mantenimiento, el recordatorio se elimina automáticamente.</li>
                </ul>

                <h4>2. Recordatorios Automáticos (ITV y Seguros)</h4>
                <p>
                    Estos recordatorios los genera el sistema automáticamente basándose en las fechas que has introducido. No necesitas crearlos manualmente.
                </p>
                <ul>
                    <li>
                        <strong>Aviso de Vencimiento de ITV:</strong> Cuando falten <strong>dos meses</strong> para que caduque la ITV de una furgoneta, aparecerá un <strong>banner rojo (R)</strong>. Al pulsarlo, se abrirá una ventana para que puedas <strong>agendar la cita de la ITV</strong>.
                    </li>
                    <li>
                        <strong>Aviso de Cita de ITV:</strong> El día antes de la cita que has agendado, aparecerá un <strong>banner azul (C)</strong> recordándotelo. Este banner tiene un botón muy importante: <strong>"ITV Pasada"</strong>.
                    </li>
                    <li>
                        <strong>Aviso de Vencimiento de Seguro:</strong> Cuando falten <strong>dos meses</strong> para que venza la póliza de seguro, aparecerá un <strong>banner rojo (R)</strong>. Al pulsarlo, se expandirá y te dará dos opciones:
                        <ul>
                            <li><strong>Borrar Banner:</strong> Oculta el aviso solo para la sesión actual. Si recargas la página, volverá a aparecer.</li>
                            <li><strong>Borrar Recordatorio:</strong> Elimina permanentemente el recordatorio de la base de datos y lo oculta hasta que registres una nueva póliza con una nueva fecha de vencimiento. <strong>Usa esta opción cuando ya hayas renovado el seguro.</strong></li>
                        </ul>
                    </li>
                </ul>

                <h4>El Proceso Mágico: ¿Qué pasa al pulsar "ITV Pasada"?</h4>
                <p>
                    Esta es una función clave para ahorrarte trabajo. Cuando haces clic en el botón <strong>"ITV Pasada"</strong> del banner azul:
                </p>
                <ul>
                    <li><strong>Paso 1:</strong> La aplicación te abre directamente la ventana para <strong>"Añadir Mantenimiento"</strong> con el tipo "ITV" y la descripción "ITV PASADA" ya rellenados.</li>
                    <li><strong>Paso 2:</strong> Solo tienes que rellenar el coste y el taller, y guardar.</li>
                    <li><strong>Paso 3 (La Magia):</strong> Una vez guardado, el sistema hace tres cosas automáticamente:
                        <ol>
                            <li>Registra el mantenimiento en el historial.</li>
                            <li>Borra la cita de ITV que tenías agendada.</li>
                            <li><strong>Calcula y actualiza la fecha del próximo vencimiento de la ITV</strong> en la ficha de la furgoneta (sumando 6 o 12 meses según la configuración del vehículo).</li>
                        </ol>
                    </li>
                </ul>
                <p>
                    De esta forma, el ciclo vuelve a empezar sin que tengas que actualizar la fecha manualmente.
                </p>

                <hr className="my-6" />

                <h3>Secciones Principales</h3>
                <ul>
                    <li><strong>Mantenimientos (Furgos y Equipos):</strong> Ofrecen un historial completo de todos los gastos. Puedes filtrar por fechas, por vehículo/equipo o por tipo de mantenimiento para ver costes totales y desglosados.</li>
                    <li><strong>Partes de Golpes y Multas:</strong> Una sección dedicada para registrar cualquier incidente en las furgonetas. Puedes añadir descripciones detalladas, múltiples fotos, vídeos e incluso <strong>grabar notas de voz</strong> directamente desde la aplicación para no olvidar ningún detalle.</li>
                    <li><strong>Talleres y Corredurías de Seguros:</strong> Son agendas de contactos para tener la información de tus proveedores siempre a mano y centralizada.</li>
                    <li><strong>Trucos Equipos:</strong> Una biblioteca visual para guardar y consultar guías rápidas, fotos o vídeos útiles sobre el manejo de los equipos.</li>
                </ul>

                <hr className="my-6" />

                <h3>Funciones Protegidas por Contraseña</h3>
                <p>
                    Para evitar borrados accidentales de información crítica, ciertas acciones requieren una contraseña de administrador:
                </p>
                <ul>
                    <li>Borrar el historial de mantenimientos desde las páginas de "Mantenimiento Furgos" y "Mantenimiento Equipos".</li>
                    <li>Editar o borrar las "Revisiones Anuales" de los equipos.</li>
                    <li>Ver el contrato de un equipo.</li>
                </ul>
            </div>
        </div>
    );
};

const Sidebar = ({ setCurrentPage, currentPage, isOpen, setIsOpen, user }) => {
    const [openSections, setOpenSections] = useState({ furgonetas: true, equipos: true });

    const NavItem = ({ page, icon, children }) => (
        <li className="mb-1">
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    setCurrentPage(...(Array.isArray(page) ? page : [page]));
                    if (window.innerWidth < 1024) { // lg breakpoint
                        setIsOpen(false);
                    }
                }}
                className={`flex items-center py-2.5 px-4 rounded-lg transition-colors duration-200 ${currentPage === page
                    ? 'bg-orange-500 text-white shadow-md'
                    : 'text-gray-700 hover:bg-orange-100'
                    }`}
            >
                {icon}
                <span className="font-medium">{children}</span>
            </a>
        </li>
    );

    const toggleSection = (section) => {
        setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    const SectionHeader = ({ section, icon, children }) => (
        <div onClick={() => toggleSection(section)} className="flex items-center justify-between cursor-pointer px-4 py-2 text-orange-900/80 hover:bg-orange-100/50 rounded-lg">
            <div className="flex items-center text-sm font-semibold"><span className="mr-3">{icon}</span>{children}</div>
            <ChevronDownIcon className={`transform transition-transform ${openSections[section] ? 'rotate-180' : ''}`} />
        </div>
    );

    return (
        <>
            <div className={`fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={() => setIsOpen(false)}></div>
            <aside className={`absolute top-0 left-0 w-64 bg-orange-50/95 backdrop-blur-sm p-4 flex flex-col h-screen lg:h-full border-r border-orange-200 z-40 lg:relative lg:translate-x-0 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                <div className="text-center py-4 mb-4">
                    <h1 className="text-3xl font-bold text-orange-500">Furgoláser</h1>
                </div>
                <nav className="flex-1 overflow-y-auto">
                    <ul>
                        <li className="mt-4 mb-2">
                            <SectionHeader section="furgonetas" icon={<CarIcon />}>Mis Furgonetas</SectionHeader>
                            {openSections.furgonetas && (
                                <ul className="pl-4 pt-1">
                                    <NavItem page="furgonetas" icon={<CarIcon />}>Furgonetas</NavItem>
                                    <NavItem page="talleres" icon={<WrenchIcon />}>Talleres</NavItem>
                                    <NavItem page="mantenimiento_furgos" icon={<WrenchIcon />}>Mantenimiento Furgos</NavItem>
                                    <NavItem page="golpes_multas" icon={<ReportIcon />}>Golpes y Multas</NavItem>
                                    <NavItem page="recordatorios_furgos" icon={<BellIcon />}>Recordatorios Furgos</NavItem>
                                    <NavItem page="correduria_seguros" icon={<BriefcaseIcon />}>Correduría Seguros</NavItem>
                                </ul>
                            )}
                        </li>
                        <li className="mt-4 mb-2">
                            <SectionHeader section="equipos" icon={<SparklesIcon />}>Mis Equipos</SectionHeader>
                            {openSections.equipos && (
                                <ul className="pl-4 pt-1">
                                    <NavItem page="equipos" icon={<SparklesIcon />}>Equipos</NavItem>
                                    <NavItem page="mantenimiento_equipos" icon={<WrenchIcon />}>Mantenimiento Equipos</NavItem>
                                    <NavItem page="recordatorios_equipos" icon={<BellIcon />}>Recordatorios Equipos</NavItem>
                                    <NavItem page="trucos_equipos" icon={<LightBulbIcon />}>Trucos Equipos</NavItem>
                                </ul>
                            )}
                        </li>
                    </ul>
                </nav>
            </aside>
        </>
    );
};

// --- MODAL PARA AÑADIR/EDITAR FURGONETA ---
const AddFurgonetaModal = ({ isOpen, onClose, onFurgonetaSaved, furgonetaToEdit, user }) => {
    const [marcaModelo, setMarcaModelo] = useState('');
    const [matricula, setMatricula] = useState('');
    const [plazaGaraje, setPlazaGaraje] = useState('');
    const [nombreInterno, setNombreInterno] = useState('');
    const [contrasenaRadio, setContrasenaRadio] = useState('');
    const [kilometraje, setKilometraje] = useState('');
    const [conductor, setConductor] = useState('');
    const [estado, setEstado] = useState('Activo');
    const [itvFrequency, setItvFrequency] = useState('Cada Año'); // Nuevo estado para la frecuencia
    const [imagenFile, setImagenFile] = useState(null);
    const [fichaTecnicaFile, setFichaTecnicaFile] = useState(null);
    const [permisoCirculacionFile, setPermisoCirculacionFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [itvDueDate, setItvDueDate] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (furgonetaToEdit) {
            setMarcaModelo(furgonetaToEdit.marcaModelo || '');
            setMatricula(furgonetaToEdit.matricula || '');
            setPlazaGaraje(furgonetaToEdit.plazaGaraje || '');
            setNombreInterno(furgonetaToEdit.nombreInterno || '');
            setContrasenaRadio(furgonetaToEdit.contrasenaRadio || '');
            setKilometraje(furgonetaToEdit.kilometraje || '');
            setConductor(furgonetaToEdit.conductor || '');
            setItvDueDate(furgonetaToEdit.itvDueDate || '');
            setItvFrequency(furgonetaToEdit.itvFrequency || 'Cada Año'); // Cargar frecuencia
            setEstado(furgonetaToEdit.estado || 'Activo');
        } else {
            setMarcaModelo(''); setMatricula(''); setPlazaGaraje('');
            setNombreInterno(''); setContrasenaRadio(''); setKilometraje(''); setItvFrequency('Cada Año');
            setConductor(''); setEstado('Activo'); setItvDueDate('');
        }
        setImagenFile(null);
        setFichaTecnicaFile(null);
        setPermisoCirculacionFile(null);
    }, [furgonetaToEdit, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!marcaModelo || !matricula || !plazaGaraje) {
            setError('Los campos con * son obligatorios.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // --- CAMBIO DE SEGURIDAD SAAS ---
            const clientFolder = user.clientId || user.uid;
            // -------------------------------

            let imageUrl = furgonetaToEdit?.imageUrl || '';
            let fichaTecnicaUrl = furgonetaToEdit?.fichaTecnicaUrl || '';
            let permisoCirculacionUrl = furgonetaToEdit?.permisoCirculacionUrl || '';

            if (imagenFile) {
                // Antes: furgonetas_imagenes/${appId}/...
                // Ahora: uploads/${clientFolder}/furgonetas_imagenes/...
                const imageRef = ref(storage, `uploads/${clientFolder}/furgonetas_imagenes/${Date.now()}_${imagenFile.name}`);
                await uploadBytes(imageRef, imagenFile);
                imageUrl = await getDownloadURL(imageRef);
            }

            if (fichaTecnicaFile) {
                const fichaRef = ref(storage, `uploads/${clientFolder}/furgonetas_documentos/ficha_${Date.now()}_${fichaTecnicaFile.name}`);
                await uploadBytes(fichaRef, fichaTecnicaFile);
                fichaTecnicaUrl = await getDownloadURL(fichaRef);
            }

            if (permisoCirculacionFile) {
                const permisoRef = ref(storage, `uploads/${clientFolder}/furgonetas_documentos/permiso_${Date.now()}_${permisoCirculacionFile.name}`);
                await uploadBytes(permisoRef, permisoCirculacionFile);
                permisoCirculacionUrl = await getDownloadURL(permisoRef);
            }

            const furgonetaData = {
                nombre: nombreInterno.toUpperCase() || marcaModelo.toUpperCase(),
                marcaModelo: marcaModelo.toUpperCase(),
                matricula: matricula.toUpperCase(),
                plazaGaraje: plazaGaraje.toUpperCase(),
                nombreInterno: nombreInterno.toUpperCase(),
                contrasenaRadio: contrasenaRadio.toUpperCase(),
                kilometraje: kilometraje.toUpperCase(),
                conductor: conductor.toUpperCase(),
                estado: estado.toUpperCase(),
                imageUrl,
                fichaTecnicaUrl,
                permisoCirculacionUrl,
                itvDueDate,
                itvFrequency,
                updatedAt: new Date().toISOString(),
            };

            if (furgonetaToEdit) {
                const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaToEdit.id);
                await updateDoc(furgonetaRef, furgonetaData);
            } else {
                furgonetaData.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'furgonetas')), furgonetaData);
            }

            onFurgonetaSaved();
            onClose();
        } catch (err) {
            setError('Error al guardar la furgoneta. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{furgonetaToEdit ? 'Editar Furgoneta' : 'Añadir Nueva Furgoneta'}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800">
                            <XIcon />
                        </button>
                    </div>
                    <p className="text-sm text-gray-600">Introduce los detalles de la furgoneta. Los campos con * son obligatorios.</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField label="Marca y Modelo *" value={marcaModelo} onChange={(e) => setMarcaModelo(e.target.value)} validationType="textOnly" placeholder="e.g., Renault Kangoo" required />
                        <InputField label="Matrícula *" value={matricula} onChange={(e) => setMatricula(e.target.value)} placeholder="e.g., 1234ABC" required />
                        <InputField label="Plaza de Garaje Nº *" value={plazaGaraje} onChange={(e) => setPlazaGaraje(e.target.value)} validationType="numeric" placeholder="e.g., 47" required />
                        <InputField label="Nombre Interno" value={nombreInterno} onChange={(e) => setNombreInterno(e.target.value)} placeholder="e.g., Equipo 1" />
                        <InputField label="Contraseña Radio" value={contrasenaRadio} onChange={(e) => setContrasenaRadio(e.target.value)} placeholder="e.g., 1234" />
                        <InputField label="Kilometraje Actual" value={kilometraje} onChange={(e) => setKilometraje(e.target.value)} validationType="numeric" placeholder="e.g., 20000" />
                        <InputField label="Conductora Habitual" value={conductor} onChange={(e) => setConductor(e.target.value)} validationType="textOnly" placeholder="e.g., Merche Amado" />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                            <select value={estado} onChange={e => setEstado(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option>Activo</option>
                                <option>En Taller</option>
                                <option>De Baja</option>
                            </select>
                        </div>
                        <InputField label="Vencimiento ITV" type="date" value={itvDueDate} onChange={e => setItvDueDate(e.target.value)} />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">¿Cada Cuánto?</label>
                            <select value={itvFrequency} onChange={e => setItvFrequency(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option>Cada Año</option>
                                <option>Cada 6 Meses</option>
                            </select>
                        </div>
                    </div>
                    <hr className="border-orange-200" />
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Archivos (Opcional)</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Subir Imagen</label>
                                <label htmlFor="imagen-upload" className="cursor-pointer bg-white border border-gray-300 rounded-lg p-3 flex items-center justify-center text-sm text-gray-600 hover:bg-gray-50 w-full">
                                    <FileIcon />
                                    <span className="truncate">{imagenFile ? imagenFile.name : 'Seleccionar Imagen'}</span>
                                </label>
                                <input id="imagen-upload" type="file" className="sr-only" onChange={(e) => handleFileProcessing(e, setImagenFile, setError, { maxSizeMB: 5, compress: true })} accept="image/jpeg,image/png,image/webp" />
                                <p className="text-xs text-gray-500 mt-1">Sube un archivo JPG, PNG o WEBP. (Max 5MB)</p>
                            </div>
                            <FileInput label="Ficha Técnica (PDF)" file={fichaTecnicaFile} setFile={setFichaTecnicaFile} accept="application/pdf" helpText="Sube un archivo PDF. (Max 5MB)" maxSizeMB={5} setError={setError} />
                            <FileInput label="Permiso Circulación (PDF)" file={permisoCirculacionFile} setFile={setPermisoCirculacionFile} accept="application/pdf" helpText="Sube un archivo PDF. (Max 5MB)" maxSizeMB={5} setError={setError} />
                        </div>
                    </div>
                    {error && <p className="text-red-600 text-sm text-center">{error}</p>}
                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 font-semibold">
                            Cancelar
                        </button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : (furgonetaToEdit ? 'Guardar Cambios' : 'Añadir Furgoneta')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// --- MODAL PARA AÑADIR/EDITAR TALLER ---
const AddTallerModal = ({ isOpen, onClose, onTallerSaved, tallerToEdit, user }) => {
    const [nombre, setNombre] = useState('');
    const [propietario, setPropietario] = useState('');
    const [telefono, setTelefono] = useState('');
    const [email, setEmail] = useState('');
    const [direccion, setDireccion] = useState('');
    const [localidad, setLocalidad] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (tallerToEdit) {
            setNombre(tallerToEdit.nombre || '');
            setPropietario(tallerToEdit.propietario || '');
            setTelefono(tallerToEdit.telefono || '');
            setEmail(tallerToEdit.email || '');
            setDireccion(tallerToEdit.direccion || '');
            setLocalidad(tallerToEdit.localidad || '');
        } else {
            setNombre(''); setPropietario(''); setTelefono('');
            setEmail(''); setDireccion(''); setLocalidad('');
        }
    }, [tallerToEdit, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nombre) {
            setError('El nombre del taller es obligatorio.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        const tallerData = {
            nombre: nombre.toUpperCase(),
            propietario: propietario.toUpperCase(),
            telefono: telefono.toUpperCase(),
            email: email.toUpperCase(),
            direccion: direccion.toUpperCase(),
            localidad: localidad.toUpperCase(),
            updatedAt: new Date().toISOString()
        };

        try {
            if (tallerToEdit) {
                const tallerRef = doc(db, getCollectionPath(user.uid, 'talleres'), tallerToEdit.id);
                await updateDoc(tallerRef, tallerData);
            } else {
                tallerData.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'talleres')), tallerData);
            }
            onTallerSaved();
            onClose();
        } catch (err) {
            setError('Error al guardar el taller. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-4">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{tallerToEdit ? 'Editar Taller' : 'Añadir Nuevo Taller'}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>
                    <p className="text-sm text-gray-600">Introduce los detalles del nuevo taller.</p>

                    <div className="space-y-4">
                        <InputField label="Nombre del Taller *" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Taller Speedy" required />
                        <InputField label="Nombre del Propietario (Opcional)" value={propietario} onChange={e => setPropietario(e.target.value)} validationType="textOnly" placeholder="Juan Pérez" />
                        <InputField label="Teléfono (Opcional)" type="tel" value={telefono} onChange={e => setTelefono(e.target.value)} validationType="numeric" placeholder="912345678" />
                        <InputField label="Correo Electrónico (Opcional)" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="contacto@speedy.com" />
                        <InputField label="Dirección (Opcional)" value={direccion} onChange={e => setDireccion(e.target.value)} placeholder="e.g., Calle Falsa 123" />
                        <InputField label="Localidad (Opcional)" value={localidad} onChange={e => setLocalidad(e.target.value)} validationType="textOnly" placeholder="e.g., Madrid" />
                    </div>

                    {error && <p className="text-red-600 text-sm text-center">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">
                            Cancelar
                        </button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar Taller'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const AddTrucoModal = ({ isOpen, onClose, onTrucoAdded, user }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [type, setType] = useState('foto');
    const [file, setFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    // Reset state when modal opens
    useEffect(() => {
        if (isOpen) {
            setTitle('');
            setDescription('');
            setType('foto');
            setFile(null);
            setError('');
            setIsSubmitting(false);
        }
    }, [isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!title || !file) {
            setError('El título y el archivo son obligatorios.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // --- CAMBIO DE SEGURIDAD SAAS ---
            const clientFolder = user.clientId || user.uid;
            // -------------------------------

            const fileRef = ref(storage, `uploads/${clientFolder}/trucos/${Date.now()}_${file.name}`);
            await uploadBytes(fileRef, file);
            const fileUrl = await getDownloadURL(fileRef);

            const trucoData = {
                title: title.toUpperCase(),
                description: description.toUpperCase(),
                type,
                fileUrl,
                fileName: file.name,
                fileType: file.type,
                createdAt: new Date().toISOString(),
            };

            await addDoc(collection(db, getCollectionPath(user.uid, 'trucos')), trucoData);
            onTrucoAdded();
            onClose();

        } catch (err) {
            setError('Error al añadir el truco. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-4">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">Añadir Nuevo Truco</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>
                    <p className="text-sm text-gray-600">Sube un nuevo consejo, foto o vídeo para tus equipos.</p>

                    <div className="space-y-4">
                        <InputField label="Título *" type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Ej: Limpieza de cabezal" required />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                            <textarea value={description} onChange={e => setDescription(e.target.value)} rows="3" placeholder="Describe el truco o consejo..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"></textarea>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Truco</label>
                            <select value={type} onChange={e => setType(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="foto">Foto</option>
                                <option value="video">Vídeo</option>
                            </select>
                        </div>
                        <FileInput label="Archivo *" file={file} setFile={setFile} accept="image/*,video/*" helpText="Sube una imagen o vídeo. (Max 10MB)" required maxSizeMB={10} compress={true} setError={setError} />
                    </div>

                    {error && <p className="text-red-600 text-sm text-center">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar Truco'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const AddMantenimientoModal = ({ isOpen, onClose, onMantenimientoSaved, furgoneta, mantenimientoToEdit, fromRecordatorio, user }) => {
    const [fecha, setFecha] = useState('');
    const [tipos, setTipos] = useState({});
    const [descripcion, setDescripcion] = useState(''); // Cambiado de otroDescripcion a descripcion
    const [coste, setCoste] = useState('');
    const [kilometraje, setKilometraje] = useState('');
    const [tallerId, setTallerId] = useState('');
    const [documentoFile, setDocumentoFile] = useState(null);
    const [talleres, setTalleres] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            const unsub = onSnapshot(collection(db, getCollectionPath(user.uid, 'talleres')), (snapshot) => {
                const talleresData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setTalleres(talleresData);
            });

            const itemToLoad = mantenimientoToEdit || fromRecordatorio;

            if (itemToLoad) {
                setFecha(itemToLoad.fecha || new Date().toISOString().split('T')[0]);
                const tiposCheck = {};
                let parsedDescripcion = itemToLoad.descripcion || ''; // Usar la nueva propiedad si existe

                (itemToLoad.tipos || []).forEach(t => {
                    if (t.startsWith('OTROS:')) {
                        tiposCheck['Otros'] = true;
                        if (!parsedDescripcion) { // Solo si no había una descripción aparte
                            parsedDescripcion = t.replace('OTROS: ', '');
                        }
                    } else {
                        const matchingTipo = MANTENIMIENTO_TIPOS_FURGOS.find(mt => mt.toUpperCase() === t.toUpperCase());
                        if (matchingTipo) {
                            tiposCheck[matchingTipo] = true;
                        }
                    }
                });
                setTipos(tiposCheck);
                setDescripcion(parsedDescripcion);
                setCoste(itemToLoad.coste || '');
                setKilometraje(itemToLoad.kilometraje || '');
                setTallerId(itemToLoad.tallerId || '');
            } else {
                setFecha(new Date().toISOString().split('T')[0]);
                setTipos({});
                setDescripcion('');
                setCoste('');
                setKilometraje('');
                setTallerId('');
            }
            setDocumentoFile(null);
            return () => unsub();
        }
    }, [isOpen, mantenimientoToEdit, fromRecordatorio]);

    const handleTipoChange = (tipo) => {
        setTipos(prev => ({ ...prev, [tipo]: !prev[tipo] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const selectedTipos = Object.keys(tipos).filter(k => tipos[k]);
        if (!fecha || selectedTipos.length === 0 || !coste || !tallerId) {
            setError('Los campos Fecha, Tipo, Coste y Taller son obligatorios.');
            return;
        }
        if (selectedTipos.includes('Otros') && !descripcion) {
            setError('Por favor, añade una descripción para "Otros", es obligatorio.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // --- CAMBIO DE SEGURIDAD SAAS ---
            const clientFolder = user.clientId || user.uid;
            // -------------------------------

            let documentoUrl = mantenimientoToEdit?.documentoUrl || '';
            if (documentoFile) {
                const docRef = ref(storage, `uploads/${clientFolder}/mantenimiento_docs/${Date.now()}_${documentoFile.name}`);
                await uploadBytes(docRef, documentoFile);
                documentoUrl = await getDownloadURL(docRef);
            }

            const tallerSeleccionado = talleres.find(t => t.id === tallerId);

            const mantenimientoData = {
                furgonetaId: furgoneta.id,
                furgonetaMatricula: furgoneta.matricula.toUpperCase(),
                furgonetaNombre: furgoneta.nombre.toUpperCase(),
                fecha,
                tipos: selectedTipos.map(t => t.toUpperCase()), // Se guardan solo los tipos
                descripcion: descripcion.toUpperCase(), // La descripción se guarda como un campo aparte
                coste,
                kilometraje,
                tallerNombre: tallerSeleccionado ? tallerSeleccionado.nombre.toUpperCase() : '',
                documentoUrl,
                updatedAt: new Date().toISOString(),
            };

            if (mantenimientoToEdit) {
                const mantRef = doc(db, getCollectionPath(user.uid, 'mantenimientos_furgos'), mantenimientoToEdit.id);
                await updateDoc(mantRef, mantenimientoData);
            } else {
                mantenimientoData.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'mantenimientos_furgos')), mantenimientoData);
            }

            if (fromRecordatorio && fromRecordatorio.id) {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'recordatorios_furgos'), fromRecordatorio.id));
            }

            onMantenimientoSaved();
            onClose();
        } catch (err) {
            setError('Error al guardar el registro. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    // Comprueba si algún tipo está seleccionado para mostrar el campo de descripción
    const isAnyTipoSelected = Object.values(tipos).some(value => value === true);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{mantenimientoToEdit ? 'Editar' : 'Añadir'} Mantenimiento para {furgoneta?.nombre}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>

                    <div className="space-y-6">
                        <InputField label="Fecha *" type="date" value={fecha} onChange={e => setFecha(e.target.value)} required />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Mantenimiento *</label>
                            <p className="text-xs text-gray-500 mb-2">Selecciona uno o varios tipos.</p>
                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2">
                                {MANTENIMIENTO_TIPOS_FURGOS.map(tipo => (
                                    <label key={tipo} className="flex items-center">
                                        <input type="checkbox" checked={!!tipos[tipo]} onChange={() => handleTipoChange(tipo)} className="h-4 w-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500" />
                                        <span className="ml-2 text-sm text-gray-700">{tipo}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                        {isAnyTipoSelected && (
                            <InputField
                                label={tipos['Otros'] ? 'Descripción (Obligatorio para "Otros") *' : 'Descripción (Opcional)'}
                                type="text"
                                value={descripcion}
                                onChange={e => setDescripcion(e.target.value)}
                                placeholder="Ej: Cambio de líquido de frenos, observaciones..."
                                required={tipos['Otros']}
                            />
                        )}
                        <InputField label="Coste (€) *" type="text" value={coste} onChange={e => setCoste(e.target.value)} validationType="decimal" placeholder="150" required />
                        <InputField label="Kilometraje (km)" type="number" value={kilometraje} onChange={e => setKilometraje(e.target.value)} validationType="numeric" placeholder="75000" />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Taller *</label>
                            <select value={tallerId} onChange={e => setTallerId(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="" disabled>Selecciona un taller</option>
                                {talleres.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                            </select>
                        </div>

                        <FileInput label="Factura (Pdf/Foto)" file={documentoFile} setFile={setDocumentoFile} accept="application/pdf,image/*" maxSizeMB={5} />
                    </div>

                    {error && <p className="text-red-600 text-sm text-center mt-4">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-6">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar Registro'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
const AddRecordatorioModal = ({ isOpen, onClose, onRecordatorioSaved, furgoneta, recordatorioToEdit, user }) => {
    const [tipos, setTipos] = useState({});
    const [descripcion, setDescripcion] = useState(''); // Cambiado de otroDescripcion a descripcion
    const [fecha, setFecha] = useState('');
    const [hora, setHora] = useState('');
    const [aviso, setAviso] = useState('3');
    const [customAviso, setCustomAviso] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (recordatorioToEdit) {
            const tiposCheck = {};
            let parsedDescripcion = recordatorioToEdit.descripcion || ''; // Usar la nueva propiedad si existe

            (recordatorioToEdit.tipos || []).forEach(tipoGuardado => {
                if (tipoGuardado.startsWith('OTROS:')) {
                    tiposCheck['Otros'] = true;
                    if (!parsedDescripcion) {
                        parsedDescripcion = tipoGuardado.replace('OTROS: ', '');
                    }
                } else {
                    const tipoOriginal = MANTENIMIENTO_TIPOS_FURGOS.find(
                        t => t.toUpperCase() === tipoGuardado.toUpperCase()
                    );
                    if (tipoOriginal) {
                        tiposCheck[tipoOriginal] = true;
                    }
                }
            });
            setTipos(tiposCheck);
            setDescripcion(parsedDescripcion);
            setFecha(recordatorioToEdit.fecha || '');
            setHora(recordatorioToEdit.hora || '');

            const predefinedAvisos = ['1', '3', '7', '14', '30'];
            if (recordatorioToEdit.aviso && predefinedAvisos.includes(String(recordatorioToEdit.aviso))) {
                setAviso(recordatorioToEdit.aviso);
                setCustomAviso('');
            } else {
                setAviso('custom');
                setCustomAviso(recordatorioToEdit.aviso || '');
            }
        } else {
            setTipos({});
            setFecha('');
            setHora('');
            setAviso('3');
            setDescripcion('');
            setCustomAviso('');
        }
    }, [isOpen, recordatorioToEdit]);

    const handleTipoChange = (tipo) => {
        setTipos(prev => ({ ...prev, [tipo]: !prev[tipo] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const selectedTipos = Object.keys(tipos).filter(k => tipos[k]);
        if (selectedTipos.length === 0 || !fecha) {
            setError('El tipo de mantenimiento y la fecha son obligatorios.');
            return;
        }
        if (selectedTipos.includes('Otros') && !descripcion) {
            setError('Por favor, añade una descripción para "Otros", es obligatorio.');
            return;
        }
        if (aviso === 'custom' && !customAviso) {
            setError('Por favor, introduce un número de días para el aviso personalizado.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            const finalAviso = aviso === 'custom' ? customAviso : aviso;
            const recordatorioData = {
                furgonetaId: furgoneta.id,
                furgonetaMatricula: furgoneta.matricula.toUpperCase(),
                furgonetaNombre: furgoneta.nombre.toUpperCase(),
                tipos: selectedTipos.map(t => t.toUpperCase()),
                descripcion: descripcion.toUpperCase(),
                fecha,
                aviso: finalAviso,
                status: 'pending',
                updatedAt: new Date().toISOString(),
            };

            if (recordatorioToEdit) {
                const recordatorioRef = doc(db, getCollectionPath(user.uid, 'recordatorios_furgos'), recordatorioToEdit.id);
                await updateDoc(recordatorioRef, recordatorioData);
            } else {
                recordatorioData.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'recordatorios_furgos')), recordatorioData);
            }

            onRecordatorioSaved();
            onClose();
        } catch (err) {
            setError('Error al guardar el recordatorio. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    const isAnyTipoSelected = Object.values(tipos).some(value => value === true);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{recordatorioToEdit ? 'Editar' : 'Añadir Nuevo'} Recordatorio</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>
                    <p className="text-sm text-gray-600 mb-6">Establece una fecha y hora futuras para un recordatorio de mantenimiento.</p>

                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Mantenimiento</label>
                            <p className="text-xs text-gray-500 mb-2">Selecciona uno o varios tipos.</p>
                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2">
                                {MANTENIMIENTO_TIPOS_FURGOS.map(tipo => (
                                    <label key={tipo} className="flex items-center">
                                        <input type="checkbox" checked={!!tipos[tipo]} onChange={() => handleTipoChange(tipo)} className="h-4 w-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500" />
                                        <span className="ml-2 text-sm text-gray-700">{tipo}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                        {isAnyTipoSelected && (
                            <InputField
                                label={tipos['Otros'] ? 'Descripción (Obligatorio para "Otros") *' : 'Descripción (Opcional)'}
                                type="text"
                                value={descripcion}
                                onChange={e => setDescripcion(e.target.value)}
                                placeholder="Ej: Recordar comprar líquido de frenos..."
                                required={tipos['Otros']}
                            />
                        )}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <InputField label="Fecha" type="date" value={fecha} onChange={e => setFecha(e.target.value)} required />
                            <InputField label="Hora (Opcional)" type="time" value={hora} onChange={e => setHora(e.target.value)} />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Avisar con antelación</label>
                            <select value={aviso} onChange={e => setAviso(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="1">1 día antes</option>
                                <option value="3">3 días antes</option>
                                <option value="7">1 semana antes</option>
                                <option value="14">2 semanas antes</option>
                                <option value="30">1 mes antes</option>
                                <option value="custom">Personalizar</option>
                            </select>
                        </div>
                        {aviso === 'custom' && (
                            <InputField label="Días de aviso personalizados" type="number" value={customAviso} onChange={e => setCustomAviso(e.target.value)} validationType="numeric" placeholder="Ej: 5" required />
                        )}
                    </div>

                    {error && <p className="text-red-600 text-sm text-center mt-4">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-6">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// New Modal for adding/editing a Policy
const AddPolicyModal = ({ isOpen, onClose, onPolicySaved, furgonetaId, policyToEdit, user }) => {
    const [price, setPrice] = useState('');
    const [company, setCompany] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [policyNumber, setPolicyNumber] = useState(''); // New field
    const [companyPhone, setCompanyPhone] = useState(''); // New field
    const [cranePhone, setCranePhone] = useState('');     // New field
    const [policyFile, setPolicyFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (policyToEdit) {
            setPrice(policyToEdit.price || '');
            setCompany(policyToEdit.company || '');
            setDueDate(policyToEdit.dueDate || '');
            setPolicyNumber(policyToEdit.policyNumber || ''); // Set new fields
            setCompanyPhone(policyToEdit.companyPhone || '');
            setCranePhone(policyToEdit.cranePhone || '');
        } else {
            setPrice('');
            setCompany('');
            setDueDate('');
            setPolicyNumber(''); // Reset new fields
            setCompanyPhone('');
            setCranePhone('');
            setPolicyFile(null);
        }
    }, [policyToEdit, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!price || !company || !dueDate || (!policyToEdit && !policyFile)) {
            setError('Los campos Precio, Compañía, Vencimiento y el archivo de la póliza son obligatorios.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // --- CAMBIO DE SEGURIDAD SAAS ---
            const clientFolder = user.clientId || user.uid;
            // -------------------------------

            let fileUrl = policyToEdit?.fileUrl || '';
            if (policyFile) {
                // Guardamos dentro de la carpeta del cliente, organizado por ID de furgoneta
                const fileRef = ref(storage, `uploads/${clientFolder}/polizas_furgonetas/${furgonetaId}/${Date.now()}_${policyFile.name}`);
                await uploadBytes(fileRef, policyFile);
                fileUrl = await getDownloadURL(fileRef);
            }

            const policyData = {
                furgonetaId,
                price: price.toUpperCase(),
                company: company.toUpperCase(),
                dueDate,
                policyNumber: policyNumber.toUpperCase(),
                companyPhone: companyPhone.toUpperCase(),
                cranePhone: cranePhone.toUpperCase(),
                fileUrl,
                fileName: policyFile ? policyFile.name : policyToEdit?.fileName || '',
                fileType: policyFile ? policyFile.type : policyToEdit?.fileType || '',
                createdAt: new Date().toISOString(),
            };

            if (policyToEdit) {
                const policyRef = doc(db, getCollectionPath(user.uid, 'polizas_furgonetas'), policyToEdit.id);
                await updateDoc(policyRef, policyData);
            } else {
                await addDoc(collection(db, getCollectionPath(user.uid, 'polizas_furgonetas')), policyData);
            }

            onPolicySaved();
            onClose();
        } catch (err) {
            setError('Error al guardar la póliza. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-4">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{policyToEdit ? 'Editar Póliza' : 'Añadir Nueva Póliza'}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>
                    <p className="text-sm text-gray-600">Introduce los detalles de la póliza.</p>

                    <div className="space-y-4">
                        <InputField label="Precio (€) *" type="text" value={price} onChange={e => setPrice(e.target.value)} validationType="decimal" placeholder="Ej: 350.50" required />
                        <InputField label="Compañía *" type="text" value={company} onChange={e => setCompany(e.target.value)} placeholder="Ej: Mapfre" required />
                        <InputField label="Fecha de Vencimiento *" type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} required />
                        <InputField label="Nº Póliza (Opcional)" type="text" value={policyNumber} onChange={e => setPolicyNumber(e.target.value)} placeholder="Ej: ABC123456789" />
                        <InputField label="Teléfono Compañía (Opcional)" type="tel" value={companyPhone} onChange={e => setCompanyPhone(e.target.value)} validationType="numeric" placeholder="Ej: 912345678" />
                        <InputField label="Teléfono Grúa (Opcional)" type="tel" value={cranePhone} onChange={e => setCranePhone(e.target.value)} validationType="numeric" placeholder="Ej: 600123456" />
                        <FileInput label="Documento de Póliza *" file={policyFile} setFile={setPolicyFile} accept="application/pdf,image/*" helpText="Sube la póliza (PDF o imagen). (Max 5MB)" required={!policyToEdit} maxSizeMB={5} compress={true} setError={setError} />
                    </div>

                    {error && <p className="text-red-600 text-sm text-center">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar Póliza'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const InputField = ({ label, validationType, ...props }) => {
    const handleChange = (e) => {
        let value = e.target.value;
        if (validationType === 'numeric') {
            value = value.replace(/[^0-9]/g, '');
        } else if (validationType === 'textOnly') {
            value = value.replace(/[^a-zA-Z\s\u00C0-\u017F]/g, '');
        } else if (validationType === 'decimal') {
            value = value.replace(/[^0-9,.]/g, '').replace(',', '.');
        }
        // Convert to uppercase
        if (props.type !== 'date' && props.type !== 'time') { // Don't uppercase date/time inputs
            value = value.toUpperCase();
        }

        const newEvent = { ...e, target: { ...e.target, value } };
        props.onChange(newEvent);
    };

    return (
        <div>
            {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
            <input {...props} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500" />
        </div>
    );
};

const FileInput = ({ label, file, setFile, accept, helpText, required, maxSizeMB = 10, compress = false, setError }) => {
    const id = `file-upload-${label.replace(/\s+/g, '-')}`;

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
            <label htmlFor={id} className="cursor-pointer bg-white border border-gray-300 rounded-lg p-3 flex items-center justify-center text-sm text-gray-600 hover:bg-gray-50 w-full">
                <FileIcon />
                <span className="truncate">{file ? file.name : 'Seleccionar Archivo'}</span>
            </label>
            <input id={id} type="file" className="sr-only" onChange={(e) => handleFileProcessing(e, setFile, setError, { maxSizeMB, compress })} accept={accept} required={required} />
            {helpText && <p className="text-xs text-gray-500 mt-1">{helpText}</p>}
        </div>
    );
};


// --- COMPONENTES DE PÁGINAS ---

const FurgonetasPage = ({ onSelectItem, setCurrentPage, user }) => {
    const [furgonetas, setFurgonetas] = useState([]);
    const [recordatorios, setRecordatorios] = useState([]);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [furgonetaToEdit, setFurgonetaToEdit] = useState(null);
    const [isMantenimientoModalOpen, setIsMantenimientoModalOpen] = useState(false);
    const [isRecordatorioModalOpen, setIsRecordatorioModalOpen] = useState(false);
    const [furgonetaForAction, setFurgonetaForAction] = useState(null);
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [furgonetaToChangeStatus, setFurgonetaToChangeStatus] = useState(null);
    const [newStatus, setNewStatus] = useState('');

    useEffect(() => {
        const qFurgos = query(collection(db, getCollectionPath(user.uid, 'furgonetas')));
        const unsubFurgos = onSnapshot(qFurgos, (snapshot) => {
            let furgonetasData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            const extractNumber = (str) => {
                if (!str) return null;
                const match = str.match(/\d+/);
                return match ? parseInt(match[0], 10) : null;
            };

            furgonetasData.sort((a, b) => {
                const numA = extractNumber(a.nombreInterno);
                const numB = extractNumber(b.nombreInterno);

                if (numA !== null && numB !== null) {
                    return numA - numB;
                }
                if (numA !== null) return -1;
                if (numB !== null) return 1;

                if (a.nombreInterno && b.nombreInterno) {
                    return a.nombreInterno.localeCompare(b.nombreInterno);
                }

                return new Date(b.createdAt) - new Date(a.createdAt);
            });
            setFurgonetas(furgonetasData);
        });

        const qRecordatorios = query(collection(db, getCollectionPath(user.uid, 'recordatorios_furgos')));
        const unsubRecordatorios = onSnapshot(qRecordatorios, (snapshot) => {
            const recordatoriosData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setRecordatorios(recordatoriosData);
        });

        return () => {
            unsubFurgos();
            unsubRecordatorios();
        };
    }, [user.uid]);

    const handleOpenAddEditModal = (furgoneta = null) => {
        setFurgonetaToEdit(furgoneta);
        setIsAddModalOpen(true);
    };

    const handleCloseAddEditModal = () => {
        setFurgonetaToEdit(null);
        setIsAddModalOpen(false);
    };

    const handleOpenMantenimientoModal = (furgoneta) => {
        setFurgonetaForAction(furgoneta);
        setIsMantenimientoModalOpen(true);
    };

    const handleOpenRecordatorioModal = (furgoneta) => {
        setFurgonetaForAction(furgoneta);
        setIsRecordatorioModalOpen(true);
    };

    const getUrgentReminderCount = (furgonetaId) => {
        const now = new Date();
        const count = recordatorios.filter(r => {
            if (r.furgonetaId !== furgonetaId) return false;

            // Lógica para recordatorios manuales o recordatorios autogenerados que tienen un 'aviso'
            if (r.fecha && r.aviso) { // Asegúrate de que tienen fecha y días de aviso
                const reminderDate = parseISO(r.fecha);
                const avisoDays = parseInt(r.aviso, 10); // 'r.aviso' puede ser string
                const reminderThreshold = new Date(reminderDate);
                reminderThreshold.setDate(reminderDate.getDate() - avisoDays);

                // Si es un recordatorio manual o un autogenerado que entra en su ventana de aviso
                if (now >= reminderThreshold && now <= reminderDate) {
                    return true;
                }
            }

            // Lógica específica para recordatorios automáticos de ITV/Seguro que ya existen
            // y cuyo 'sourceEventId' indica que han sido autogenerados
            if (r.sourceEventId && (r.sourceEventId.startsWith('autogen-itv-') || r.sourceEventId.startsWith('autogen-seguro-'))) {
                const eventDate = parseISO(r.fecha); // Fecha de vencimiento de ITV/Seguro

                // Mostrar la campanita si estamos en el periodo de 2 meses antes del vencimiento
                // (Mismo umbral que usamos para CREAR el recordatorio autogenerado)
                const twoMonthsBeforeEvent = subMonths(eventDate, 2);

                if (isWithinInterval(now, { start: twoMonthsBeforeEvent, end: eventDate })) {
                    return true;
                }
            }

            return false; // No cumple ninguna condición para mostrar la campanita
        }).length;
        return count;
    };

    const handleStatusChangeClick = (furgoneta) => {
        setFurgonetaToChangeStatus(furgoneta);
        setNewStatus(furgoneta.estado); // Set current status as default
        setIsStatusModalOpen(true);
    };

    const handleConfirmStatusChange = async () => {
        if (furgonetaToChangeStatus && newStatus) {
            try {
                const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaToChangeStatus.id);
                await updateDoc(furgonetaRef, { estado: newStatus });
                setIsStatusModalOpen(false);
                setFurgonetaToChangeStatus(null);
                setNewStatus('');
            } catch (error) {
                console.error("Error updating furgoneta status:", error);
            }
        }
    };

    const getStatusClasses = (status) => {
        switch (status) {
            case 'ACTIVO':
                return 'bg-green-200 text-green-800';
            case 'EN TALLER':
                return 'bg-red-200 text-red-800';
            case 'DE BAJA':
                return 'bg-gray-200 text-gray-800';
            default:
                return 'bg-yellow-200 text-yellow-800';
        }
    };

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Mis Furgonetas</h2>
                <button onClick={() => handleOpenAddEditModal(null)} className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 flex items-center transition-transform transform hover:scale-105 w-full sm:w-auto justify-center">
                    <PlusCircleIcon /> Añadir Furgoneta
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {furgonetas.map(f => {
                    const reminderCount = getUrgentReminderCount(f.id);
                    return (
                        <div key={f.id} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow flex flex-col">
                            <div className="relative">
                                <img className="h-48 w-full object-cover" src={f.imageUrl || 'https://placehold.co/600x400/fed7aa/f97316?text=Furgoneta'} alt={`Furgoneta ${f.nombre}`} />
                                {reminderCount > 0 && (
                                    <button
                                        onClick={() => setCurrentPage('recordatorios_furgos')}
                                        className="absolute top-2 right-2 p-1 rounded-full bg-white bg-opacity-70 hover:bg-opacity-100 transition-opacity"
                                        title={`Tienes ${reminderCount} recordatorio(s) urgente(s)`}
                                    >
                                        <BellAlertIcon count={reminderCount} />
                                    </button>
                                )}
                            </div>

                            <div className="p-4 md:p-6 flex flex-col flex-grow">
                                <div className="flex justify-between items-start">
                                    <h3 className="text-lg md:text-xl font-bold text-gray-900">{f.nombreInterno || f.marcaModelo || 'Furgoneta sin nombre'}</h3>
                                    <div className="inline-flex items-baseline gap-1.5 bg-orange-200 text-orange-800 font-semibold px-2 py-1 rounded-full">
                                        <span className="text-xs opacity-80">Matrícula</span>
                                        <span className="text-sm">{f.matricula}</span>
                                    </div>
                                </div>
                                <p className="text-gray-600 mt-1 text-sm">{f.marcaModelo || 'Marca/Modelo no especificado'}</p>
                                {f.conductor && (
                                    <p className="text-gray-600 mt-1 text-sm">
                                        <span className="font-semibold">Conductora:</span> {f.conductor}
                                    </p>
                                )}
                                <div className="mt-4 space-y-2 text-sm text-gray-700 flex-grow">
                                    <p><span className="font-semibold">Plaza Garaje:</span> {f.plazaGaraje || 'N/A'}</p>
                                    <p>
                                        <span className="font-semibold">Estado:</span>
                                        <button
                                            onClick={() => handleStatusChangeClick(f)}
                                            className={`ml-2 px-2 py-1 rounded-md text-sm font-bold transition-colors ${getStatusClasses(f.estado)}`}
                                        >
                                            {f.estado || 'ACTIVO'}
                                        </button>
                                    </p>
                                    {f.latestPolicy && (
                                        <>
                                            <p><span className="font-semibold">Última Póliza:</span> {f.latestPolicy.company} ({f.latestPolicy.price}€)</p>
                                            <p className="text-xs text-gray-500">Vence: {format(parseISO(f.latestPolicy.dueDate), 'dd/MM/yyyy')}</p>
                                        </>
                                    )}
                                    <p className="text-xs text-red-500">ITV: {f.itvDueDate ? format(parseISO(f.itvDueDate), 'dd/MM/yyyy') : 'Sin fecha'}</p>
                                    {f.itvAppointmentDate && (
                                        <p className="text-xs text-blue-600 font-bold">
                                            CITA: {format(parseISO(f.itvAppointmentDate), 'dd/MM/yyyy')} {f.itvAppointmentTime}
                                        </p>
                                    )}

                                </div>
                                <div className="mt-6 grid grid-cols-1 gap-3">
                                    <button onClick={() => onSelectItem(f.id)} className="w-full bg-orange-500 text-white py-2 rounded-lg font-semibold hover:bg-orange-600 transition">Ver Detalles →</button>
                                    <div className="grid grid-cols-2 gap-3">
                                        <button onClick={() => handleOpenMantenimientoModal(f)} className="w-full bg-blue-500 text-white py-2 rounded-lg font-semibold hover:bg-blue-600 transition text-sm">Crear Mantenimiento</button>
                                        <button onClick={() => handleOpenRecordatorioModal(f)} className="w-full bg-red-500 text-white py-2 rounded-lg font-semibold hover:bg-red-600 transition text-sm">Crear Recordatorio</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {furgonetas.length === 0 && (
                <div className="text-center py-12 bg-gray-50 rounded-lg">
                    <p className="text-gray-500">No se han encontrado furgonetas.</p>
                    <p className="text-gray-500">Empieza añadiendo tu primera furgoneta.</p>
                </div>
            )}
            <AddFurgonetaModal
                isOpen={isAddModalOpen}
                onClose={handleCloseAddEditModal}
                onFurgonetaSaved={handleCloseAddEditModal}
                furgonetaToEdit={furgonetaToEdit}
                user={user}
            />
            <AddMantenimientoModal
                isOpen={isMantenimientoModalOpen}
                onClose={() => setIsMantenimientoModalOpen(false)}
                onMantenimientoSaved={() => setIsMantenimientoModalOpen(false)}
                furgoneta={furgonetaForAction}
                user={user}
            />
            <AddRecordatorioModal
                isOpen={isRecordatorioModalOpen}
                onClose={() => setIsRecordatorioModalOpen(false)}
                onRecordatorioSaved={() => setIsRecordatorioModalOpen(false)}
                furgoneta={furgonetaForAction}
                user={user}
            />
            <ConfirmationModal
                isOpen={isStatusModalOpen}
                onClose={() => setIsStatusModalOpen(false)}
                onConfirm={handleConfirmStatusChange}
                title="Cambiar Estado de Furgoneta"
                message={
                    <div className="flex flex-col gap-4">
                        <p>¿Estás seguro de que quieres cambiar el estado de la furgoneta <span className="font-bold">{furgonetaToChangeStatus?.nombre}</span>?</p>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Nuevo Estado:</label>
                            <select
                                value={newStatus}
                                onChange={(e) => setNewStatus(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white"
                            >
                                <option value="ACTIVO">ACTIVO</option>
                                <option value="EN TALLER">EN TALLER</option>
                                <option value="DE BAJA">DE BAJA</option>
                            </select>
                        </div>
                    </div>
                }
            />
        </div>
    );
};

const FurgonetaDetailPage = ({ furgonetaId, onBack, setLightboxContent, pageOptions, user }) => {
    const [furgoneta, setFurgoneta] = useState(null);
    const [mantenimientos, setMantenimientos] = useState([]);
    const [recordatorios, setRecordatorios] = useState([]);
    const [policies, setPolicies] = useState([]);
    const [activeTab, setActiveTab] = useState(pageOptions?.initialTab || 'mantenimiento');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [furgonetaToEdit, setFurgonetaToEdit] = useState(null);
    const [isMantenimientoModalOpen, setIsMantenimientoModalOpen] = useState(false);
    const [mantenimientoToEdit, setMantenimientoToEdit] = useState(null);
    const [isRecordatorioModalOpen, setIsRecordatorioModalOpen] = useState(false);
    const [recordatorioToEdit, setRecordatorioToEdit] = useState(null);
    const [recordatorioToComplete, setRecordatorioToComplete] = useState(null);
    const [isAddPolicyModalOpen, setIsAddPolicyModalOpen] = useState(false);
    const [policyToEdit, setPolicyToEdit] = useState(null);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [deleteType, setDeleteType] = useState('');
    const dropdownRef = useRef(null);
    const [isEditingComment, setIsEditingComment] = useState(false);
    const [editableComment, setEditableComment] = useState('');
    // Estados para la edición de la fecha de ITV
    const [isEditingItvDate, setIsEditingItvDate] = useState(false);
    const [editableItvDate, setEditableItvDate] = useState('');


    useEffect(() => {
        const unsubFurgoneta = onSnapshot(doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaId), (doc) => {
            setFurgoneta({ id: doc.id, ...doc.data() });
        });
        const qMantenimientos = query(collection(db, getCollectionPath(user.uid, 'mantenimientos_furgos')), where("furgonetaId", "==", furgonetaId));
        const unsubMantenimientos = onSnapshot(qMantenimientos, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
            setMantenimientos(data);
        });
        const qRecordatorios = query(collection(db, getCollectionPath(user.uid, 'recordatorios_furgos')), where("furgonetaId", "==", furgonetaId));
        const unsubRecordatorios = onSnapshot(qRecordatorios, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            data.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
            setRecordatorios(data);
        });
        const qPolicies = query(collection(db, getCollectionPath(user.uid, 'polizas_furgonetas')), where("furgonetaId", "==", furgonetaId));
        const unsubPolicies = onSnapshot(qPolicies, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            data.sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
            setPolicies(data);
            if (data.length > 0) {
                const latestPolicy = data[0];
                updateDoc(doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaId), {
                    latestPolicy: {
                        company: latestPolicy.company, price: latestPolicy.price, dueDate: latestPolicy.dueDate,
                        fileUrl: latestPolicy.fileUrl, policyNumber: latestPolicy.policyNumber,
                        companyPhone: latestPolicy.companyPhone, cranePhone: latestPolicy.cranePhone,
                    }
                });
            } else {
                updateDoc(doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaId), { latestPolicy: null });
            }
        });

        return () => {
            unsubFurgoneta(); unsubMantenimientos(); unsubRecordatorios(); unsubPolicies();
        };
    }, [furgonetaId, user.uid]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownRef]);

    const handleDelete = async () => {
        if (!itemToDelete) return;
        try {
            if (deleteType === 'furgoneta') {
                if (itemToDelete.imageUrl) {
                    await deleteObject(ref(storage, itemToDelete.imageUrl)).catch(e => console.warn("Error deleting image file:", e));
                }
                if (itemToDelete.fichaTecnicaUrl) {
                    await deleteObject(ref(storage, itemToDelete.fichaTecnicaUrl)).catch(e => console.warn("Error deleting ficha tecnica file:", e));
                }
                if (itemToDelete.permisoCirculacionUrl) {
                    await deleteObject(ref(storage, itemToDelete.permisoCirculacionUrl)).catch(e => console.warn("Error deleting permiso circulacion file:", e));
                }
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'furgonetas'), itemToDelete.id));
                onBack();
            } else if (deleteType === 'mantenimiento') {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'mantenimientos_furgos'), itemToDelete.id));
            } else if (deleteType === 'recordatorio') {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'recordatorios_furgos'), itemToDelete.id));
            } else if (deleteType === 'policy') {
                if (itemToDelete.fileUrl) {
                    const fileRef = ref(storage, itemToDelete.fileUrl);
                    await deleteObject(fileRef).catch(e => console.warn("Error deleting policy file from storage:", e));
                }
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'polizas_furgonetas'), itemToDelete.id));
            } else if (deleteType === 'ficha_tecnica') {
                if (itemToDelete.fichaTecnicaUrl) {
                    await deleteObject(ref(storage, itemToDelete.fichaTecnicaUrl)).catch(e => console.warn("Error deleting ficha tecnica file:", e));
                    const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), itemToDelete.id);
                    await updateDoc(furgonetaRef, { fichaTecnicaUrl: deleteField() });
                }
            } else if (deleteType === 'permiso_circulacion') {
                if (itemToDelete.permisoCirculacionUrl) {
                    await deleteObject(ref(storage, itemToDelete.permisoCirculacionUrl)).catch(e => console.warn("Error deleting permiso circulacion file:", e));
                    const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), itemToDelete.id);
                    await updateDoc(furgonetaRef, { permisoCirculacionUrl: deleteField() });
                }
            }
        } catch (error) {
            console.error("Error deleting document: ", error);
        } finally {
            setItemToDelete(null); setDeleteType('');
        }
    };

    const handleMarkReminderDone = (recordatorio) => {
        setRecordatorioToComplete(recordatorio); setIsMantenimientoModalOpen(true);
    };

    const handleOpenAddPolicyModal = (policy = null) => {
        setPolicyToEdit(policy); setIsAddPolicyModalOpen(true);
    };

    const handleCloseAddPolicyModal = () => {
        setPolicyToEdit(null); setIsAddPolicyModalOpen(false);
    };

    const handleSaveComment = async () => {
        if (!furgoneta) return;
        try {
            const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaId);
            await updateDoc(furgonetaRef, { comentarios: editableComment });
            setIsEditingComment(false);
        } catch (error) {
            console.error("Error updating comment: ", error);
        }
    };

    const handleSaveItvDate = async () => {
        if (!furgoneta || !editableItvDate) return;
        try {
            const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaId);
            await updateDoc(furgonetaRef, { itvDueDate: editableItvDate });
            setIsEditingItvDate(false);
        } catch (error) {
            console.error("Error updating ITV date: ", error);
        }
    };

    if (!furgoneta) {
        return <div className="text-center py-10">Cargando datos de la furgoneta...</div>;
    }

    const InfoItem = ({ icon, label, value }) => (
        <div>
            <div className="flex items-center">
                {icon}
                <span className="ml-2 text-sm text-gray-500">
                    {label === 'Conductora Habitual' ? (
                        <>
                            <span className="sm:hidden">Conductora</span>
                            <span className="hidden sm:inline">Conductora Habitual</span>
                        </>
                    ) : (
                        label
                    )}
                </span>
            </div>
            <p className="font-semibold text-gray-800 mt-1 break-words">{value || 'N/A'}</p>
        </div>
    );

    const getStatusClasses = (status) => {
        switch (status) {
            case 'ACTIVO': return 'bg-green-200 text-green-800';
            case 'EN TALLER': return 'bg-red-200 text-red-800';
            case 'DE BAJA': return 'bg-gray-200 text-gray-800';
            default: return 'bg-yellow-200 text-yellow-800';
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                <button onClick={onBack} className="flex items-center text-sm font-semibold text-gray-600 hover:text-gray-900">
                    <ChevronLeftIcon /> Volver a Furgonetas
                </button>
                <div className="relative" ref={dropdownRef}>
                    <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center bg-white shadow-sm border rounded-lg px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 w-full justify-center sm:w-auto">
                        Acciones <DotsVerticalIcon />
                    </button>
                    {isDropdownOpen && (
                        <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-xl z-20">
                            <a href="#" onClick={(e) => { e.preventDefault(); setFurgonetaToEdit(furgoneta); setIsAddModalOpen(true); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Editar Furgoneta</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); setIsMantenimientoModalOpen(true); setMantenimientoToEdit(null); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Añadir Mantenimiento</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); setIsRecordatorioModalOpen(true); setRecordatorioToEdit(null); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Añadir Recordatorio</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); handleOpenAddPolicyModal(); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Añadir Póliza</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); setItemToDelete(furgoneta); setDeleteType('furgoneta'); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-red-600 hover:bg-red-50">Eliminar Furgoneta</a>
                        </div>
                    )}
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-1 rounded-xl shadow-md overflow-hidden bg-gray-200 flex items-center justify-center">
                    <img
                        src={furgoneta.imageUrl || 'https://placehold.co/600x400/fed7aa/f97316?text=Furgoneta'}
                        alt={furgoneta.nombre}
                        className="w-full h-auto object-contain" // Quitamos max-h-96. La imagen define su altura.
                        style={{ maxHeight: 'calc(100vh - 200px)' }} // Opcional: Límite de altura para que no ocupe toda la pantalla en imágenes muy altas
                    />
                </div>

                <div className="lg:col-span-2 bg-white p-6 rounded-xl shadow-md">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                        <h2 className="text-2xl md:text-3xl font-bold text-gray-800">{furgoneta.nombreInterno || furgoneta.marcaModelo}</h2>
                        <div className="mt-2 sm:mt-0 flex items-baseline gap-2 bg-orange-200 text-orange-800 font-semibold px-3 py-1 rounded-full">
                            <span className="text-sm opacity-80">Matrícula</span>
                            <span className="text-base">{furgoneta.matricula}</span>
                        </div>
                    </div>
                    <p className="text-gray-500 mt-1">{furgoneta.marcaModelo}</p>

                    <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                        <InfoItem icon={<SpeedIcon />} label="Kilometraje Actual" value={`${furgoneta.kilometraje || '0'} KM`} />
                        <InfoItem icon={<UserIcon />} label="Conductora Habitual" value={furgoneta.conductor} />
                        <InfoItem icon={<GarageIcon />} label="Plaza de Garaje" value={furgoneta.plazaGaraje} />
                        <InfoItem icon={<BellIcon className="h-5 w-5 text-gray-500" />} label="Recordatorios Activos" value={recordatorios.length} />
                        <div>
                            <div className="flex items-center"><GarageIcon className="h-5 w-5 text-gray-500" /><span className="ml-2 text-sm text-gray-500">Estado</span></div>
                            <span className={`mt-1 inline-block px-2 py-1 rounded-md text-base font-bold ${getStatusClasses(furgoneta.estado)}`}>{furgoneta.estado}</span>
                        </div>
                        <div>
                            <div className="flex items-center">
                                <ShieldCheckIcon className="h-5 w-5 text-gray-500" />
                                <span className="ml-2 text-sm text-gray-500">Vencimiento ITV</span>
                                {!isEditingItvDate && (
                                    <button onClick={() => { setIsEditingItvDate(true); setEditableItvDate(furgoneta.itvDueDate || ''); }} className="ml-2 text-orange-600 hover:text-orange-900 p-1">
                                        <PencilIcon />
                                    </button>
                                )}
                            </div>
                            {isEditingItvDate ? (
                                <div className="mt-1 flex items-center gap-2">
                                    <input
                                        type="date"
                                        value={editableItvDate}
                                        onChange={e => setEditableItvDate(e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 text-sm"
                                    />
                                    <button onClick={handleSaveItvDate} className="p-2 bg-green-500 text-white rounded-lg hover:bg-green-600">
                                        <CheckIcon />
                                    </button>
                                </div>
                            ) : (
                                <p className="font-semibold text-gray-800 mt-1 break-words">{furgoneta.itvDueDate ? format(parseISO(furgoneta.itvDueDate), 'dd/MM/yyyy') : 'Sin fecha'}</p>
                            )}
                        </div>
                        {furgoneta.itvAppointmentDate && (
                            <div className="text-blue-600 font-bold">
                                <InfoItem icon={<CalendarIcon />} label="Cita ITV Agendada" value={`${format(parseISO(furgoneta.itvAppointmentDate), 'dd/MM/yyyy')} a las ${furgoneta.itvAppointmentTime}`} />
                            </div>
                        )}
                    </div>

                    <div className="mt-6">
                        <div className="flex justify-between items-center mb-2">
                            <label className="block text-sm font-bold text-gray-700">Comentarios</label>
                            {!isEditingComment && (<button onClick={() => { setIsEditingComment(true); setEditableComment(furgoneta.comentarios || ''); }} className="text-orange-600 hover:text-orange-900 p-1 flex items-center text-sm font-semibold"><PencilIcon /><span className="ml-1">Editar</span></button>)}
                        </div>
                        <textarea readOnly={!isEditingComment} value={isEditingComment ? editableComment : (furgoneta.comentarios || '')} onChange={(e) => setEditableComment(e.target.value)} className={`w-full p-3 border rounded-lg h-28 resize-none transition-colors ${isEditingComment ? 'bg-white border-orange-400 focus:ring-orange-500 focus:border-orange-500' : 'bg-gray-100 border-gray-200'}`} placeholder={isEditingComment ? "Escribe aquí..." : "No hay comentarios."} />
                        {isEditingComment && (
                            <div className="flex justify-end gap-2 mt-2">
                                <button onClick={() => setIsEditingComment(false)} className="px-4 py-1 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 text-sm font-semibold">Cancelar</button>
                                <button onClick={handleSaveComment} className="px-4 py-1 rounded-lg text-white bg-orange-500 hover:bg-orange-600 text-sm font-semibold">Guardar</button>
                            </div>
                        )}
                    </div>

                    <div className="mt-6 border-t pt-6">
                        <h3 className="text-xl font-bold text-gray-800 flex items-center mb-4"><ShieldCheckIcon /> Información del Seguro</h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                            <InfoItem icon={null} label="Compañía" value={furgoneta.latestPolicy?.company} />
                            <InfoItem icon={null} label="Nº Póliza" value={furgoneta.latestPolicy?.policyNumber} />
                            <InfoItem icon={null} label="Precio Anual" value={furgoneta.latestPolicy?.price ? `${Number(furgoneta.latestPolicy.price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : 'N/A'} />
                            <InfoItem icon={null} label="Teléfono Compañía" value={furgoneta.latestPolicy?.companyPhone} />
                            <InfoItem icon={null} label="Teléfono Grúa" value={furgoneta.latestPolicy?.cranePhone} />
                            <InfoItem icon={null} label="Vencimiento (Última Póliza)" value={furgoneta.latestPolicy?.dueDate ? format(parseISO(furgoneta.latestPolicy.dueDate), 'dd/MM/yyyy') : 'N/A'} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-md">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex flex-wrap gap-6 px-6">
                        <button onClick={() => setActiveTab('mantenimiento')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'mantenimiento' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>Mantenimiento</button>
                        <button onClick={() => setActiveTab('recordatorios')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'recordatorios' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>Recordatorios</button>
                        <button onClick={() => setActiveTab('historial_polizas')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'historial_polizas' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>
                            Historial Pólizas
                        </button>
                        <button onClick={() => setActiveTab('ficha_tecnica')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'ficha_tecnica' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>Ficha Técnica</button>
                        <button onClick={() => setActiveTab('permiso_circulacion')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'permiso_circulacion' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>Permiso Circulación</button>
                    </nav>
                </div>
                <div className="p-4 md:p-6">
                    {activeTab === 'mantenimiento' ? (
                        <div className="space-y-4">
                            {mantenimientos.length > 0 ? mantenimientos.map(m => (
                                <div key={m.id} className={`${(m.descripcion === 'ITV PASADA' || m.tipos.includes('ITV')) ? 'bg-blue-50 border-l-4 border-blue-400' : 'bg-gray-50'} p-4 rounded-lg flex flex-col sm:flex-row justify-between sm:items-center gap-4`}>
                                    <div className="flex-1">
                                        <p className="font-bold">{m.tipos.join(', ')}</p>
                                        <p className="text-sm text-gray-600">{format(new Date(m.fecha), 'dd MMMM yyyy', { locale: es })} • {m.tallerNombre}</p>
                                        {m.descripcion && <p className="text-sm text-gray-500 mt-1">{m.descripcion}</p>}
                                    </div>
                                    <div className="text-sm sm:text-right">
                                        <p className="font-semibold">{Number(m.coste).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                                        {m.kilometraje && <p className="text-gray-500">{m.kilometraje} KM</p>}
                                    </div>
                                    <div className="flex gap-2 self-end sm:self-center">
                                        {m.documentoUrl && (<a href={m.documentoUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 p-1" title="Ver/Descargar Factura"><FileIcon /></a>)}
                                        <button onClick={() => { setMantenimientoToEdit(m); setIsMantenimientoModalOpen(true); }} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                        <button onClick={() => { setItemToDelete(m); setDeleteType('mantenimiento'); }} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                    </div>
                                </div>
                            )) : <p className="text-center text-gray-500 py-8">El historial de mantenimientos aparecerá aquí.</p>}
                        </div>
                    ) : activeTab === 'recordatorios' ? (
                        <div className="space-y-4">
                            {recordatorios.length > 0 ? recordatorios.map(r => (
                                <div key={r.id} className="bg-gray-50 p-4 rounded-lg flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                                    <div className="flex-1">
                                        <p className="font-bold">{r.tipos.join(', ')}</p>
                                        <p className="text-sm text-gray-600">{format(new Date(r.fecha), 'dd MMMM yyyy', { locale: es })} {r.hora}</p>
                                        {r.descripcion && (
                                            <div className="mt-2">
                                                <p className="text-sm font-semibold text-gray-700">Descripción:</p>
                                                <p className="text-sm text-gray-600 whitespace-pre-wrap">{r.descripcion}</p>
                                            </div>
                                        )}
                                        <p className="text-xs text-gray-500 mt-2">Avisar {r.aviso} días antes</p>
                                    </div>
                                    <div className="flex gap-2 self-end sm:self-center">
                                        <button onClick={() => handleMarkReminderDone(r)} className="bg-green-500 text-white text-xs font-bold py-1 px-2 rounded-md hover:bg-green-600 transition-colors">Hecho</button>
                                        <button onClick={() => { setRecordatorioToEdit(r); setIsRecordatorioModalOpen(true); }} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                        <button onClick={() => { setItemToDelete(r); setDeleteType('recordatorio'); }} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                    </div>
                                </div>
                            )) : <p className="text-center text-gray-500 py-8">El historial de recordatorios aparecerá aquí.</p>}
                        </div>
                    ) : activeTab === 'historial_polizas' ? (
                        <div className="space-y-4">
                            <button onClick={() => handleOpenAddPolicyModal()} className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-600 flex items-center transition-transform transform hover:scale-105 mb-4">
                                <PlusCircleIcon /> Añadir Póliza
                            </button>
                            {policies.length > 0 ? policies.map(policy => (
                                <div key={policy.id} className="bg-gray-50 p-4 rounded-lg flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                                    <div className="flex-1">
                                        <p className="font-bold">{policy.company}</p>
                                        <p className="text-sm text-gray-600">Vencimiento: {format(parseISO(policy.dueDate), 'dd MMMM yyyy', { locale: es })}</p>
                                        {policy.policyNumber && <p className="text-xs text-gray-500">Nº Póliza: {policy.policyNumber}</p>}
                                        {policy.companyPhone && <p className="text-xs text-gray-500">Teléfono Compañía: {policy.companyPhone}</p>}
                                        {policy.cranePhone && <p className="text-xs text-gray-500">Teléfono Grúa: {policy.cranePhone}</p>}
                                    </div>
                                    <div className="text-sm sm:text-right">
                                        <p className="font-semibold">{Number(policy.price).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                                    </div>
                                    <div className="flex gap-2 self-end sm:self-center">
                                        {policy.fileUrl && (<a href={policy.fileUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 p-1" title="Ver/Descargar Póliza"><FileIcon /></a>)}
                                        <button onClick={() => { setPolicyToEdit(policy); handleOpenAddPolicyModal(policy); }} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                        <button onClick={() => { setItemToDelete(policy); setDeleteType('policy'); }} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                    </div>
                                </div>
                            )) : <p className="text-center text-gray-500 py-8">El historial de pólizas aparecerá aquí.</p>}
                        </div>
                    ) : activeTab === 'ficha_tecnica' ? (
                        <div>
                            {furgoneta.fichaTecnicaUrl ? (
                                <div className="flex items-center gap-4">
                                    <a href={furgoneta.fichaTecnicaUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-blue-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-600">
                                        Abrir / Descargar
                                    </a>
                                    <button onClick={() => { setItemToDelete(furgoneta); setDeleteType('ficha_tecnica'); }} className="bg-red-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-red-700 flex items-center gap-2">
                                        <TrashIcon /> Borrar
                                    </button>
                                </div>
                            ) : (
                                <p className="text-center text-gray-500 py-8">No se ha subido la ficha técnica.</p>
                            )}
                        </div>
                    ) : activeTab === 'permiso_circulacion' ? (
                        <div>
                            {furgoneta.permisoCirculacionUrl ? (
                                <div className="flex items-center gap-4">
                                    <a href={furgoneta.permisoCirculacionUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-blue-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-600">
                                        Abrir / Descargar
                                    </a>
                                    <button onClick={() => { setItemToDelete(furgoneta); setDeleteType('permiso_circulacion'); }} className="bg-red-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-red-700 flex items-center gap-2">
                                        <TrashIcon /> Borrar
                                    </button>
                                </div>
                            ) : (<p className="text-center text-gray-500 py-8">No se ha subido el permiso de circulación.</p>)}
                        </div>
                    ) : null}
                </div>
            </div>

            <AddFurgonetaModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onFurgonetaSaved={() => setIsAddModalOpen(false)} furgonetaToEdit={furgonetaToEdit} user={user} />
            <AddMantenimientoModal isOpen={isMantenimientoModalOpen} onClose={() => { setIsMantenimientoModalOpen(false); setRecordatorioToComplete(null); setMantenimientoToEdit(null); }} onMantenimientoSaved={() => { setIsMantenimientoModalOpen(false); setRecordatorioToComplete(null); setMantenimientoToEdit(null); }} furgoneta={furgoneta} fromRecordatorio={recordatorioToComplete} mantenimientoToEdit={mantenimientoToEdit} user={user} />
            <AddRecordatorioModal isOpen={isRecordatorioModalOpen} onClose={() => { setIsRecordatorioModalOpen(false); setRecordatorioToEdit(null) }} onRecordatorioSaved={() => { setIsRecordatorioModalOpen(false); setRecordatorioToEdit(null); }} furgoneta={furgoneta} recordatorioToEdit={recordatorioToEdit} user={user} />
            <AddPolicyModal isOpen={isAddPolicyModalOpen} onClose={handleCloseAddPolicyModal} onPolicySaved={handleCloseAddPolicyModal} furgonetaId={furgonetaId} policyToEdit={policyToEdit} user={user} />
            <ConfirmationModal isOpen={!!itemToDelete} onClose={() => setItemToDelete(null)} onConfirm={handleDelete} title="Confirmar Borrado" message="¿Estás seguro de que quieres borrar este registro? Esta acción no se puede deshacer." />
        </div>
    );
};

const TalleresPage = ({ onSelectItem, user }) => {
    const [talleres, setTalleres] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tallerToEdit, setTallerToEdit] = useState(null);
    const [tallerToDelete, setTallerToDelete] = useState(null);

    useEffect(() => {
        const q = query(collection(db, getCollectionPath(user.uid, 'talleres')));
        const unsub = onSnapshot(q, (snapshot) => {
            const talleresData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            talleresData.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
            setTalleres(talleresData);
        });
        return () => unsub();
    }, [user.uid]);

    const handleOpenModal = (taller = null) => {
        setTallerToEdit(taller);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setTallerToEdit(null);
        setIsModalOpen(false);
    };

    const handleDelete = async () => {
        if (tallerToDelete) {
            await deleteDoc(doc(db, getCollectionPath(user.uid, 'talleres'), tallerToDelete.id));
            setTallerToDelete(null);
        }
    };

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Talleres</h2>
                <button onClick={() => handleOpenModal()} className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 flex items-center transition-transform transform hover:scale-105 w-full sm:w-auto justify-center">
                    <PlusCircleIcon /> Añadir Taller
                </button>
            </div>

            <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <div className="hidden md:block">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contacto</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ubicación</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {talleres.map(taller => (
                                <tr key={taller.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm font-semibold text-gray-900">{taller.nombre}</div>
                                        <div className="text-sm text-gray-500">{taller.propietario}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-gray-900">{taller.telefono}</div>
                                        <div className="text-sm text-gray-500">{taller.email}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-gray-900">{taller.direccion}</div>
                                        <div className="text-sm text-gray-500">{taller.localidad}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                        <button onClick={() => handleOpenModal(taller)} className="text-orange-600 hover:text-orange-900 p-2"><PencilIcon /></button>
                                        <button onClick={() => setTallerToDelete(taller)} className="text-red-600 hover:text-red-900 p-2 ml-2"><TrashIcon /></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="md:hidden space-y-4 p-4">
                    {talleres.map(taller => (
                        <div key={taller.id} className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="font-bold text-gray-900">{taller.nombre}</p>
                                    <p className="text-sm text-gray-600">{taller.propietario}</p>
                                </div>
                                <div className="flex gap-2">
                                    <button onClick={() => handleOpenModal(taller)} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                    <button onClick={() => setTallerToDelete(taller)} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                </div>
                            </div>
                            <div className="mt-2 text-sm text-gray-700 space-y-1">
                                <p>{taller.telefono}</p>
                                <p>{taller.email}</p>
                                <p>{taller.direccion}, {taller.localidad}</p>
                            </div>
                        </div>
                    ))}
                </div>
                {talleres.length === 0 && (
                    <div className="text-center py-12">
                        <p className="text-gray-500">No se han encontrado talleres.</p>
                    </div>
                )}
            </div>

            <AddTallerModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onTallerSaved={handleCloseModal}
                tallerToEdit={tallerToEdit}
                user={user}
            />
            <ConfirmationModal
                isOpen={!!tallerToDelete}
                onClose={() => setTallerToDelete(null)}
                onConfirm={handleDelete}
                title="Confirmar Borrado"
                message={`¿Estás seguro de que quieres borrar el taller "${tallerToDelete?.nombre}"? Esta acción no se puede deshacer.`}
            />
        </div>
    );
};

const EquiposPage = ({ onSelectItem, setCurrentPage, user, pageOptions }) => {
    const [equipos, setEquipos] = useState([]);
    const [recordatorios, setRecordatorios] = useState([]);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [equipoToEdit, setEquipoToEdit] = useState(null);
    const [isMantenimientoModalOpen, setIsMantenimientoModalOpen] = useState(false);
    const [isRecordatorioModalOpen, setIsRecordatorioModalOpen] = useState(false);
    const [equipoForAction, setEquipoForAction] = useState(null);
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [equipoToChangeStatus, setEquipoToChangeStatus] = useState(null);
    const [newStatus, setNewStatus] = useState('');

    // Efecto para manejar la apertura del modal desde fuera del componente
    useEffect(() => {
        if (pageOptions?.openAddModal) {
            handleOpenAddEditModal();
        }
    }, [pageOptions]);

    useEffect(() => {
        const qEquipos = query(collection(db, getCollectionPath(user.uid, 'equipos')));
        const unsubEquipos = onSnapshot(qEquipos, (snapshot) => {
            let equiposData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            const extractNumber = (str) => {
                if (!str) return null;
                const match = str.match(/\d+/);
                return match ? parseInt(match[0], 10) : null;
            };

            equiposData.sort((a, b) => {
                const numA = extractNumber(a.numero);
                const numB = extractNumber(b.numero);

                if (numA !== null && numB !== null) {
                    return numA - numB;
                }
                if (numA !== null) return -1;
                if (numB !== null) return 1;

                if (a.numero && b.numero) {
                    return a.numero.localeCompare(b.numero);
                }
                return new Date(b.createdAt) - new Date(a.createdAt);
            });
            setEquipos(equiposData);
        });

        const qRecordatorios = query(collection(db, getCollectionPath(user.uid, 'recordatorios_equipos')));
        const unsubRecordatorios = onSnapshot(qRecordatorios, (snapshot) => {
            const recordatoriosData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setRecordatorios(recordatoriosData);
        });

        return () => {
            unsubEquipos();
            unsubRecordatorios();
        };
    }, [user.uid]);

    const handleOpenAddEditModal = (equipo = null) => {
        setEquipoToEdit(equipo);
        setIsAddModalOpen(true);
    };

    const handleOpenMantenimientoModal = (equipo) => {
        setEquipoForAction(equipo);
        setIsMantenimientoModalOpen(true);
    };

    const handleOpenRecordatorioModal = (equipo) => {
        setEquipoForAction(equipo);
        setIsRecordatorioModalOpen(true);
    };

    const getUrgentReminderCount = (equipoId) => {
        const now = new Date();
        const count = recordatorios.filter(r => {
            if (r.laserId !== equipoId || !r.fecha) return false;
            const reminderDate = parseISO(r.fecha);
            const avisoDays = parseInt(r.aviso, 10);
            const reminderThreshold = new Date(reminderDate);
            reminderThreshold.setDate(reminderDate.getDate() - avisoDays);

            return now >= reminderThreshold && now <= reminderDate;
        }).length;
        return count;
    };

    const handleStatusChangeClick = (equipo) => {
        setEquipoToChangeStatus(equipo);
        setNewStatus(equipo.estado || 'ACTIVO');
        setIsStatusModalOpen(true);
    };

    const handleConfirmStatusChange = async () => {
        if (equipoToChangeStatus && newStatus) {
            try {
                const equipoRef = doc(db, getCollectionPath(user.uid, 'equipos'), equipoToChangeStatus.id);
                await updateDoc(equipoRef, { estado: newStatus.toUpperCase() });
                setIsStatusModalOpen(false);
                setEquipoToChangeStatus(null);
                setNewStatus('');
            } catch (error) {
                console.error("Error updating laser status:", error);
            }
        }
    };

    const getStatusClasses = (status) => {
        switch (status) {
            case 'ACTIVO': return 'bg-green-200 text-green-800';
            case 'REPARACIÓN': return 'bg-red-200 text-red-800';
            default: return 'bg-gray-200 text-gray-800';
        }
    };

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Mis Equipos</h2>
                <button onClick={() => handleOpenAddEditModal()} className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 flex items-center transition-transform transform hover:scale-105 w-full sm:w-auto justify-center">
                    <PlusCircleIcon /> Añadir Equipo
                </button>
            </div>
            {equipos.length === 0 ? (
                <div className="text-center py-12 bg-gray-50 rounded-lg">
                    <p className="text-gray-500">No se han encontrado equipos.</p>
                    <p className="text-gray-500 mt-1">Empieza añadiendo tu primer equipo.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {equipos.map(l => {
                        const reminderCount = getUrgentReminderCount(l.id);
                        return (
                            <div key={l.id} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow flex flex-col">
                                <div className="relative">
                                    <img className="h-48 w-full object-cover" src={l.imageUrl || 'https://placehold.co/600x400/fed7aa/f97316?text=Equipo'} alt={`Equipo ${l.marca}`} />
                                    {reminderCount > 0 && (
                                        <button
                                            onClick={() => setCurrentPage('recordatorios_equipos')}
                                            className="absolute top-2 right-2 p-1 rounded-full bg-white bg-opacity-70 hover:bg-opacity-100 transition-opacity"
                                            title={`Tienes ${reminderCount} recordatorio(s) urgente(s)`}
                                        >
                                            <BellAlertIcon count={reminderCount} />
                                        </button>
                                    )}
                                </div>
                                <div className="p-4 md:p-6 flex flex-col flex-grow">
                                    <h3 className="text-lg md:text-xl font-bold text-gray-900">EQUIPO Nº {l.numero}</h3>
                                    <p className="text-gray-600 mt-1">{l.marca} {l.modelo}</p>
                                    <div className="mt-4 space-y-2 text-sm text-gray-700 flex-grow">
                                        <p><span className="font-semibold">Nº Serie:</span> {l.numeroSerie || 'N/A'}</p>
                                        <p><span className="font-semibold">Comprado:</span> {l.fechaCompra ? format(parseISO(l.fechaCompra), 'dd/MM/yyyy') : 'N/A'}</p>
                                        <p>
                                            <span className="font-semibold">Estado:</span>
                                            <button
                                                onClick={() => handleStatusChangeClick(l)}
                                                className={`ml-2 px-2 py-1 rounded-md text-sm font-bold transition-colors ${getStatusClasses(l.estado)}`}
                                            >
                                                {l.estado || 'ACTIVO'}
                                            </button>
                                        </p>
                                    </div>
                                    <div className="mt-6 grid grid-cols-1 gap-3">
                                        <button onClick={() => onSelectItem(l.id)} className="w-full bg-orange-500 text-white py-2 rounded-lg font-semibold hover:bg-orange-600 transition">Ver Detalles →</button>
                                        <div className="grid grid-cols-2 gap-3">
                                            <button onClick={() => handleOpenMantenimientoModal(l)} className="w-full bg-blue-500 text-white py-2 rounded-lg font-semibold hover:bg-blue-600 transition text-sm">Crear Mantenimiento</button>
                                            <button onClick={() => handleOpenRecordatorioModal(l)} className="w-full bg-red-500 text-white py-2 rounded-lg font-semibold hover:bg-red-600 transition text-sm">Crear Recordatorio</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            <AddEquipoModal
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                onLaserSaved={() => setIsAddModalOpen(false)}
                laserToEdit={equipoToEdit}
                user={user}
            />
            <AddMantenimientoEquipoModal
                isOpen={isMantenimientoModalOpen}
                onClose={() => setIsMantenimientoModalOpen(false)}
                onMantenimientoSaved={() => setIsMantenimientoModalOpen(false)}
                laser={equipoForAction}
                user={user}
            />
            <AddRecordatorioEquipoModal
                isOpen={isRecordatorioModalOpen}
                onClose={() => setIsRecordatorioModalOpen(false)}
                onRecordatorioSaved={() => setIsRecordatorioModalOpen(false)}
                laser={equipoForAction}
                user={user}
            />
            <ConfirmationModal
                isOpen={isStatusModalOpen}
                onClose={() => setIsStatusModalOpen(false)}
                onConfirm={handleConfirmStatusChange}
                title="Cambiar Estado del Equipo"
                message={
                    <div className="flex flex-col gap-4">
                        <p>¿Estás seguro de que quieres cambiar el estado del equipo <strong>{equipoToChangeStatus?.marca} {equipoToChangeStatus?.modelo}</strong>?</p>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Nuevo Estado:</label>
                            <select
                                value={newStatus}
                                onChange={(e) => setNewStatus(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white"
                            >
                                <option value="ACTIVO">ACTIVO</option>
                                <option value="REPARACIÓN">REPARACIÓN</option>
                            </select>
                        </div>
                    </div>
                }
            />
        </div>
    );
};

const AddEquipoModal = ({ isOpen, onClose, onLaserSaved, laserToEdit, user }) => {
    const [numero, setNumero] = useState('');
    const [marca, setMarca] = useState('');
    const [modelo, setModelo] = useState('');
    const [fechaCompra, setFechaCompra] = useState('');
    const [numeroSerie, setNumeroSerie] = useState('');
    const [estado, setEstado] = useState('ACTIVO'); // Nuevo estado
    const [imagenFile, setImagenFile] = useState(null);
    const [serieFile, setSerieFile] = useState(null);
    const [contratoFile, setContratoFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (laserToEdit) {
            setNumero(laserToEdit.numero || '');
            setMarca(laserToEdit.marca || '');
            setModelo(laserToEdit.modelo || '');
            setFechaCompra(laserToEdit.fechaCompra || '');
            setNumeroSerie(laserToEdit.numeroSerie || '');
            setEstado(laserToEdit.estado || 'ACTIVO');
        } else {
            setNumero(''); setMarca(''); setModelo('');
            setEstado('ACTIVO');
        }
        setImagenFile(null);
        setSerieFile(null);
        setContratoFile(null);
    }, [laserToEdit, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!marca || !fechaCompra) {
            setError('Los campos con * son obligatorios.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // --- CAMBIO DE SEGURIDAD SAAS ---
            const clientFolder = user.clientId || user.uid;
            // -------------------------------

            let imageUrl = laserToEdit?.imageUrl || '';
            let serieUrl = laserToEdit?.serieUrl || '';
            let contratoUrl = laserToEdit?.contratoUrl || '';
            let contratoFileName = laserToEdit?.contratoFileName || '';

            if (imagenFile) {
                const imageRef = ref(storage, `uploads/${clientFolder}/laseres_imagenes/${Date.now()}_${imagenFile.name}`);
                await uploadBytes(imageRef, imagenFile);
                imageUrl = await getDownloadURL(imageRef);
            }

            if (serieFile) {
                const serieRef = ref(storage, `uploads/${clientFolder}/laseres_series/${Date.now()}_${serieFile.name}`);
                await uploadBytes(serieRef, serieFile);
                serieUrl = await getDownloadURL(serieRef);
            }

            if (contratoFile) {
                const contratoRef = ref(storage, `uploads/${clientFolder}/laseres_contratos/${Date.now()}_${contratoFile.name}`);
                await uploadBytes(contratoRef, contratoFile);
                contratoUrl = await getDownloadURL(contratoRef);
                contratoFileName = contratoFile.name;
            }

            const laserData = {
                numero: numero.toUpperCase(),
                marca: marca.toUpperCase(),
                modelo: modelo.toUpperCase(),
                fechaCompra,
                numeroSerie: numeroSerie.toUpperCase(),
                imageUrl,
                estado: estado.toUpperCase(),
                serieUrl,
                contratoUrl,
                contratoFileName,
                updatedAt: new Date().toISOString()
            };

            if (laserToEdit) {
                const laserRef = doc(db, getCollectionPath(user.uid, 'equipos'), laserToEdit.id);
                await updateDoc(laserRef, laserData);
            } else {
                laserData.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'equipos')), laserData);
            }

            onLaserSaved();
            onClose();
        } catch (err) {
            setError('Error al guardar el láser. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{laserToEdit ? 'Editar Equipo' : 'Añadir Nuevo Equipo'}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800">
                            <XIcon />
                        </button>
                    </div>
                    <p className="text-sm text-gray-600">Introduce los detalles del equipo. Los campos con * son obligatorios.</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField label="Número de Equipo" value={numero} onChange={(e) => setNumero(e.target.value)} placeholder="e.g., 01" />
                        <InputField label="Marca *" value={marca} onChange={(e) => setMarca(e.target.value)} placeholder="e.g., Milesman" required />
                        <InputField label="Modelo" value={modelo} onChange={(e) => setModelo(e.target.value)} placeholder="e.g., Premium" />
                        <InputField label="Número de Serie" value={numeroSerie} onChange={(e) => setNumeroSerie(e.target.value)} placeholder="e.g., SN123456" />
                        <InputField label="Fecha de Compra *" type="date" value={fechaCompra} onChange={e => setFechaCompra(e.target.value)} required />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                            <select value={estado} onChange={e => setEstado(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option>ACTIVO</option>
                                <option>REPARACIÓN</option>
                            </select>
                        </div>
                    </div>
                    <hr className="border-orange-200" />
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Archivos (Opcional)</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <FileInput
                                label="Imagen del Equipo"
                                file={imagenFile}
                                setFile={setImagenFile}
                                accept="image/*"
                                helpText="Sube una foto del equipo. (Max 5MB)"
                                maxSizeMB={5}
                                compress={true}
                                setError={setError}
                            />
                            <FileInput
                                label="Foto del Nº de Serie"
                                file={serieFile}
                                setFile={setSerieFile}
                                accept="image/*"
                                helpText="Sube una foto de la placa del nº de serie. (Max 5MB)"
                                maxSizeMB={5}
                                compress={true}
                                setError={setError}
                            />
                            <FileInput
                                label="Contrato (PDF)"
                                file={contratoFile}
                                setFile={setContratoFile}
                                accept="application/pdf"
                                helpText="Sube el contrato de compra/renting. (Max 5MB)"
                                maxSizeMB={5}
                                setError={setError}
                            />
                        </div>
                    </div>

                    {error && <p className="text-red-600 text-sm text-center">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 font-semibold">
                            Cancelar
                        </button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : (laserToEdit ? 'Guardar Cambios' : 'Añadir Equipo')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const EquipoDetailPage = ({ laserId, onBack, setCurrentPage, pageOptions, user }) => {
    const [laser, setLaser] = useState(null);
    const [mantenimientos, setMantenimientos] = useState([]);
    const [recordatorios, setRecordatorios] = useState([]);
    const [activeTab, setActiveTab] = useState(pageOptions?.initialTab || 'mantenimiento');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [equipoToEdit, setEquipoToEdit] = useState(null);
    const [isMantenimientoModalOpen, setIsMantenimientoModalOpen] = useState(false);
    const [mantenimientoToEdit, setMantenimientoToEdit] = useState(null);
    const [isRecordatorioModalOpen, setIsRecordatorioModalOpen] = useState(false);
    const [recordatorioToEdit, setRecordatorioToEdit] = useState(null);
    const [recordatorioToComplete, setRecordatorioToComplete] = useState(null); // New state for completing laser reminder
    const [itemToDelete, setItemToDelete] = useState(null);
    const [deleteType, setDeleteType] = useState('');
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const [passwordInput, setPasswordInput] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const dropdownRef = useRef(null);
    // New state for comment editing
    const [isEditingComment, setIsEditingComment] = useState(false);
    const [editableComment, setEditableComment] = useState('');
    // State for password-protected actions on revisions
    const [isRevisionPasswordPromptOpen, setIsRevisionPasswordPromptOpen] = useState(false);
    const [revisionForPasswordAction, setRevisionForPasswordAction] = useState({ item: null, action: '' });

    useEffect(() => {
        const unsubLaser = onSnapshot(doc(db, getCollectionPath(user.uid, 'equipos'), laserId), (doc) => {
            setLaser({ id: doc.id, ...doc.data() });
        });
        const qMantenimientos = query(collection(db, getCollectionPath(user.uid, 'mantenimientos_equipos')), where("laserId", "==", laserId));
        const unsubMantenimientos = onSnapshot(qMantenimientos, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
            setMantenimientos(data);
        });
        const qRecordatorios = query(collection(db, getCollectionPath(user.uid, 'recordatorios_equipos')), where("laserId", "==", laserId));
        const unsubRecordatorios = onSnapshot(qRecordatorios, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            data.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
            setRecordatorios(data);
        });

        return () => {
            unsubLaser();
            unsubMantenimientos();
            unsubRecordatorios();
        };
    }, [laserId, user.uid]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownRef]);

    const handleDelete = async () => {
        if (!itemToDelete) return;
        try {
            if (deleteType === 'laser') {
                // Delete associated files from Storage
                if (itemToDelete.imageUrl) {
                    try { // eslint-disable-next-line
                        await deleteObject(ref(storage, itemToDelete.imageUrl));
                    } catch (e) { console.warn("Could not delete image file:", e); }
                }
                if (itemToDelete.serieUrl) {
                    try { // eslint-disable-next-line
                        await deleteObject(ref(storage, itemToDelete.serieUrl));
                    } catch (e) { console.warn("Could not delete serie file:", e); }
                }
                if (itemToDelete.contratoUrl) {
                    try { // eslint-disable-next-line
                        await deleteObject(ref(storage, itemToDelete.contratoUrl));
                    } catch (e) { console.warn("Could not delete contrato file:", e); }
                }

                await deleteDoc(doc(db, getCollectionPath(user.uid, 'equipos'), itemToDelete.id));
                onBack();
            } else if (deleteType === 'mantenimiento') {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'mantenimientos_equipos'), itemToDelete.id));
            } else if (deleteType === 'recordatorio') {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'recordatorios_equipos'), itemToDelete.id));
            }
        } catch (error) {
            console.error("Error deleting document: ", error);
        } finally {
            setItemToDelete(null);
            setDeleteType('');
        }
    };

    const handleConfirmPasswordAction = async () => {
        if (passwordInput !== '49913') {
            setPasswordError('Contraseña incorrecta.');
            return;
        }

        const { item, action } = revisionForPasswordAction;

        if (action === 'delete') {
            try {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'mantenimientos_equipos'), item.id));
            } catch (error) {
                console.error("Error deleting revision:", error);
            }
        } else if (action === 'edit') {
            // Open the edit modal for this item
            setMantenimientoToEdit(item);
            setIsMantenimientoModalOpen(true);
        }

        // Close and reset everything
        setIsRevisionPasswordPromptOpen(false);
        setRevisionForPasswordAction({ item: null, action: '' });
        setPasswordInput('');
        setPasswordError('');
    };

    const handleMarkReminderDoneLaser = (recordatorio) => {
        setRecordatorioToComplete(recordatorio);
        setIsMantenimientoModalOpen(true);
    };

    const CORRECT_CONTRACT_PASSWORD = '49913';

    const handleViewContractClick = () => {
        setIsPasswordModalOpen(true);
        setPasswordInput('');
        setPasswordError('');
    };

    const handleContractPasswordSubmit = () => {
        if (passwordInput === CORRECT_CONTRACT_PASSWORD) {
            window.open(laser.contratoUrl, '_blank');
            setIsPasswordModalOpen(false);
        } else {
            setPasswordError('Contraseña incorrecta.');
        }
    };

    const handleSaveLaserComment = async () => {
        if (!laser) return;
        try {
            const laserRef = doc(db, getCollectionPath(user.uid, 'equipos'), laserId);
            await updateDoc(laserRef, {
                comentarios: editableComment
            });
            setIsEditingComment(false);
        } catch (error) {
            console.error("Error updating laser comment: ", error);
            // Optionally, show an error message to the user
        }
    };

    if (!laser) {
        return <div className="text-center py-10">Cargando datos del equipo...</div>;
    }

    const revisionesAnuales = mantenimientos.filter(m => m.tipo?.toUpperCase() === 'REVISIÓN ANUAL');
    const otrosMantenimientos = mantenimientos.filter(m => m.tipo?.toUpperCase() !== 'REVISIÓN ANUAL');

    const InfoItem = ({ label, value }) => (
        <div>
            <p className="text-sm text-gray-500">{label}</p>
            <p className="font-semibold text-gray-800 mt-1 break-words">{value || 'N/A'}</p>
        </div>
    );

    const getStatusClasses = (status) => {
        switch (status) {
            case 'ACTIVO':
                return 'bg-green-200 text-green-800';
            case 'REPARACIÓN':
                return 'bg-red-200 text-red-800';
            default:
                return 'bg-gray-200 text-gray-800';
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                <button onClick={onBack} className="flex items-center text-sm font-semibold text-gray-600 hover:text-gray-900">
                    <ChevronLeftIcon />
                    Volver a Equipos
                </button>
                <div className="relative" ref={dropdownRef}>
                    <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center bg-white shadow-sm border rounded-lg px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 w-full justify-center sm:w-auto">
                        Acciones
                        <DotsVerticalIcon />
                    </button>
                    {isDropdownOpen && (
                        <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-xl z-20">
                            <a href="#" onClick={(e) => { e.preventDefault(); setEquipoToEdit(laser); setIsAddModalOpen(true); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Editar Equipo</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); setIsMantenimientoModalOpen(true); setMantenimientoToEdit(null); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Añadir Mantenimiento</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); setIsRecordatorioModalOpen(true); setRecordatorioToEdit(null); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Añadir Recordatorio</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); setItemToDelete(laser); setDeleteType('laser'); setIsDropdownOpen(false); }} className="block px-4 py-2 text-sm text-red-600 hover:bg-red-50">Eliminar Equipo</a>
                        </div>
                    )}

                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-1">
                    <img src={laser.imageUrl || 'https://placehold.co/600x400/fed7aa/f97316?text=Equipo'} alt={`${laser.marca} ${laser.modelo}`} className="w-full h-auto object-cover rounded-xl shadow-md" />
                </div>
                <div className="lg:col-span-2 bg-white p-6 rounded-xl shadow-md">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800">LÁSER Nº {laser.numero}</h2>
                    <p className="text-gray-500 mt-1">{laser.marca} {laser.modelo}</p>

                    <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                        <InfoItem label="Número de Serie" value={laser.numeroSerie} />
                        <InfoItem label="Fecha de Compra" value={laser.fechaCompra ? format(parseISO(laser.fechaCompra), 'dd/MM/yyyy') : 'N/A'} />
                        <InfoItem label="Recordatorios Activos" value={recordatorios.length} />
                        <div>
                            <div className="flex items-center"><WrenchIcon className="h-5 w-5 text-gray-500" /><span className="ml-2 text-sm text-gray-500">Estado</span></div>
                            <span className={`mt-1 inline-block px-2 py-1 rounded-md text-base font-bold ${getStatusClasses(laser.estado)}`}>
                                {laser.estado || 'ACTIVO'}
                            </span>
                        </div>
                        {laser.serieUrl && (
                            <div className="mt-4">
                                <a href={laser.serieUrl} target="_blank" rel="noopener noreferrer" className="inline-block text-blue-500 hover:text-blue-700"><img src={laser.serieUrl} alt="Número de serie" className="w-32 h-auto object-cover rounded-md shadow-sm cursor-pointer" /></a>
                            </div>
                        )}
                        {laser.contratoUrl && (
                            <div className="col-span-2 md:col-span-1 mt-4">
                                <button
                                    onClick={handleViewContractClick}
                                    className="w-full bg-blue-500 text-white py-2 rounded-lg font-semibold hover:bg-blue-600 transition flex items-center justify-center gap-2"
                                >
                                    <FileIcon /> Ver Contrato
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="mt-6">
                        <div className="flex justify-between items-center mb-2">
                            <label className="block text-sm font-bold text-gray-700">Comentarios</label>
                            {!isEditingComment && (
                                <button
                                    onClick={() => { setIsEditingComment(true); setEditableComment(laser.comentarios || ''); }}
                                    className="text-orange-600 hover:text-orange-900 p-1 flex items-center text-sm font-semibold"
                                >
                                    <PencilIcon />
                                    <span className="ml-1">Editar</span>
                                </button>
                            )}
                        </div>
                        <textarea
                            readOnly={!isEditingComment}
                            value={isEditingComment ? editableComment : (laser.comentarios || '')}
                            onChange={(e) => setEditableComment(e.target.value)}
                            className={`w-full p-3 border rounded-lg h-28 resize-none transition-colors ${isEditingComment ? 'bg-white border-orange-400 focus:ring-orange-500 focus:border-orange-500' : 'bg-gray-100 border-gray-200'}`}
                            placeholder={isEditingComment ? "Escribe aquí..." : "No hay comentarios."}
                        />
                        {isEditingComment && (
                            <div className="flex justify-end gap-2 mt-2">
                                <button onClick={() => setIsEditingComment(false)} className="px-4 py-1 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 text-sm font-semibold">
                                    Cancelar
                                </button>
                                <button onClick={handleSaveLaserComment} className="px-4 py-1 rounded-lg text-white bg-orange-500 hover:bg-orange-600 text-sm font-semibold">
                                    Guardar
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-md">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex flex-wrap gap-6 px-6">
                        <button onClick={() => setActiveTab('mantenimiento')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'mantenimiento' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>Mantenimiento</button>
                        <button onClick={() => setActiveTab('recordatorios')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'recordatorios' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>Recordatorios</button>
                        <button onClick={() => setActiveTab('revision')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'revision' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>Revisión</button>
                    </nav>
                </div>
                <div className="p-4 md:p-6">
                    {activeTab === 'mantenimiento' ? (
                        <div className="space-y-4">
                            {otrosMantenimientos.length > 0 ? otrosMantenimientos.map(m => (
                                <div key={m.id} className="bg-gray-50 p-4 rounded-lg flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                                    <div className="flex-1">
                                        <p className="font-bold">{m.tipo}</p>
                                        <p className="text-sm text-gray-600">{format(new Date(m.fecha), 'dd MMMM yyyy', { locale: es })}</p>
                                        <p className="text-sm text-gray-500 mt-1">{m.descripcion}</p>
                                    </div>
                                    <div className="text-sm sm:text-right">
                                        <p className="font-semibold">{Number(m.coste).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                                    </div>
                                    <div className="flex gap-2 self-end sm:self-center">
                                        {m.documentoUrl && (
                                            <a href={m.documentoUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 p-1" title="Ver/Descargar Factura">
                                                <FileIcon />
                                            </a>
                                        )}
                                        <button onClick={() => { setMantenimientoToEdit(m); setIsMantenimientoModalOpen(true); }} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                        <button onClick={() => { setItemToDelete(m); setDeleteType('mantenimiento'); }} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                    </div>
                                </div>
                            )) : <p className="text-center text-gray-500 py-8">No hay mantenimientos registrados.</p>}
                        </div>
                    ) : activeTab === 'recordatorios' ? (
                        <div className="space-y-4">
                            {recordatorios.length > 0 ? recordatorios.map(r => (
                                <div key={r.id} className="bg-gray-50 p-4 rounded-lg flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                                    <div className="flex-1">
                                        <p className="font-bold">{r.tipo}</p>
                                        <p className="text-sm text-gray-600">{format(new Date(r.fecha), 'dd MMMM yyyy', { locale: es })} {r.hora}</p>
                                        {r.descripcion && (
                                            <div className="mt-2">
                                                <p className="text-sm font-semibold text-gray-700">Descripción:</p>
                                                <p className="text-sm text-gray-600 whitespace-pre-wrap">{r.descripcion}</p>
                                            </div>
                                        )}
                                        <p className="text-xs text-gray-500 mt-2">Avisar {r.aviso} días antes</p>
                                    </div>
                                    <div className="flex gap-2 self-end sm:self-center">
                                        <button onClick={() => handleMarkReminderDoneLaser(r)} className="bg-green-500 text-white text-xs font-bold py-1 px-2 rounded-md hover:bg-green-600 transition-colors">Hecho</button>
                                        <button onClick={() => { setRecordatorioToEdit(r); setIsRecordatorioModalOpen(true); }} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                        <button onClick={() => { setItemToDelete(r); setDeleteType('recordatorio'); }} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                    </div>
                                </div>
                            )) : <p className="text-center text-gray-500 py-8">El historial de recordatorios del equipo aparecerá aquí.</p>}
                        </div>
                    ) : ( // Revisión
                        <div className="space-y-4">
                            {revisionesAnuales.length > 0 ? revisionesAnuales.map(m => (
                                <div key={m.id} className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                                    <div className="flex-1">
                                        <p className="font-bold text-yellow-800">{m.tipo}</p>
                                        <p className="text-sm text-gray-600">{format(new Date(m.fecha), 'dd MMMM yyyy', { locale: es })}</p>
                                        <p className="text-sm text-gray-500 mt-1">{m.descripcion}</p>
                                    </div>
                                    <div className="text-sm sm:text-right">
                                        <p className="font-semibold">{Number(m.coste).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                                    </div>
                                    <div className="flex gap-2 self-end sm:self-center">
                                        {m.documentoUrl && (
                                            <a href={m.documentoUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 p-1" title="Ver/Descargar Factura"><FileIcon /></a>
                                        )}
                                        <button onClick={() => {
                                            setRevisionForPasswordAction({ item: m, action: 'edit' });
                                            setIsRevisionPasswordPromptOpen(true);
                                        }} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                        <button onClick={() => {
                                            setRevisionForPasswordAction({ item: m, action: 'delete' });
                                            setIsRevisionPasswordPromptOpen(true);
                                        }} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                    </div>
                                </div>
                            )) : <p className="text-center text-gray-500 py-8">No hay revisiones anuales registradas.</p>}
                        </div>
                    )}
                </div>
            </div>

            <AddEquipoModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onLaserSaved={() => setIsAddModalOpen(false)} laserToEdit={equipoToEdit} user={user} />
            <AddMantenimientoEquipoModal user={user}
                isOpen={isMantenimientoModalOpen}
                onClose={() => { setIsMantenimientoModalOpen(false); setMantenimientoToEdit(null); setRecordatorioToComplete(null); }}
                onMantenimientoSaved={(esRevision) => {
                    setIsMantenimientoModalOpen(false);
                    setMantenimientoToEdit(null);
                    setRecordatorioToComplete(null);
                    if (esRevision) {
                        setActiveTab('revision');
                    }
                }}
                laser={laser}
                mantenimientoToEdit={mantenimientoToEdit}
                fromRecordatorio={recordatorioToComplete} // Pass the recordatorio to complete
            />
            <AddRecordatorioEquipoModal isOpen={isRecordatorioModalOpen} onClose={() => { setIsRecordatorioModalOpen(false); setRecordatorioToEdit(null) }} onRecordatorioSaved={() => { setIsRecordatorioModalOpen(false); setRecordatorioToEdit(null); }} laser={laser} recordatorioToEdit={recordatorioToEdit} user={user} />
            <ConfirmationModal isOpen={!!itemToDelete} onClose={() => setItemToDelete(null)} onConfirm={handleDelete} title="Confirmar Borrado" message="¿Estás seguro de que quieres borrar este registro? Esta acción no se puede deshacer." />
            <ConfirmationModal
                isOpen={isPasswordModalOpen}
                onClose={() => {
                    setIsPasswordModalOpen(false);
                    setPasswordInput('');
                    setPasswordError('');
                }}
                onConfirm={handleContractPasswordSubmit}
                title="Acceso al Contrato"
                message={
                    <div className="flex flex-col gap-4">
                        <p>Introduce la contraseña para ver el contrato:</p>
                        <input
                            type="password"
                            value={passwordInput}
                            onChange={(e) => setPasswordInput(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                            placeholder="Contraseña"
                            onKeyPress={(e) => e.key === 'Enter' && handleContractPasswordSubmit()}
                        />
                        {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
                    </div>
                }
            />
            <ConfirmationModal
                isOpen={isRevisionPasswordPromptOpen}
                onClose={() => {
                    setIsRevisionPasswordPromptOpen(false);
                    setPasswordInput('');
                    setPasswordError('');
                    setRevisionForPasswordAction({ item: null, action: '' });
                }}
                onConfirm={handleConfirmPasswordAction}
                title="Confirmar Acción de Revisión"
                message={
                    <div className="flex flex-col gap-4">
                        <p>Esta acción requiere permisos. Introduce la contraseña para continuar:</p>
                        <input
                            type="password"
                            value={passwordInput}
                            onChange={(e) => { setPasswordInput(e.target.value); setPasswordError(''); }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                            placeholder="Contraseña"
                            onKeyPress={(e) => e.key === 'Enter' && handleConfirmPasswordAction()}
                        />
                        {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
                    </div>
                }
            />
        </div>
    );
};

const CalendarPage = ({ setCurrentPage, onCloseCalendar, user }) => { // Receive setCurrentPage and onCloseCalendar props
    const [currentMonth, setCurrentMonth] = useState(new Date()); // Estado para el mes actual
    const [selectedDate, setSelectedDate] = useState(new Date());
    const eventListRef = useRef(null); // Ref para la lista de eventos
    const [furgonetas, setFurgonetas] = useState([]);
    const [furgonetaRecordatorios, setFurgonetaRecordatorios] = useState([]);
    const [laserRecordatorios, setLaserRecordatorios] = useState([]);
    const [furgonetaMantenimientos, setFurgonetaMantenimientos] = useState([]);
    const [laserMantenimientos, setLaserMantenimientos] = useState([]);

    useEffect(() => {
        // Fetch furgoneta recordatorios
        const unsubFurgonetas = onSnapshot(collection(db, getCollectionPath(user.uid, 'recordatorios_furgos')), (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'furgoneta' }));
            setFurgonetaRecordatorios(data);
        });

        // Fetch laser recordatorios
        const unsubLaseres = onSnapshot(collection(db, getCollectionPath(user.uid, 'recordatorios_equipos')), (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'laser' }));
            setLaserRecordatorios(data);
        });

        // Fetch furgoneta mantenimientos
        const unsubFurgosMant = onSnapshot(collection(db, getCollectionPath(user.uid, 'mantenimientos_furgos')), (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'furgoneta' }));
            setFurgonetaMantenimientos(data);
        });

        // Fetch all furgonetas to calculate recurring ITV dates
        const unsubFurgos = onSnapshot(collection(db, getCollectionPath(user.uid, 'furgonetas')), (snapshot) => {
            const furgosData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setFurgonetas(furgosData);
        });

        // Fetch laser mantenimientos
        const unsubLaseresMant = onSnapshot(collection(db, getCollectionPath(user.uid, 'mantenimientos_equipos')), (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'laser' }));
            setLaserMantenimientos(data);
        });

        return () => {
            unsubFurgonetas();
            unsubLaseres();
            unsubFurgosMant();
            unsubLaseresMant();
            unsubFurgos(); // Cleanup
        };
    }, [user.uid]);

    const allRecordatorios = [...furgonetaRecordatorios, ...laserRecordatorios].map(event => {
        const isFurgoneta = event.type === 'furgoneta';
        // Comprobamos si 'event.tipos' existe y es un array antes de usar .join(). Si no, usamos 'event.tipo'.
        const tipoDeEvento = isFurgoneta && Array.isArray(event.tipos) ? event.tipos.join(', ') : event.tipo;
        const nombreActivo = isFurgoneta ? event.furgonetaNombre : event.laserNombre;
        const assetId = isFurgoneta ? event.furgonetaId : event.laserId;

        return {
            id: event.id,
            date: event.fecha,
            title: `Recordatorio: ${tipoDeEvento} - ${nombreActivo}`,
            type: event.type,
            assetId: assetId,
            assetType: event.type,
            eventType: 'recordatorio',
        };
    });

    const allMantenimientos = [...furgonetaMantenimientos, ...laserMantenimientos].map(event => ({
        id: event.id,
        date: event.fecha,
        title: event.type === 'furgoneta' ? `Mantenimiento: ${event.tipos.join(', ')} - ${event.tallerNombre}` : `Mantenimiento: ${event.tipo} - ${event.laserNombre}`,
        type: event.type,
        assetId: event.type === 'furgoneta' ? event.furgonetaId : event.laserId,
        assetType: event.type,
        eventType: 'mantenimiento',
    }));

    // Generate recurring ITV events for the calendar
    const itvEvents = furgonetas.flatMap(furgoneta => {
        if (!furgoneta.itvDueDate || !furgoneta.itvFrequency) return [];

        const events = [];
        try {
            let nextItvDate = parseISO(furgoneta.itvDueDate);
            const frequencyMonths = furgoneta.itvFrequency === 'Cada 6 Meses' ? 6 : 12;
            const twoYearsFromNow = addYears(new Date(), 2); // Generate events for the next 2 years for performance

            // Keep adding events until they are past the 2-year window
            while (nextItvDate < twoYearsFromNow) {
                // Add the current `nextItvDate` if it's not in the distant past
                if (nextItvDate > subMonths(new Date(), 12)) { // Don't show very old events
                    events.push({
                        id: `itv-${furgoneta.id}-${format(nextItvDate, 'yyyy-MM-dd')}`,
                        date: format(nextItvDate, 'yyyy-MM-dd'),
                        title: `Vencimiento ITV: ${furgoneta.nombreInterno || furgoneta.marcaModelo}`,
                        type: 'furgoneta',
                        assetId: furgoneta.id,
                        assetType: 'furgoneta',
                        eventType: 'itv'
                    });
                }
                nextItvDate = addMonths(nextItvDate, frequencyMonths);
            }
        } catch (e) {
            console.error("Error generating ITV calendar events for furgoneta:", furgoneta.matricula, e);
        }
        return events;
    });

    // Generate insurance due date events for the calendar
    const insuranceEvents = furgonetas.flatMap(furgoneta => {
        if (!furgoneta.latestPolicy?.dueDate) return [];

        try {
            const dueDate = parseISO(furgoneta.latestPolicy.dueDate);
            return [{
                id: `insurance-${furgoneta.id}`,
                date: format(dueDate, 'yyyy-MM-dd'),
                title: `Vencimiento Seguro: ${furgoneta.nombreInterno || furgoneta.marcaModelo}`,
                type: 'furgoneta',
                assetId: furgoneta.id,
                assetType: 'furgoneta',
                eventType: 'insurance' // New event type
            }];
        } catch (e) {
            console.error("Error generating insurance calendar event for furgoneta:", furgoneta.matricula, e);
            return [];
        }
    });
    const allEvents = [...allRecordatorios, ...allMantenimientos, ...itvEvents, ...insuranceEvents];

    const handlePrevMonth = () => {
        setCurrentMonth(subMonths(currentMonth, 1));
    };

    const handleNextMonth = () => {
        setCurrentMonth(addMonths(currentMonth, 1));
    };

    const handleDayClick = (day) => {
        setSelectedDate(day);
        // Comprueba si hay eventos para el día clicado
        const hasEvents = allEvents.some(event => event.date && isSameDay(parseISO(event.date), day));

        // En móvil, si se clica un día con eventos, se desplaza a la lista de eventos
        if (window.innerWidth < 1024 && hasEvents) { // 1024px es el breakpoint 'lg'
            setTimeout(() => {
                eventListRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100); // Timeout para permitir que el DOM se actualice
        }
    };

    const handleEventClick = (event) => {
        const tab = event.eventType === 'recordatorio' ? 'recordatorios' : 'mantenimiento';
        const options = { initialTab: tab };
        if (event.assetType === 'furgoneta') {
            setCurrentPage('furgonetaDetail', event.assetId, options);
        } else if (event.assetType === 'laser') {
            setCurrentPage('laserDetail', event.assetId, options);
        }
    };

    const selectedDateEvents = allEvents.filter(event => event.date && isSameDay(parseISO(event.date), selectedDate));

    return (
        <div className="flex flex-col lg:flex-row gap-8 h-full">
            {/* Main Calendar View */}
            <div className="flex-grow bg-white p-4 sm:p-6 rounded-lg shadow-md relative">
                <button
                    onClick={onCloseCalendar}
                    className="absolute top-4 right-4 z-10 p-2 rounded-full bg-gray-100/50 hover:bg-gray-200/80 text-gray-600 hover:text-gray-900 transition-colors"
                    title="Cerrar Calendario"
                >
                    <XIcon />
                </button>
                <h2 className="text-2xl font-bold text-gray-800 mb-2">Calendario de Eventos</h2>
                <p className="text-sm text-gray-500 mb-6">Vista general de todos los mantenimientos y recordatorios.</p>

                <div className="flex justify-between items-center mb-4">
                    <button onClick={handlePrevMonth} className="p-2 rounded-full hover:bg-gray-100"><ChevronLeftIcon /></button>
                    <button onClick={handleNextMonth} className="p-2 rounded-full hover:bg-gray-100"><ChevronRightIcon /></button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
                    <div>
                        <h4 className="text-center font-semibold text-gray-800 mb-3 capitalize">{format(currentMonth, 'MMMM yyyy', { locale: es })}</h4>
                        <CalendarMonth
                            monthDate={currentMonth}
                            selectedDate={selectedDate}
                            onDayClick={handleDayClick}
                            events={allEvents}
                        />
                    </div>
                    <div>
                        <h4 className="text-center font-semibold text-gray-800 mb-3 capitalize">{format(addMonths(currentMonth, 1), 'MMMM yyyy', { locale: es })}</h4>
                        <CalendarMonth
                            monthDate={addMonths(currentMonth, 1)}
                            selectedDate={selectedDate}
                            onDayClick={handleDayClick}
                            events={allEvents}
                        />
                    </div>
                    <div>
                        <h4 className="text-center font-semibold text-gray-800 mb-3 capitalize">{format(addMonths(currentMonth, 2), 'MMMM yyyy', { locale: es })}</h4>
                        <CalendarMonth
                            monthDate={addMonths(currentMonth, 2)}
                            selectedDate={selectedDate}
                            onDayClick={handleDayClick}
                            events={allEvents}
                        />
                    </div>
                    <div>
                        <h4 className="text-center font-semibold text-gray-800 mb-3 capitalize">{format(addMonths(currentMonth, 3), 'MMMM yyyy', { locale: es })}</h4>
                        <CalendarMonth
                            monthDate={addMonths(currentMonth, 3)}
                            selectedDate={selectedDate}
                            onDayClick={handleDayClick}
                            events={allEvents}
                        />
                    </div>
                    <div>
                        <h4 className="text-center font-semibold text-gray-800 mb-3 capitalize">{format(addMonths(currentMonth, 4), 'MMMM yyyy', { locale: es })}</h4>
                        <CalendarMonth
                            monthDate={addMonths(currentMonth, 4)}
                            selectedDate={selectedDate}
                            onDayClick={handleDayClick}
                            events={allEvents}
                        />
                    </div>
                    <div>
                        <h4 className="text-center font-semibold text-gray-800 mb-3 capitalize">{format(addMonths(currentMonth, 5), 'MMMM yyyy', { locale: es })}</h4>
                        <CalendarMonth
                            monthDate={addMonths(currentMonth, 5)}
                            selectedDate={selectedDate}
                            onDayClick={handleDayClick}
                            events={allEvents}
                        />
                    </div>
                </div>
            </div>

            {/* Event List Sidebar */}
            <div ref={eventListRef} className="w-full lg:w-80 lg:max-w-sm flex-shrink-0 bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                    <CalendarIcon />
                    <span className="ml-2">Eventos para {format(selectedDate, 'dd MMMM yyyy', { locale: es })}</span>
                </h3>
                <div className="space-y-3">
                    {selectedDateEvents.length > 0 ? (
                        selectedDateEvents.map(event => (
                            <div key={event.id} className={`p-3 rounded-lg border-l-4 cursor-pointer ${event.eventType === 'insurance' ? 'border-purple-500 bg-purple-50 hover:bg-purple-100' :
                                event.eventType === 'itv' ? 'border-red-500 bg-red-50 hover:bg-red-100' :
                                    event.eventType === 'recordatorio' ? 'border-yellow-500 bg-yellow-50 hover:bg-yellow-100' :
                                        'border-blue-500 bg-blue-50 hover:bg-blue-100'
                                }`} onClick={() => handleEventClick(event)}>
                                <p className={`font-semibold text-sm ${event.eventType === 'recordatorio' ? 'text-red-800' : 'text-blue-800'}`}>{event.title}</p>
                                <span className={`text-xs font-bold text-gray-600`}>
                                    {event.type === 'furgoneta' ? 'Furgoneta' : 'Láser'}
                                </span>
                            </div>
                        ))
                    ) : (
                        <p className="text-sm text-gray-500 text-center mt-8">No hay eventos para este día.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

const CalendarMonth = ({ monthDate, selectedDate, onDayClick, events }) => {
    const today = new Date();
    const monthStart = startOfMonth(monthDate);
    const monthEnd = endOfMonth(monthDate);
    const startDate = startOfWeek(monthStart, { weekStartsOn: 1 }); // Monday start
    const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });

    const days = eachDayOfInterval({ start: startDate, end: endDate });
    const dayNames = ['lu', 'ma', 'mi', 'ju', 'vi', 'sá', 'do'];

    return (
        <div>
            <div className="grid grid-cols-7 gap-2 text-center text-xs font-bold text-gray-500 mb-2">
                {dayNames.map(day => <div key={day}>{day}</div>)}
            </div>
            <div className="grid grid-cols-7 gap-1">
                {days.map((day, i) => {
                    const isCurrentMonth = isSameMonth(day, monthDate);
                    const isSelected = isSameDay(day, selectedDate);
                    const isToday = isSameDay(day, today);
                    const dayEvents = events.filter(event => event.date && isSameDay(parseISO(event.date), day));
                    const hasInsurance = dayEvents.some(e => e.eventType === 'insurance');
                    const hasItv = dayEvents.some(e => e.eventType === 'itv');
                    const hasRecordatorio = dayEvents.some(e => e.eventType === 'recordatorio');
                    const hasMantenimiento = dayEvents.some(e => e.eventType === 'mantenimiento');

                    const dayClasses = `
                        w-full aspect-square flex items-center justify-center rounded-full text-sm cursor-pointer
                        ${isCurrentMonth ? 'text-gray-700' : 'text-gray-300'}
                        ${!isToday && !isSelected && isCurrentMonth ? 'hover:bg-gray-100' : ''}
                        ${hasInsurance ? 'bg-purple-500 text-white font-bold' :
                            hasItv ? 'bg-red-500 text-white font-bold' :
                                hasRecordatorio ? 'bg-yellow-400 text-white font-bold' :
                                    hasMantenimiento ? 'bg-blue-400 text-white font-bold' : ''
                        }
                        ${isToday ? 'ring-2 ring-offset-1 ring-orange-500' : ''}
                        ${isSelected ? 'outline outline-2 outline-offset-2 outline-orange-500' : ''}
                        
                    `;

                    return (
                        <div key={i} onClick={() => onDayClick(day)} className={dayClasses}>
                            {format(day, 'd')}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const MantenimientoFurgosPage = ({ user }) => {
    const [furgonetas, setFurgonetas] = useState([]);
    const [mantenimientos, setMantenimientos] = useState([]);
    const [filteredMantenimientos, setFilteredMantenimientos] = useState([]);
    const [selectedFurgoneta, setSelectedFurgoneta] = useState('all');
    const [selectedTipo, setSelectedTipo] = useState('all');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const [passwordInput, setPasswordInput] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [deleteType, setDeleteType] = useState('');

    const CORRECT_PHRASE = 'borrar mantenimiento';

    useEffect(() => {
        const furgonetasUnsub = onSnapshot(collection(db, getCollectionPath(user.uid, 'furgonetas')), (snapshot) => {
            setFurgonetas(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });

        const mantenimientosUnsub = onSnapshot(collection(db, getCollectionPath(user.uid, 'mantenimientos_furgos')), (snapshot) => {
            const mantenimientosData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setMantenimientos(mantenimientosData);
        });

        return () => {
            furgonetasUnsub();
            mantenimientosUnsub();
        };
    }, [user.uid]);

    useEffect(() => {
        let filtered = mantenimientos;

        if (selectedFurgoneta !== 'all') {
            filtered = filtered.filter(m => m.furgonetaId === selectedFurgoneta);
        }

        if (selectedTipo !== 'all') {
            const upperSelectedTipo = selectedTipo.toUpperCase();
            if (upperSelectedTipo === 'OTROS') {
                // For "Otros", check if any type starts with 'OTROS' to catch "OTROS: description"
                filtered = filtered.filter(m => m.tipos && m.tipos.some(t => t.startsWith('OTROS')));
            } else {
                filtered = filtered.filter(m => m.tipos && m.tipos.includes(upperSelectedTipo));
            }
        }

        if (startDate) {
            filtered = filtered.filter(m => new Date(m.fecha) >= new Date(startDate));
        }

        if (endDate) {
            filtered = filtered.filter(m => new Date(m.fecha) <= new Date(endDate));
        }

        setFilteredMantenimientos(filtered.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));
    }, [selectedFurgoneta, selectedTipo, startDate, endDate, mantenimientos]);

    const handleClearFilters = () => {
        setSelectedFurgoneta('all');
        setSelectedTipo('all');
        setStartDate('');
        setEndDate('');
    };

    const totalCost = filteredMantenimientos.reduce((acc, m) => acc + (Number(m.coste) || 0), 0);

    const costByFurgoneta = filteredMantenimientos.reduce((acc, m) => {
        const furgoneta = furgonetas.find(f => f.id === m.furgonetaId);
        const furgonetaNombre = furgoneta ? furgoneta.nombre : 'Desconocida';
        if (!acc[furgonetaNombre]) {
            acc[furgonetaNombre] = 0;
        }
        acc[furgonetaNombre] += (Number(m.coste) || 0);
        return acc;
    }, {});

    const handleEnableDelete = () => {
        setIsPasswordModalOpen(true);
    };

    const handlePasswordSubmit = () => {
        if (passwordInput.toLowerCase() === CORRECT_PHRASE) {
            setDeleteEnabled(true);
            setIsPasswordModalOpen(false);
            setPasswordInput('');
            setPasswordError('');
        } else {
            setPasswordError('La frase no es correcta. Escribe "borrar mantenimiento".');
        }
    };

    const handleDeleteSingle = (item) => {
        setItemToDelete(item);
        setDeleteType('single');
    };

    const handleDeleteAll = () => {
        setItemToDelete(null); // No specific item, implies all filtered
        setDeleteType('all');
    };

    const confirmDeleteAction = async () => {
        try {
            if (deleteType === 'single' && itemToDelete) {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'mantenimientos_furgos'), itemToDelete.id));
            } else if (deleteType === 'all') {
                for (const m of filteredMantenimientos) {
                    await deleteDoc(doc(db, getCollectionPath(user.uid, 'mantenimientos_furgos'), m.id));
                }
            }
        } catch (error) {
            console.error("Error deleting maintenance records:", error);
        } finally {
            setItemToDelete(null);
            setDeleteType('');
            setDeleteEnabled(false); // Disable delete after action
        }
    };

    return (
        <div className="space-y-6">
            <div className="mb-6">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Mantenimiento Furgos</h2>
                <p className="text-gray-500 mt-1">Filtra y visualiza el historial y los gastos de mantenimiento de tu flota.</p>
            </div>

            <div className="p-4 bg-white rounded-lg shadow-sm flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-4">
                <select
                    value={selectedFurgoneta}
                    onChange={e => setSelectedFurgoneta(e.target.value)}
                    className="p-2 border border-gray-300 rounded-lg bg-white w-full sm:w-auto"
                >
                    <option value="all">Todas las Furgonetas</option>
                    {furgonetas.map(f => (
                        <option key={f.id} value={f.id}>{f.nombre} ({f.matricula})</option>
                    ))}
                </select>
                <select
                    value={selectedTipo}
                    onChange={e => setSelectedTipo(e.target.value)}
                    className="p-2 border border-gray-300 rounded-lg bg-white w-full sm:w-auto"
                >
                    <option value="all">Todos los Tipos</option>
                    {MANTENIMIENTO_TIPOS_FURGOS.map(tipo => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                    ))}
                </select>
                <div className="flex flex-col sm:flex-row items-center gap-2 w-full sm:w-auto">
                    <input
                        type={startDate ? 'date' : 'text'}
                        onFocus={(e) => e.target.type = 'date'}
                        onBlur={(e) => { if (!e.target.value) e.target.type = 'text'; }}
                        value={startDate} onChange={e => setStartDate(e.target.value)}
                        placeholder="Desde (dd/mm/aaaa)"
                        className="p-2 border border-gray-300 rounded-lg w-full text-gray-700 placeholder-gray-400"
                    />
                    <span className="text-gray-500 hidden sm:block mx-2">-</span>
                    <input
                        type={endDate ? 'date' : 'text'}
                        onFocus={(e) => e.target.type = 'date'}
                        onBlur={(e) => { if (!e.target.value) e.target.type = 'text'; }}
                        value={endDate} onChange={e => setEndDate(e.target.value)}
                        placeholder="Hasta (dd/mm/aaaa)"
                        className="p-2 border border-gray-300 rounded-lg w-full text-gray-700 placeholder-gray-400"
                    />
                </div>
                <button onClick={handleClearFilters} className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 w-full sm:w-auto whitespace-normal text-center">
                    Limpiar Filtros
                </button>
                <button
                    onClick={handleEnableDelete}
                    className={`px-4 py-2 rounded-lg font-semibold w-full sm:w-auto whitespace-normal text-center ${deleteEnabled ? 'bg-red-500 text-white hover:bg-red-600' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                    {deleteEnabled ? 'Modo Borrar ACTIVADO' : 'Activar Borrar Mantenimientos'}
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="p-6 bg-white rounded-lg shadow-sm">
                    <h3 className="text-gray-500 font-semibold">Gasto Total</h3>
                    <p className="text-3xl md:text-4xl font-bold mt-2">{totalCost.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                    <p className="text-sm text-gray-400 mt-1">Coste total para la selección actual</p>
                </div>
                <div className="p-6 bg-white rounded-lg shadow-sm">
                    <h3 className="text-gray-500 font-semibold">Gasto por Furgoneta</h3>
                    <div className="mt-2 space-y-1">
                        {Object.keys(costByFurgoneta).length > 0 ? (
                            Object.entries(costByFurgoneta).map(([nombre, coste]) => (
                                <div key={nombre} className="flex justify-between text-sm">
                                    <span className="font-medium">{nombre}</span>
                                    <span className="font-bold">{coste.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</span>
                                </div>
                            ))
                        ) : (
                            <p className="text-sm text-gray-400">No hay gastos para la selección actual.</p>
                        )}
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm">
                <h3 className="text-xl font-bold p-6">Historial de Mantenimientos Filtrado</h3>
                {deleteEnabled && filteredMantenimientos.length > 0 && (
                    <div className="px-6 pb-4">
                        <button onClick={handleDeleteAll} className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 text-sm">
                            Borrar TODOS los mantenimientos filtrados
                        </button>
                    </div>
                )}
                {/* Desktop Table View */}
                <div className="overflow-x-auto hidden md:block">
                    <table className="min-w-full">
                        <thead className="border-b-2 border-gray-200 bg-gray-50">
                            <tr>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Furgoneta</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Fecha</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Tipo</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Taller</th>
                                <th className="p-3 text-right text-sm font-semibold text-gray-500">Coste</th>
                                <th className="p-3 text-center text-sm font-semibold text-gray-500">Factura</th>
                                {deleteEnabled && <th className="p-3 text-center text-sm font-semibold text-gray-500">Borrar</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredMantenimientos.length > 0 ? (
                                filteredMantenimientos.map(m => {
                                    const furgoneta = furgonetas.find(f => f.id === m.furgonetaId);
                                    return (
                                        <tr key={m.id} className="border-b border-gray-100">
                                            <td className="p-3 text-sm whitespace-nowrap">{furgoneta ? furgoneta.nombre : 'Desconocida'}</td>
                                            <td className="p-3 text-sm whitespace-nowrap">{format(new Date(m.fecha), 'dd/MM/yyyy')}</td>
                                            <td className="p-3 text-sm">{m.tipos.join(', ')}</td>
                                            <td className="p-3 text-sm whitespace-nowrap">{m.tallerNombre}</td>
                                            <td className="p-3 text-sm text-right font-semibold whitespace-nowrap">{Number(m.coste).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</td>
                                            <td className="p-3 text-center whitespace-nowrap">
                                                {m.documentoUrl && (
                                                    <a href={m.documentoUrl} target="_blank" rel="noopener noreferrer" className="inline-block text-blue-500 hover:text-blue-700">
                                                        <FileIcon />
                                                    </a>
                                                )}
                                            </td>
                                            {deleteEnabled && (
                                                <td className="p-3 text-center whitespace-nowrap">
                                                    <button onClick={() => handleDeleteSingle(m)} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                                </td>
                                            )}
                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan={deleteEnabled ? "7" : "6"} className="text-center py-8 text-gray-500">No se encontraron registros.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {/* Mobile Card View */}
                <div className="md:hidden space-y-4 p-2 sm:p-0">
                    {filteredMantenimientos.length > 0 ? (
                        filteredMantenimientos.map(m => {
                            const furgoneta = furgonetas.find(f => f.id === m.furgonetaId);
                            return (
                                <div key={m.id} className="bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-200">
                                    <div className="flex justify-between items-start">
                                        <div>
                                            <p className="font-bold text-gray-800">{furgoneta ? furgoneta.nombre : 'Desconocida'}</p>
                                            <p className="text-sm text-gray-600">{format(new Date(m.fecha), 'dd/MM/yyyy')}</p>
                                        </div>
                                        <p className="font-bold text-lg text-gray-800">{Number(m.coste).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                                    </div>
                                    <div className="mt-3 border-t pt-3 space-y-1">
                                        <p className="text-sm"><span className="font-semibold text-gray-600">Tipo:</span> {m.tipos.join(', ')}</p>
                                        <p className="text-sm"><span className="font-semibold text-gray-600">Taller:</span> {m.tallerNombre}</p>
                                    </div>
                                    <div className="flex justify-end items-center gap-4 mt-3">
                                        {m.documentoUrl && (
                                            <a href={m.documentoUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 p-1" title="Ver/Descargar Factura">
                                                <FileIcon />
                                            </a>
                                        )}
                                        {deleteEnabled && (
                                            <button onClick={() => handleDeleteSingle(m)} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                        )}
                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <p className="text-center py-8 text-gray-500">No se encontraron registros.</p>
                    )}
                </div>
            </div>
            <ConfirmationModal
                isOpen={isPasswordModalOpen}
                onClose={() => setIsPasswordModalOpen(false)}
                onConfirm={handlePasswordSubmit}
                title="Activar Borrado de Mantenimientos"
                message={ // eslint-disable-next-line react/jsx-key
                    <div className="flex flex-col gap-4">
                        <p>Para activar la opción de borrado, escribe la frase <span className="font-bold text-red-600">borrar mantenimiento</span> en el campo de abajo.</p>
                        <input
                            type="text"
                            value={passwordInput}
                            onChange={(e) => setPasswordInput(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                            placeholder="borrar mantenimiento"
                        />
                        {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
                    </div>
                }
            />
            <ConfirmationModal
                isOpen={!!itemToDelete || (deleteType === 'all' && deleteEnabled)}
                onClose={() => { setItemToDelete(null); setDeleteType(''); }}
                onConfirm={confirmDeleteAction}
                title="Confirmar Borrado"
                message={deleteType === 'all' ? "¿Estás seguro de que quieres borrar TODOS los mantenimientos filtrados? Esta acción no se puede deshacer." : "¿Estás seguro de que quieres borrar este registro de mantenimiento? Esta acción no se puede deshacer."}
            />
        </div>
    );
};

const MantenimientoLaseresPage = ({ user }) => {
    const [laseres, setLaseres] = useState([]);
    const [mantenimientos, setMantenimientos] = useState([]);
    const [filteredMantenimientos, setFilteredMantenimientos] = useState([]);
    const [selectedLaser, setSelectedLaser] = useState('all');
    const [selectedTipo, setSelectedTipo] = useState('all');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const [passwordInput, setPasswordInput] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [deleteType, setDeleteType] = useState('');

    const CORRECT_PHRASE = 'borrar mantenimiento';

    useEffect(() => {
        const laseresUnsub = onSnapshot(collection(db, getCollectionPath(user.uid, 'equipos')), (snapshot) => {
            setLaseres(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });

        const mantenimientosUnsub = onSnapshot(collection(db, getCollectionPath(user.uid, 'mantenimientos_equipos')), (snapshot) => {
            const mantenimientosData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setMantenimientos(mantenimientosData);
        });

        return () => {
            laseresUnsub();
            mantenimientosUnsub();
        };
    }, [user.uid]);

    useEffect(() => {
        let filtered = mantenimientos;

        if (selectedLaser !== 'all') {
            filtered = filtered.filter(m => m.laserId === selectedLaser);
        }

        if (selectedTipo !== 'all') {
            filtered = filtered.filter(m => m.tipo && m.tipo.toUpperCase() === selectedTipo.toUpperCase());
        }

        if (startDate) {
            filtered = filtered.filter(m => new Date(m.fecha) >= new Date(startDate));
        }

        if (endDate) {
            filtered = filtered.filter(m => new Date(m.fecha) <= new Date(endDate));
        }

        setFilteredMantenimientos(filtered.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));
    }, [selectedLaser, selectedTipo, startDate, endDate, mantenimientos]);

    const handleClearFilters = () => {
        setSelectedLaser('all');
        setSelectedTipo('all');
        setStartDate('');
        setEndDate('');
    };

    const totalCost = filteredMantenimientos.reduce((acc, m) => acc + (Number(m.coste) || 0), 0);

    const costByLaser = filteredMantenimientos.reduce((acc, m) => {
        const laser = laseres.find(l => l.id === m.laserId);
        const laserNombre = laser ? `${laser.marca} ${laser.modelo}` : 'Desconocido';
        if (!acc[laserNombre]) {
            acc[laserNombre] = 0;
        }
        acc[laserNombre] += (Number(m.coste) || 0);
        return acc;
    }, {});

    const handleEnableDelete = () => {
        setIsPasswordModalOpen(true);
    };

    const handlePasswordSubmit = () => {
        if (passwordInput.toLowerCase() === CORRECT_PHRASE) {
            setDeleteEnabled(true);
            setIsPasswordModalOpen(false);
            setPasswordInput('');
            setPasswordError('');
        } else {
            setPasswordError('La frase no es correcta. Escribe "borrar mantenimiento".');
        }
    };

    const handleDeleteSingle = (item) => {
        setItemToDelete(item);
        setDeleteType('single');
    };

    const handleDeleteAll = () => {
        setItemToDelete(null); // No specific item, implies all filtered
        setDeleteType('all');
    };

    const confirmDeleteAction = async () => {
        try {
            if (deleteType === 'single' && itemToDelete) {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'mantenimientos_equipos'), itemToDelete.id));
            } else if (deleteType === 'all') {
                for (const m of filteredMantenimientos) {
                    await deleteDoc(doc(db, getCollectionPath(user.uid, 'mantenimientos_equipos'), m.id));
                }
            }
        } catch (error) {
            console.error("Error deleting maintenance records:", error);
        } finally {
            setItemToDelete(null);
            setDeleteType('');
            setDeleteEnabled(false); // Disable delete after action
        }
    };

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Mantenimiento Equipos</h2>
                <p className="text-gray-500 mt-1">Filtra y visualiza el historial y los gastos de mantenimiento de tus equipos.</p>
            </div>

            <div className="p-4 bg-white rounded-lg shadow-sm flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-4">
                <select
                    value={selectedLaser}
                    onChange={e => setSelectedLaser(e.target.value)}
                    className="p-2 border border-gray-300 rounded-lg bg-white w-full sm:w-auto"
                >
                    <option value="all">Todos los Láseres</option>
                    {laseres.map(l => (
                        <option key={l.id} value={l.id}>{l.marca} {l.modelo} (Nº {l.numero})</option>
                    ))}
                </select>
                <select
                    value={selectedTipo}
                    onChange={e => setSelectedTipo(e.target.value)}
                    className="p-2 border border-gray-300 rounded-lg bg-white w-full sm:w-auto"
                >
                    <option value="all">Todos los Tipos</option>
                    {MANTENIMIENTO_TIPOS_EQUIPOS.map(tipo => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                    ))}
                </select>
                <div className="flex flex-col sm:flex-row items-center gap-2 w-full sm:w-auto">
                    <input
                        type={startDate ? 'date' : 'text'}
                        onFocus={(e) => e.target.type = 'date'}
                        onBlur={(e) => { if (!e.target.value) e.target.type = 'text'; }}
                        value={startDate} onChange={e => setStartDate(e.target.value)}
                        placeholder="Desde (dd/mm/aaaa)"
                        className="p-2 border border-gray-300 rounded-lg w-full text-gray-700 placeholder-gray-400"
                    />
                    <span className="text-gray-500 hidden sm:block mx-2">-</span>
                    <input
                        type={endDate ? 'date' : 'text'}
                        onFocus={(e) => e.target.type = 'date'}
                        onBlur={(e) => { if (!e.target.value) e.target.type = 'text'; }}
                        value={endDate} onChange={e => setEndDate(e.target.value)}
                        placeholder="Hasta (dd/mm/aaaa)"
                        className="p-2 border border-gray-300 rounded-lg w-full text-gray-700 placeholder-gray-400"
                    />
                </div>
                <button onClick={handleClearFilters} className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 w-full sm:w-auto whitespace-normal text-center">
                    Limpiar Filtros
                </button>
                <button
                    onClick={handleEnableDelete}
                    className={`px-4 py-2 rounded-lg font-semibold w-full sm:w-auto whitespace-normal text-center ${deleteEnabled ? 'bg-red-500 text-white hover:bg-red-600' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                    {deleteEnabled ? 'Modo Borrar ACTIVADO' : 'Activar Borrar Mantenimientos'}
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="p-6 bg-white rounded-lg shadow-sm">
                    <h3 className="text-gray-500 font-semibold">Gasto Total</h3>
                    <p className="text-3xl md:text-4xl font-bold mt-2">{totalCost.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                    <p className="text-sm text-gray-400 mt-1">Coste total para la selección actual</p>
                </div>
                <div className="p-6 bg-white rounded-lg shadow-sm">
                    <h3 className="text-gray-500 font-semibold">Gasto por Equipo</h3>
                    <div className="mt-2 space-y-1">
                        {Object.keys(costByLaser).length > 0 ? (
                            Object.entries(costByLaser).map(([nombre, coste]) => (
                                <div key={nombre} className="flex justify-between text-sm">
                                    <span className="font-medium">{nombre}</span>
                                    <span className="font-bold">{coste.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</span>
                                </div>
                            ))
                        ) : (
                            <p className="text-sm text-gray-400">No hay gastos para la selección actual.</p>
                        )}
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm">
                <h3 className="text-xl font-bold p-6">Historial de Mantenimientos Filtrado</h3>
                {deleteEnabled && filteredMantenimientos.length > 0 && (
                    <div className="px-6 pb-4">
                        <button onClick={handleDeleteAll} className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 text-sm">
                            Borrar TODOS los mantenimientos filtrados
                        </button>
                    </div>
                )}
                {/* Desktop Table View */}
                <div className="overflow-x-auto hidden md:block">
                    <table className="min-w-full">
                        <thead className="border-b-2 border-gray-200 bg-gray-50">
                            <tr>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Equipo</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Fecha</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Tipo</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Descripción</th>
                                <th className="p-3 text-right text-sm font-semibold text-gray-500">Coste</th>
                                <th className="p-3 text-center text-sm font-semibold text-gray-500">Factura</th>
                                {deleteEnabled && <th className="p-3 text-center text-sm font-semibold text-gray-500">Borrar</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredMantenimientos.length > 0 ? (
                                filteredMantenimientos.map(m => {
                                    const laser = laseres.find(l => l.id === m.laserId);
                                    return (
                                        <tr key={m.id} className="border-b border-gray-100">
                                            <td className="p-3 text-sm whitespace-nowrap">{laser ? `${laser.marca} ${laser.modelo}` : 'Desconocido'}</td>
                                            <td className="p-3 text-sm whitespace-nowrap">{format(new Date(m.fecha), 'dd/MM/yyyy')}</td>
                                            <td className="p-3 text-sm whitespace-nowrap">{m.tipo}</td>
                                            <td className="p-3 text-sm">{m.descripcion || 'N/A'}</td>
                                            <td className="p-3 text-sm text-right font-semibold whitespace-nowrap">{Number(m.coste).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</td>
                                            <td className="p-3 text-center whitespace-nowrap">
                                                {m.documentoUrl && (
                                                    <a href={m.documentoUrl} target="_blank" rel="noopener noreferrer" className="inline-block text-blue-500 hover:text-blue-700">
                                                        <FileIcon />
                                                    </a>
                                                )}
                                            </td>
                                            {deleteEnabled && (
                                                <td className="p-3 text-center whitespace-nowrap">
                                                    <button onClick={() => handleDeleteSingle(m)} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                                </td>
                                            )}
                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan={deleteEnabled ? "7" : "6"} className="text-center py-8 text-gray-500">No se encontraron registros.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {/* Mobile Card View */}
                <div className="md:hidden space-y-4 p-2 sm:p-0">
                    {filteredMantenimientos.length > 0 ? (
                        filteredMantenimientos.map(m => {
                            const laser = laseres.find(l => l.id === m.laserId);
                            return (
                                <div key={m.id} className="bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-200">
                                    <div className="flex justify-between items-start">
                                        <div>
                                            <p className="font-bold text-gray-800">{laser ? `${laser.marca} ${laser.modelo}` : 'Desconocido'}</p>
                                            <p className="text-sm text-gray-600">{format(new Date(m.fecha), 'dd/MM/yyyy')}</p>
                                        </div>
                                        <p className="font-bold text-lg text-gray-800">{Number(m.coste).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
                                    </div>
                                    <div className="mt-3 border-t pt-3 space-y-1">
                                        <p className="text-sm"><span className="font-semibold text-gray-600">Tipo:</span> {m.tipo}</p>
                                        {m.descripcion && <p className="text-sm"><span className="font-semibold text-gray-600">Descripción:</span> {m.descripcion}</p>}
                                    </div>
                                    <div className="flex justify-end items-center gap-4 mt-3">
                                        {m.documentoUrl && (
                                            <a href={m.documentoUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 p-1" title="Ver/Descargar Factura">
                                                <FileIcon />
                                            </a>
                                        )}
                                        {deleteEnabled && (
                                            <button onClick={() => handleDeleteSingle(m)} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                        )}
                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <p className="text-center py-8 text-gray-500">No se encontraron registros.</p>
                    )}
                </div>
            </div>
            <ConfirmationModal
                isOpen={isPasswordModalOpen}
                onClose={() => setIsPasswordModalOpen(false)}
                onConfirm={handlePasswordSubmit}
                title="Activar Borrado de Mantenimientos"
                message={ // eslint-disable-next-line react/jsx-key
                    <div className="flex flex-col gap-4">
                        <p>Para activar la opción de borrado, escribe la frase <span className="font-bold text-red-600">borrar mantenimiento</span> en el campo de abajo.</p>
                        <input
                            type="text"
                            value={passwordInput}
                            onChange={(e) => setPasswordInput(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                            placeholder="borrar mantenimiento"
                        />
                        {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
                    </div>
                }
            />
            <ConfirmationModal
                isOpen={!!itemToDelete || (deleteType === 'all' && deleteEnabled)}
                onClose={() => { setItemToDelete(null); setDeleteType(''); }}
                onConfirm={confirmDeleteAction}
                title="Confirmar Borrado"
                message={deleteType === 'all' ? "¿Estás seguro de que quieres borrar TODOS los mantenimientos filtrados? Esta acción no se puede deshacer." : "¿Estás seguro de que quieres borrar este registro de mantenimiento? Esta acción no se puede deshacer."}
            />
        </div>
    );
};

const TrucosMilesmanPage = ({ setLightboxContent, user }) => {
    const [activeTab, setActiveTab] = useState('fotos');
    const [trucos, setTrucos] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [trucoToDelete, setTrucoToDelete] = useState(null);

    useEffect(() => {
        const q = query(collection(db, getCollectionPath(user.uid, 'trucos')));
        const unsub = onSnapshot(q, (snapshot) => {
            const trucosData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            trucosData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setTrucos(trucosData);
        });
        return () => unsub();
    }, [user.uid]);

    const handleDelete = async () => {
        if (trucoToDelete) {
            try {
                // Delete file from storage using its URL
                const fileRef = ref(storage, trucoToDelete.fileUrl);
                await deleteObject(fileRef).catch(e => console.warn("Error deleting truco file from storage:", e));
                // Delete document from Firestore
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'trucos'), trucoToDelete.id));
                setTrucoToDelete(null); // Close confirmation modal
            } catch (error) {
                console.error("Error deleting truco:", error);
                // Handle error (e.g., show a message to the user)
            }
        }
    };

    const filteredTrucos = trucos.filter(t => (activeTab === 'fotos' ? t.type === 'foto' : t.type === 'video'));

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Trucos Equipos</h2>
                    <p className="text-gray-500 mt-1">Consejos y trucos para sacar el máximo partido a tus equipos.</p>
                </div>
                <button onClick={() => setIsModalOpen(true)} className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 flex items-center transition-transform transform hover:scale-105 w-full sm:w-auto justify-center">
                    <PlusCircleIcon /> Añadir Truco
                </button>
            </div>

            <div className="mb-6">
                <div className="flex border-b border-gray-200">
                    <button onClick={() => setActiveTab('fotos')} className={`py-2 px-4 font-semibold ${activeTab === 'fotos' ? 'border-b-2 border-orange-500 text-orange-600' : 'text-gray-500 hover:text-gray-700'}`}>
                        Fotos
                    </button>
                    <button onClick={() => setActiveTab('videos')} className={`py-2 px-4 font-semibold ${activeTab === 'videos' ? 'border-b-2 border-orange-500 text-orange-600' : 'text-gray-500 hover:text-gray-700'}`}>
                        Vídeos
                    </button>
                </div>
            </div>

            {filteredTrucos.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {filteredTrucos.map(truco => (
                        <div key={truco.id} className="bg-white rounded-lg shadow-md overflow-hidden group relative">
                            <button onClick={() => setTrucoToDelete(truco)} className="absolute top-2 right-2 bg-white/70 backdrop-blur-sm rounded-full p-1.5 text-red-600 hover:bg-white z-10 opacity-0 group-hover:opacity-100 transition-opacity">
                                <TrashIcon />
                            </button>
                            {truco.type === 'foto' ? (
                                <img src={truco.fileUrl} alt={truco.title} className="w-full h-48 object-cover cursor-pointer" onClick={() => setLightboxContent({ url: truco.fileUrl, type: 'image/' })} />
                            ) : (
                                <div className="relative w-full h-48 bg-black" onClick={() => setLightboxContent({ url: truco.fileUrl, type: 'video/' })}>
                                    <video src={truco.fileUrl} className="w-full h-full object-cover"></video>
                                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40">
                                        <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd"></path></svg>
                                    </div>
                                </div>
                            )}
                            <div className="p-4">
                                <h3 className="font-bold text-gray-800">{truco.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{truco.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-20 bg-gray-50 rounded-lg">
                    <LightBulbIcon />
                    <p className="text-gray-500 mt-2">No se han encontrado {activeTab}.</p>
                    <p className="text-sm text-gray-400">Empieza añadiendo tu primer truco con {activeTab === 'fotos' ? 'una imagen' : 'un vídeo'}.</p>
                </div>
            )}

            <AddTrucoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onTrucoAdded={() => setIsModalOpen(false)} user={user} />
            <ConfirmationModal
                isOpen={!!trucoToDelete}
                onClose={() => setTrucoToDelete(null)}
                onConfirm={handleDelete}
                title="Confirmar Borrado"
                message={`¿Estás seguro de que quieres borrar el truco "${trucoToDelete?.title}"?`}
            />
        </div>
    );
};


const PlaceholderPage = ({ title }) => (
    <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">{title}</h2>
        <div className="bg-white p-10 rounded-lg shadow-md text-center">
            <p className="text-gray-600">Esta sección está en construcción.</p>
            <p className="text-gray-500">Aquí podrás gestionar {title.toLowerCase()}.</p>
        </div>
    </div>
);

const UserManagementPage = ({ user }) => {
    const [users, setUsers] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const q = query(collection(db, getCollectionPath(user.uid, 'users')));
        const unsub = onSnapshot(q, (snapshot) => {
            const userList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setUsers(userList);
        });
        return () => unsub();
    }, [user.uid]);

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Gestión de Usuarios</h2>
                    <p className="text-gray-500 mt-1">Añade, edita o elimina usuarios con acceso a la aplicación.</p>
                </div>
                <button onClick={() => setIsModalOpen(true)} className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 flex items-center transition-transform transform hover:scale-105 w-full sm:w-auto justify-center">
                    <PlusCircleIcon /> Añadir Usuario
                </button>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <thead className="border-b-2 border-gray-200 bg-gray-50">
                            <tr>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Correo Electrónico</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Rol</th>
                                <th className="p-3 text-right text-sm font-semibold text-gray-500">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length > 0 ? (
                                users.map(user => (
                                    <tr key={user.id} className="border-b border-gray-100">
                                        <td className="p-3 text-sm">{user.email}</td>
                                        <td className="p-3 text-sm">{user.role}</td>
                                        <td className="p-3 text-right">
                                            <button className="text-indigo-600 hover:text-indigo-900 mr-4">Editar</button>
                                            <button className="text-red-600 hover:text-red-900">Borrar</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center py-8 text-gray-500">No se encontraron usuarios.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* AddUserModal would be rendered here */}
        </div>
    );
};

const CorreduriaPage = ({ user }) => {
    const [corredurias, setCorredurias] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemToEdit, setItemToEdit] = useState(null);
    const [itemToDelete, setItemToDelete] = useState(null);

    useEffect(() => {
        const q = query(collection(db, getCollectionPath(user.uid, 'corredurias')));
        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setCorredurias(data);
        });
        return () => unsub();
    }, [user.uid]);

    const handleOpenModal = (item = null) => {
        setItemToEdit(item);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setItemToEdit(null);
        setIsModalOpen(false);
    };

    const handleDelete = async () => {
        if (itemToDelete) {
            await deleteDoc(doc(db, getCollectionPath(user.uid, 'corredurias'), itemToDelete.id));
            setItemToDelete(null);
        }
    };

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Corredurías de Seguros</h2>
                <button onClick={() => handleOpenModal()} className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 flex items-center transition-transform transform hover:scale-105 w-full sm:w-auto justify-center">
                    <PlusCircleIcon /> Añadir Correduría
                </button>
            </div>

            <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell">Contacto Principal</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">Teléfonos</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {corredurias.map(item => (
                                <tr key={item.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm font-semibold text-gray-900">{item.nombre}</div>
                                        <div className="text-sm text-gray-500 md:hidden">{item.telefonoMovil}</div>
                                        <div className="text-sm text-gray-500 sm:hidden">{item.contactoPrincipal}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap hidden sm:table-cell">
                                        <div className="text-sm text-gray-900">{item.contactoPrincipal}</div>
                                        <div className="text-sm text-gray-500">{item.email}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap hidden md:table-cell">
                                        <div className="text-sm text-gray-900">Fijo: {item.telefonoFijo}</div>
                                        <div className="text-sm text-gray-500">Móvil: {item.telefonoMovil}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                        <button onClick={() => handleOpenModal(item)} className="text-orange-600 hover:text-orange-900 p-2"><PencilIcon /></button>
                                        <button onClick={() => setItemToDelete(item)} className="text-red-600 hover:text-red-900 p-2 ml-2"><TrashIcon /></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {corredurias.length === 0 && (
                    <div className="text-center py-12">
                        <p className="text-gray-500">No se han encontrado corredurías.</p>
                    </div>
                )}
            </div>

            <AddCorreduriaModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onSaved={handleCloseModal}
                itemToEdit={itemToEdit}
                user={user}
            />
            <ConfirmationModal
                isOpen={!!itemToDelete}
                onClose={() => setItemToDelete(null)}
                onConfirm={handleDelete}
                title="Confirmar Borrado"
                message={`¿Estás seguro de que quieres borrar la correduría "${itemToDelete?.nombre}"? Esta acción no se puede deshacer.`}
            />
        </div>
    );
};

const AddCorreduriaModal = ({ isOpen, onClose, onSaved, itemToEdit, user }) => {
    const [nombre, setNombre] = useState('');
    const [contactoPrincipal, setContactoPrincipal] = useState('');
    const [contactoSecundario, setContactoSecundario] = useState('');
    const [email, setEmail] = useState('');
    const [telefonoFijo, setTelefonoFijo] = useState('');
    const [telefonoMovil, setTelefonoMovil] = useState('');
    const [direccion, setDireccion] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (itemToEdit) {
            setNombre(itemToEdit.nombre || '');
            setContactoPrincipal(itemToEdit.contactoPrincipal || '');
            setContactoSecundario(itemToEdit.contactoSecundario || '');
            setEmail(itemToEdit.email || '');
            setTelefonoFijo(itemToEdit.telefonoFijo || '');
            setTelefonoMovil(itemToEdit.telefonoMovil || '');
            setDireccion(itemToEdit.direccion || '');
        } else {
            setNombre(''); setContactoPrincipal(''); setContactoSecundario('');
            setEmail(''); setTelefonoFijo(''); setTelefonoMovil(''); setDireccion('');
        }
    }, [itemToEdit, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nombre || !contactoPrincipal || !telefonoFijo || !telefonoMovil) {
            setError('Los campos con * son obligatorios.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        const data = {
            nombre: nombre.toUpperCase(),
            contactoPrincipal: contactoPrincipal.toUpperCase(),
            contactoSecundario: contactoSecundario.toUpperCase(),
            email: email.toUpperCase(),
            telefonoFijo: telefonoFijo.toUpperCase(),
            telefonoMovil: telefonoMovil.toUpperCase(),
            direccion: direccion.toUpperCase(),
            updatedAt: new Date().toISOString()
        };

        try {
            if (itemToEdit) {
                const itemRef = doc(db, getCollectionPath(user.uid, 'corredurias'), itemToEdit.id);
                await updateDoc(itemRef, data);
            } else {
                data.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'corredurias')), data);
            }
            onSaved();
            onClose();
        } catch (err) {
            setError('Error al guardar. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-4">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{itemToEdit ? 'Editar Correduría' : 'Añadir Correduría'}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>
                    <p className="text-sm text-gray-600">Introduce los detalles de la nueva correduría.</p>

                    <div className="space-y-4">
                        <InputField label="Nombre de la Correduría *" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre de la empresa corredora" required />
                        <InputField label="Contacto Principal *" value={contactoPrincipal} onChange={e => setContactoPrincipal(e.target.value)} placeholder="Nombre del primer contacto" required />
                        <InputField label="Contacto Secundario (Opcional)" value={contactoSecundario} onChange={e => setContactoSecundario(e.target.value)} placeholder="Nombre del segundo contacto" />
                        <InputField label="Correo Electrónico (Opcional)" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correduria.com" />
                        <InputField label="Teléfono Fijo *" type="tel" value={telefonoFijo} onChange={e => setTelefonoFijo(e.target.value)} validationType="numeric" placeholder="Ej: 912345678" required />
                        <InputField label="Teléfono Móvil *" type="tel" value={telefonoMovil} onChange={e => setTelefonoMovil(e.target.value)} validationType="numeric" placeholder="Ej: 612345678" required />
                        <InputField label="Dirección (Opcional)" value={direccion} onChange={e => setDireccion(e.target.value)} placeholder="Dirección completa de la correduría" />
                    </div>

                    {error && <p className="text-red-600 text-sm text-center">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar Correduría'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const AddMantenimientoEquipoModal = ({ isOpen, onClose, onMantenimientoSaved, laser, mantenimientoToEdit, fromRecordatorio, user }) => {
    const [fecha, setFecha] = useState('');
    const [tipo, setTipo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [coste, setCoste] = useState('');
    const [documentoFile, setDocumentoFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            const itemToLoad = mantenimientoToEdit || fromRecordatorio;

            if (itemToLoad) {
                setFecha(itemToLoad.fecha || new Date().toISOString().split('T')[0]);
                setTipo(itemToLoad.tipo || '');
                setDescripcion(itemToLoad.descripcion || '');
                setCoste(itemToLoad.coste || '');
            } else {
                setFecha(new Date().toISOString().split('T')[0]);
                setTipo('');
                setDescripcion('');
                setCoste('');
            }
            setDocumentoFile(null);
            setError('');
        }
    }, [isOpen, mantenimientoToEdit, fromRecordatorio]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!fecha || !tipo || !coste) {
            setError('Los campos Fecha, Tipo y Coste son obligatorios.');
            return;
        }
        // NUEVA VALIDACIÓN
        if (tipo === 'Otros' && !descripcion) {
            setError('La descripción para "Otros" es obligatoria.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // --- CAMBIO DE SEGURIDAD SAAS ---
            const clientFolder = user.clientId || user.uid;
            // -------------------------------

            let documentoUrl = mantenimientoToEdit?.documentoUrl || '';
            if (documentoFile) {
                const docRef = ref(storage, `uploads/${clientFolder}/mantenimiento_equipos_docs/${Date.now()}_${documentoFile.name}`);
                await uploadBytes(docRef, documentoFile);
                documentoUrl = await getDownloadURL(docRef);
            }

            const mantenimientoData = {
                laserId: laser.id,
                laserNumero: laser.numero.toUpperCase(),
                laserNombre: `${laser.marca.toUpperCase()} ${laser.modelo.toUpperCase()}`,
                fecha,
                tipo: tipo.toUpperCase(),
                descripcion: descripcion.toUpperCase(), // Se guarda siempre
                coste,
                documentoUrl,
                updatedAt: new Date().toISOString(),
            };

            if (mantenimientoToEdit) {
                const mantRef = doc(db, getCollectionPath(user.uid, 'mantenimientos_equipos'), mantenimientoToEdit.id);
                await updateDoc(mantRef, mantenimientoData);
            } else {
                mantenimientoData.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'mantenimientos_equipos')), mantenimientoData);
            }

            if (fromRecordatorio) {
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'recordatorios_equipos'), fromRecordatorio.id));
            }

            onMantenimientoSaved(tipo.toUpperCase() === 'REVISIÓN ANUAL');
            onClose();
        } catch (err) {
            setError('Error al guardar el registro. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{mantenimientoToEdit ? 'Editar' : 'Añadir'} Mantenimiento para {laser?.marca} {laser?.modelo}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>

                    <div className="space-y-6">
                        <InputField label="Fecha *" type="date" value={fecha} onChange={e => setFecha(e.target.value)} required />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Mantenimiento *</label>
                            <select value={tipo} onChange={e => setTipo(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="" disabled>Selecciona un tipo</option>
                                {MANTENIMIENTO_TIPOS_EQUIPOS.map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {tipo === 'Otros' ? 'Descripción (Obligatorio) *' : 'Descripción (Opcional)'}
                            </label>
                            <textarea
                                value={descripcion}
                                onChange={e => setDescripcion(e.target.value)}
                                rows="3"
                                placeholder="Describe el trabajo realizado..."
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                                required={tipo === 'Otros'} // El campo es requerido si el tipo es "Otros"
                            />
                        </div>
                        <InputField label="Coste (€) *" type="text" value={coste} onChange={e => setCoste(e.target.value)} validationType="decimal" placeholder="150" required />
                        <FileInput label="Documento de Coste (PDF/Foto)" file={documentoFile} setFile={setDocumentoFile} accept="application/pdf,image/*" maxSizeMB={5} />
                    </div>

                    {error && <p className="text-red-600 text-sm text-center mt-4">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-6">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar Registro'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
const AddRecordatorioEquipoModal = ({ isOpen, onClose, onRecordatorioSaved, laser, recordatorioToEdit, user }) => {
    const [tipo, setTipo] = useState('');
    const [descripcion, setDescripcion] = useState(''); // Cambiado de otroDescripcion
    const [fecha, setFecha] = useState('');
    const [hora, setHora] = useState('');
    const [aviso, setAviso] = useState('7');
    const [customAviso, setCustomAviso] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (recordatorioToEdit) {
            const tipoGuardado = recordatorioToEdit.tipo || '';
            let parsedDescripcion = recordatorioToEdit.descripcion || '';

            if (tipoGuardado.startsWith('OTROS:')) {
                setTipo('Otros');
                if (!parsedDescripcion) {
                    parsedDescripcion = tipoGuardado.replace('OTROS: ', '');
                }
            } else {
                const tipoOriginal = MANTENIMIENTO_TIPOS_EQUIPOS.find(
                    t => t.toUpperCase() === tipoGuardado.toUpperCase()
                );
                setTipo(tipoOriginal || '');
            }

            setDescripcion(parsedDescripcion);
            setFecha(recordatorioToEdit.fecha || '');
            setHora(recordatorioToEdit.hora || '');

            const predefinedAvisos = ['1', '3', '7', '14', '30'];
            if (predefinedAvisos.includes(recordatorioToEdit.aviso)) {
                setAviso(recordatorioToEdit.aviso);
                setCustomAviso('');
            } else {
                setAviso('custom');
                setCustomAviso(recordatorioToEdit.aviso || '');
            }
        } else {
            setTipo('');
            setDescripcion('');
            setFecha('');
            setHora('');
            setAviso('7');
            setCustomAviso('');
        }
    }, [recordatorioToEdit, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!tipo || !fecha) {
            setError('El tipo y la fecha son obligatorios.');
            return;
        }
        if (tipo === 'Otros' && !descripcion) {
            setError('Por favor, añade una descripción para "Otros", es obligatorio.');
            return;
        }
        if (aviso === 'custom' && !customAviso) {
            setError('Por favor, introduce un número de días para el aviso personalizado.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            const finalAviso = aviso === 'custom' ? customAviso : aviso;

            const recordatorioData = {
                laserId: laser.id,
                laserNumero: laser.numero.toUpperCase(),
                laserNombre: `${laser.marca.toUpperCase()} ${laser.modelo.toUpperCase()}`,
                tipo: tipo.toUpperCase(),
                descripcion: descripcion.toUpperCase(),
                fecha,
                hora,
                aviso: finalAviso,
                status: 'pending',
                updatedAt: new Date().toISOString(),
            };

            if (recordatorioToEdit) {
                const recordatorioRef = doc(db, getCollectionPath(user.uid, 'recordatorios_equipos'), recordatorioToEdit.id);
                await updateDoc(recordatorioRef, recordatorioData);
            } else {
                recordatorioData.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'recordatorios_equipos')), recordatorioData);
            }

            onRecordatorioSaved();
            onClose();
        } catch (err) {
            setError('Error al guardar el recordatorio. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="p-6 md:p-8">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{recordatorioToEdit ? 'Editar' : 'Añadir Nuevo'} Recordatorio para Equipo</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>
                    <p className="text-sm text-gray-600 mb-6">Establece una fecha y hora futuras para un recordatorio de mantenimiento del láser.</p>

                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Recordatorio *</label>
                            <select value={tipo} onChange={e => setTipo(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="" disabled>Selecciona un tipo</option>
                                {MANTENIMIENTO_TIPOS_EQUIPOS.map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </div>
                        <InputField
                            label={tipo === 'Otros' ? 'Descripción (Obligatorio para "Otros") *' : 'Descripción (Opcional)'}
                            type="text"
                            value={descripcion}
                            onChange={e => setDescripcion(e.target.value)}
                            placeholder="Ej: Recordar pedir presupuesto de lente..."
                            required={tipo === 'Otros'}
                        />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <InputField label="Fecha" type="date" value={fecha} onChange={e => setFecha(e.target.value)} required />
                            <InputField label="Hora (Opcional)" type="time" value={hora} onChange={e => setHora(e.target.value)} />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Avisar con antelación</label>
                            <select value={aviso} onChange={e => setAviso(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="1">1 día antes</option>
                                <option value="3">3 días antes</option>
                                <option value="7">7 días antes</option>
                                <option value="14">2 semanas antes</option>
                                <option value="30">1 mes antes</option>
                                <option value="custom">Personalizar</option>
                            </select>
                        </div>
                        {aviso === 'custom' && (
                            <InputField label="Días de aviso personalizados" type="number" value={customAviso} onChange={e => setCustomAviso(e.target.value)} validationType="numeric" placeholder="Ej: 5" required />
                        )}
                    </div>

                    {error && <p className="text-red-600 text-sm text-center mt-4">{error}</p>}

                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-6">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
const AddGolpeMultaModal = ({ isOpen, onClose, onSaved, itemToEdit, furgonetas, conductores, user }) => {
    const [tipo, setTipo] = useState('Golpe');
    const [fecha, setFecha] = useState('');
    const [conductor, setConductor] = useState('');
    const [furgonetaId, setFurgonetaId] = useState('');
    const [comentarios, setComentarios] = useState('');
    const [archivos, setArchivos] = useState([null, null, null, null]);
    const [existingFiles, setExistingFiles] = useState([]);
    const [isRecording, setIsRecording] = useState(false);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            // Resetear estado al abrir
            setError('');
            setIsSubmitting(false);
            setArchivos([null, null, null, null]);
            setAudioBlob(null);
            setAudioUrl(null);

            if (itemToEdit) {
                // Modo Edición
                setTipo(itemToEdit.tipo || 'Golpe');
                setFecha(itemToEdit.fecha || '');
                setConductor(itemToEdit.conductor || '');
                setFurgonetaId(itemToEdit.furgonetaId || '');
                setComentarios(itemToEdit.comentarios || '');
                setExistingFiles(itemToEdit.archivos || []);
            } else {
                // Modo Creación
                setTipo('Golpe');
                setFecha(new Date().toISOString().split('T')[0]);
                setConductor('');
                setFurgonetaId('');
                setComentarios('');
                setExistingFiles([]);
            }
        }
    }, [isOpen, itemToEdit]);

    const handleAudioRecord = async () => {
        if (isRecording) {
            if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
                mediaRecorderRef.current.stop();
            }
            setIsRecording(false);
            return;
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            audioChunksRef.current = [];
            const recorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
            mediaRecorderRef.current = recorder;

            recorder.ondataavailable = event => {
                if (event.data.size > 0) audioChunksRef.current.push(event.data);
            };

            recorder.onstop = () => {
                if (audioChunksRef.current.length > 0) {
                    const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
                    setAudioBlob(blob);
                    setAudioUrl(URL.createObjectURL(blob));
                }
                stream.getTracks().forEach(track => track.stop());
            };

            recorder.start();
            setIsRecording(true);
        } catch (err) {
            setError("No se pudo acceder al micrófono. Asegúrate de dar permiso en el navegador.");
            console.error("Error de micrófono:", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!fecha || !conductor || !furgonetaId || !tipo) {
            setError('Los campos con * son obligatorios.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // --- CAMBIO DE SEGURIDAD SAAS ---
            const clientFolder = user.clientId || user.uid;
            // -------------------------------

            const filesToUpload = archivos.filter(Boolean);
            let audioInfo = null;
            if (audioBlob) {
                const audioRef = ref(storage, `uploads/${clientFolder}/golpes_multas/audio_${Date.now()}.webm`);
                await uploadBytes(audioRef, audioBlob);
                const url = await getDownloadURL(audioRef);
                audioInfo = { url, type: audioBlob.type, name: 'Grabación de audio' };
            }

            const fileInfos = await Promise.all(
                filesToUpload.map(async (file) => {
                    const fileRef = ref(storage, `uploads/${clientFolder}/golpes_multas/${Date.now()}_${file.name}`);
                    await uploadBytes(fileRef, file);
                    const url = await getDownloadURL(fileRef);
                    return { url, type: file.type, name: file.name };
                })
            );

            const furgonetaSeleccionada = furgonetas.find(f => f.id === furgonetaId);
            const finalArchivos = [...existingFiles, ...fileInfos];
            if (audioInfo) finalArchivos.push(audioInfo);

            const data = {
                fecha, tipo,
                conductor: conductor.toUpperCase(),
                furgonetaId,
                furgonetaMatricula: furgonetaSeleccionada?.matricula.toUpperCase() || '',
                comentarios: comentarios.toUpperCase(),
                archivos: finalArchivos,
                updatedAt: new Date().toISOString()
            };

            if (itemToEdit) {
                const itemRef = doc(db, getCollectionPath(user.uid, 'golpes_multas'), itemToEdit.id);
                await updateDoc(itemRef, data);
            } else {
                data.createdAt = new Date().toISOString();
                await addDoc(collection(db, getCollectionPath(user.uid, 'golpes_multas')), data);
            }

            onSaved();

        } catch (err) {
            setError('Error al guardar el parte. Inténtalo de nuevo.');
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    const setFileForIndex = (file, index) => {
        const newArchivos = [...archivos];
        newArchivos[index] = file;
        setArchivos(newArchivos);
    };

    // Si no está abierto (isOpen=false), no renderizamos nada para evitar problemas.
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4" onClick={onClose}>
            <div className="bg-orange-50 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-6" >
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">{itemToEdit ? 'Editar Parte' : 'Añadir Golpe o Multa'}</h2>
                        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800"><XIcon /></button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField label="Fecha *" type="date" value={fecha} onChange={e => setFecha(e.target.value)} required />
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Parte *</label>
                            <select value={tipo} onChange={e => setTipo(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option>Golpe</option>
                                <option>Multa</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Conductor/a *</label>
                            <select value={conductor} onChange={e => setConductor(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="" disabled>Selecciona un conductor</option>
                                {conductores.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Furgoneta (Matrícula) *</label>
                            <select value={furgonetaId} onChange={e => setFurgonetaId(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500 bg-white">
                                <option value="" disabled>Selecciona una furgoneta</option>
                                {furgonetas.map(f => <option key={f.id} value={f.id}>{f.matricula} ({f.nombreInterno})</option>)}
                            </select>
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Comentarios</label>
                        <textarea value={comentarios} onChange={e => setComentarios(e.target.value)} rows="4" placeholder="Describe el incidente, la multa, los daños, etc." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"></textarea>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Adjuntar Archivos (hasta 4)</h3>
                        <p className="text-xs text-gray-500 mb-2">Puedes subir fotos (máx 5MB) o vídeos (máx 20MB).</p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                            {[0, 1, 2, 3].map(index => {
                                const id = `golpe-file-upload-${index}`;
                                return (
                                    <div key={index}>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">{`Archivo ${index + 1}`}</label>
                                        <label htmlFor={id} className="cursor-pointer bg-white border border-gray-300 rounded-lg p-3 flex items-center justify-center text-sm text-gray-600 hover:bg-gray-50 w-full">
                                            <FileIcon />
                                            <span className="truncate">{archivos[index] ? archivos[index].name : 'Seleccionar'}</span>
                                        </label>
                                        <input id={id} type="file" className="sr-only"
                                            onChange={(e) => {
                                                let limit = 5;
                                                if (e.target.files && e.target.files[0] && e.target.files[0].type.startsWith('video/')) {
                                                    limit = 20;
                                                }
                                                handleFileProcessing(e, (file) => setFileForIndex(file, index), setError, { maxSizeMB: limit, compress: true });
                                            }}
                                            accept="image/*,video/*" />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Grabar Audio</h3>
                        <div className="flex items-center gap-4 p-4 bg-white rounded-lg border">
                            <button type="button" onClick={handleAudioRecord} className={`p-3 rounded-full flex items-center justify-center transition-colors ${isRecording ? 'bg-red-500 text-white animate-pulse' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}>
                                <MicrophoneIcon />
                            </button>
                            <div className="flex-grow">
                                {isRecording && <p className="text-red-600 font-semibold text-sm">Grabando...</p>}
                                {audioUrl && !isRecording && (
                                    <audio src={audioUrl} controls className="w-full h-10" />
                                )}
                                {!isRecording && !audioUrl && <p className="text-sm text-gray-500">Pulsa para grabar un audio</p>}
                            </div>
                        </div>
                    </div>
                    {itemToEdit && existingFiles.length > 0 && (
                        <div>
                            {/* ... (código para mostrar archivos existentes que ya tenías) ... */}
                        </div>
                    )}
                    {error && <p className="text-red-600 text-sm text-center font-bold py-2">{error}</p>}
                    <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 font-semibold">Cancelar</button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-white bg-orange-500 hover:bg-orange-600 font-semibold disabled:bg-orange-300">
                            {isSubmitting ? 'Guardando...' : (itemToEdit ? 'Guardar Cambios' : 'Guardar Parte')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
const GolpesMultasPage = ({ setLightboxContent, user }) => {
    const [partes, setPartes] = useState([]);
    const [furgonetas, setFurgonetas] = useState([]);
    const [conductores, setConductores] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemToEdit, setItemToEdit] = useState(null);
    const [itemToDelete, setItemToDelete] = useState(null);

    useEffect(() => {
        const qPartes = query(collection(db, getCollectionPath(user.uid, 'golpes_multas')));
        const unsubPartes = onSnapshot(qPartes, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
            setPartes(data);
        });

        const qFurgonetas = query(collection(db, getCollectionPath(user.uid, 'furgonetas')));
        const unsubFurgonetas = onSnapshot(qFurgonetas, (snapshot) => {
            const furgonetasData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setFurgonetas(furgonetasData);
            // Extraemos los conductores únicos de la lista de furgonetas
            const conductoresUnicos = new Set(furgonetasData.map(f => f.conductor).filter(Boolean));
            // Añadimos conductores que puedan existir en partes antiguos pero no en la lista actual
            partes.forEach(p => conductoresUnicos.add(p.conductor));
            setConductores(Array.from(conductoresUnicos).sort());
        });

        return () => {
            unsubPartes();
            unsubFurgonetas();
        };
    }, [user.uid, partes]); // Dependemos de 'partes' para actualizar la lista de conductores

    const handleOpenModal = (item = null) => {
        setItemToEdit(item);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setItemToEdit(null);
    };

    const handleDelete = async () => {
        if (itemToDelete) {
            try {
                if (itemToDelete.archivos && itemToDelete.archivos.length > 0) {
                    const deletePromises = itemToDelete.archivos.map(file => {
                        const fileRef = ref(storage, file.url);
                        return deleteObject(fileRef).catch(e => console.warn("Archivo no encontrado o ya borrado:", e));
                    });
                    await Promise.all(deletePromises);
                }
                await deleteDoc(doc(db, getCollectionPath(user.uid, 'golpes_multas'), itemToDelete.id));
                setItemToDelete(null);
            } catch (err) {
                console.error("Error al borrar el parte:", err);
                alert("Hubo un error al borrar el parte.");
            }
        }
    };

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Partes de Golpes y Multas</h2>
                    <p className="text-gray-500 mt-1">Registra y consulta todos los incidentes de la flota.</p>
                </div>
                <button onClick={() => handleOpenModal()} className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 flex items-center transition-transform transform hover:scale-105 w-full sm:w-auto justify-center">
                    <PlusCircleIcon /> Añadir Parte
                </button>
            </div>

            <div className="space-y-6">
                {partes.map(parte => (
                    <div key={parte.id} className={`bg-white p-4 sm:p-6 rounded-lg shadow-md border-l-4 ${parte.tipo === 'Golpe' ? 'border-red-500' : 'border-yellow-500'}`}>
                        <div className="flex flex-col sm:flex-row justify-between items-start">
                            <div>
                                <span className={`inline-block px-3 py-1 text-xs font-bold rounded-full text-white ${parte.tipo === 'Golpe' ? 'bg-red-500' : 'bg-yellow-500'}`}>{parte.tipo.toUpperCase()}</span>
                                <p className="text-xl font-bold text-gray-800 mt-2">Conductor: {parte.conductor}</p>
                                <p className="text-sm text-gray-500">
                                    Furgoneta: {parte.furgonetaMatricula} | Fecha: {format(parseISO(parte.fecha), 'dd MMMM yyyy', { locale: es })}
                                </p>
                            </div>
                            <div className="flex gap-2 mt-2 sm:mt-0 self-start sm:self-center">
                                <button onClick={() => handleOpenModal(parte)} className="text-orange-600 hover:text-orange-900 p-2"><PencilIcon /></button>
                                <button onClick={() => setItemToDelete(parte)} className="text-red-600 hover:text-red-900 p-2"><TrashIcon /></button>
                            </div>
                        </div>
                        {parte.comentarios && (
                            <div className="mt-4 pt-4 border-t border-gray-200">
                                <h4 className="font-semibold text-gray-700">Comentarios:</h4>
                                <p className="text-gray-600 whitespace-pre-wrap mt-1">{parte.comentarios}</p>
                            </div>
                        )}
                        {parte.archivos && parte.archivos.length > 0 && (
                            <div className="mt-4 pt-4 border-t border-gray-200">
                                <h4 className="font-semibold text-gray-700 mb-2">Archivos Adjuntos:</h4>
                                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                                    {parte.archivos.map((file, index) => (
                                        <div key={index} className="relative group">
                                            {file.type.startsWith('image/') && (<img src={file.url} alt={file.name} className="h-24 w-full object-cover rounded-md cursor-pointer" onClick={() => setLightboxContent({ url: file.url, type: 'image/' })} />)}
                                            {file.type.startsWith('video/') && (<div className="h-24 w-full bg-black rounded-md flex items-center justify-center cursor-pointer" onClick={() => setLightboxContent({ url: file.url, type: 'video/' })}> <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd"></path></svg> </div>)}
                                            {file.type.startsWith('audio/') && (<div className="h-24 w-full bg-gray-200 rounded-md flex items-center justify-center"> <audio src={file.url} controls className="w-full h-8" /> </div>)}
                                            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs p-1 truncate opacity-0 group-hover:opacity-100 transition-opacity">{file.name}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))
                }
            </div>

            {isModalOpen && (
                <AddGolpeMultaModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onSaved={handleCloseModal} // Cuando guarde, también cierra el modal
                    itemToEdit={itemToEdit}
                    furgonetas={furgonetas}
                    conductores={conductores}
                    user={user}
                />
            )}

            <ConfirmationModal
                isOpen={!!itemToDelete}
                onClose={() => setItemToDelete(null)}
                onConfirm={handleDelete}
                title="Confirmar Borrado"
                message={`¿Estás seguro de que quieres borrar este parte? Todos los archivos asociados se eliminarán permanentemente. Esta acción no se puede deshacer.`}
            />
        </div>
    );
};
const MainContent = ({ currentPage, user, isAdmin, setCurrentPage, selectedItemId, setLightboxContent, toggleSidebar, pageOptions, isSidebarOpen, onCloseCalendar, onOpenItvAppointmentModal, onCancelItvAppointment, onDeleteInsuranceReminder, auth }) => {
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    // Estado para gestionar qué banners se han ocultado
    // Se ha cambiado para que el estado solo dure la sesión actual y no se guarde en localStorage.
    // De esta forma, si el usuario recarga la página, los banners relevantes vuelven a aparecer.
    // La ocultación permanente solo ocurre si se elimina el recordatorio subyacente (ej. desde el banner de seguro).
    const [dismissedBanners, setDismissedBanners] = useState([]);

    // --- LÓGICA DE RECORDATORIOS AUTOMÁTICOS MEJORADA ---
    useEffect(() => {
        const checkAndCreateReminders = async () => {
            console.log("Iniciando revisión de recordatorios automáticos...");
            const now = new Date();

            // 1. Obtenemos la lista de furgonetas una sola vez.
            const furgonetasQuery = query(collection(db, getCollectionPath(user.uid, 'furgonetas')));
            const furgonetasSnapshot = await getDocs(furgonetasQuery);

            let bannerEvents = []; // Array para los banners visuales

            // 2. Usamos Promise.all para manejar las comprobaciones asíncronas dentro del bucle
            await Promise.all(furgonetasSnapshot.docs.map(async (furgonetaDoc) => {
                const furgoneta = { id: furgonetaDoc.id, ...furgonetaDoc.data() };

                // --- LÓGICA PARA LA ITV ---
                if (furgoneta.itvDueDate && furgoneta.itvFrequency) {
                    try {
                        let nextItvDate = parseISO(furgoneta.itvDueDate);
                        const frequencyMonths = furgoneta.itvFrequency === 'Cada 6 Meses' ? 6 : 12;

                        // Calculamos la próxima fecha de ITV futura
                        while (nextItvDate < now) {
                            nextItvDate = addMonths(nextItvDate, frequencyMonths);
                        }

                        const reminderStartDate = subMonths(nextItvDate, 2);

                        // Si estamos en la ventana de 2 meses para el aviso
                        if (isWithinInterval(now, { start: reminderStartDate, end: nextItvDate })) {
                            // Añadimos el evento para el BANNER VISUAL
                            bannerEvents.push({
                                id: `itv-banner-${furgoneta.id}-${format(nextItvDate, 'yyyy-MM-dd')}`,
                                title: `ITV de ${furgoneta.matricula} vence el ${format(nextItvDate, 'dd/MM/yyyy')}. ¿Agendar cita?`,
                                eventType: 'itv-due', // Tipo de evento para el banner
                                furgoneta: furgoneta, // Pasamos el objeto completo
                            });

                            // AHORA, LA LÓGICA PARA CREAR EL RECORDATORIO PERMANENTE
                            const reminderUniqueId = `autogen-itv-${furgoneta.id}-${format(nextItvDate, 'yyyy-MM-dd')}`;
                            const remindersRef = collection(db, getCollectionPath(user.uid, 'recordatorios_furgos'));
                            const q = query(remindersRef, where("sourceEventId", "==", reminderUniqueId));
                            const existingReminderSnapshot = await getDocs(q);

                            // Si no existe un recordatorio permanente, lo creamos
                            if (existingReminderSnapshot.empty) {
                                console.log(`Creando recordatorio de ITV para ${furgoneta.matricula}...`);
                                const recordatorioData = {
                                    furgonetaId: furgoneta.id,
                                    furgonetaMatricula: furgoneta.matricula.toUpperCase(),
                                    furgonetaNombre: (furgoneta.nombreInterno || furgoneta.nombre).toUpperCase(),
                                    tipos: ['ITV'],
                                    fecha: format(nextItvDate, 'yyyy-MM-dd'),
                                    hora: '',
                                    aviso: '14', // Aviso por defecto a los 14 días
                                    status: 'pending',
                                    sourceEventId: reminderUniqueId, // Guardamos el ID único para no duplicar
                                    createdAt: new Date().toISOString(),
                                    updatedAt: new Date().toISOString(),
                                };
                                await addDoc(remindersRef, recordatorioData);
                            }
                        }
                    } catch (e) {
                        console.error("Error procesando ITV para:", furgoneta.matricula, e);
                    }
                }

                // --- LÓGICA PARA EL SEGURO ---
                if (furgoneta.latestPolicy?.dueDate) {
                    try {
                        const dueDate = parseISO(furgoneta.latestPolicy.dueDate);
                        const reminderStartDate = subMonths(dueDate, 2);

                        // Primero, comprobamos si el recordatorio ha sido descartado permanentemente para este ciclo.
                        const reminderUniqueId = `autogen-seguro-${furgoneta.id}-${furgoneta.latestPolicy.dueDate}`;
                        const isPermanentlyDismissed = localStorage.getItem(reminderUniqueId);

                        // Si está descartado, no hacemos nada más para este seguro.
                        if (isPermanentlyDismissed) {
                            return; // Salta a la siguiente iteración del map.
                        }

                        // Si no está descartado y estamos en el periodo de aviso, creamos el banner y el recordatorio en BD si es necesario.
                        if (isWithinInterval(now, { start: reminderStartDate, end: dueDate })) {
                            // Añadimos el evento para el BANNER VISUAL
                            bannerEvents.push({
                                id: `insurance-banner-${furgoneta.id}`,
                                title: `Recuerda: Seguro de ${furgoneta.matricula} vence el ${format(dueDate, 'dd/MM/yyyy')}`,
                                eventType: 'insurance-due', // Tipo de evento genérico
                                furgoneta: furgoneta,
                            });

                            // AHORA, LA LÓGICA PARA CREAR EL RECORDATORIO PERMANENTE
                            const remindersRef = collection(db, getCollectionPath(user.uid, 'recordatorios_furgos'));
                            const q = query(remindersRef, where("sourceEventId", "==", reminderUniqueId));
                            const existingReminderSnapshot = await getDocs(q);

                            if (existingReminderSnapshot.empty) {
                                console.log(`Creando recordatorio de SEGURO para ${furgoneta.matricula}...`);
                                const recordatorioData = {
                                    furgonetaId: furgoneta.id,
                                    furgonetaMatricula: furgoneta.matricula.toUpperCase(),
                                    furgonetaNombre: (furgoneta.nombreInterno || furgoneta.nombre).toUpperCase(),
                                    tipos: ['SEGURO'],
                                    fecha: furgoneta.latestPolicy.dueDate,
                                    hora: '',
                                    aviso: '14',
                                    status: 'pending',
                                    sourceEventId: reminderUniqueId,
                                    createdAt: new Date().toISOString(),
                                    updatedAt: new Date().toISOString(),
                                };
                                await addDoc(remindersRef, recordatorioData);
                            }
                        }
                    } catch (e) {
                        console.error("Error procesando Seguro para:", furgoneta.matricula, e);
                    }
                }
            }));

            // --- LÓGICA PARA RECORDATORIO DE CITA DE ITV (EL DÍA ANTES) ---
            furgonetasSnapshot.docs.forEach(doc => {
                const furgoneta = { id: doc.id, ...doc.data() };
                if (furgoneta.itvAppointmentDate && isTomorrow(parseISO(furgoneta.itvAppointmentDate))) {
                    bannerEvents.push({
                        id: `itv-appointment-reminder-${furgoneta.id}`,
                        title: `Mañana tienes la cita de la ITV para ${furgoneta.matricula} a las ${furgoneta.itvAppointmentTime}.`,
                        eventType: 'itv-appointment',
                        furgoneta: furgoneta,
                        furgonetaId: furgoneta.id, // ID para la cancelación
                    });
                }
            });

            // Lógica para los banners de "Mañana tienes..." (OPTIMIZADA)
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1); // Establece el día de mañana
            const twoDaysFromNow = new Date(today);
            twoDaysFromNow.setDate(today.getDate() + 2); // Hasta dos días en el futuro

            const collectionsForUpcoming = [
                { name: 'recordatorios_furgos', type: 'furgoneta', assetPropName: 'furgonetaId', assetNameProp: 'furgonetaNombre', typesProp: 'tipos' },
                { name: 'recordatorios_equipos', type: 'laser', assetPropName: 'laserId', assetNameProp: 'laserNombre', typesProp: 'tipo' }
            ];

            const upcomingEventsPromises = collectionsForUpcoming.map(async (coll) => {
                // Consulta solo los recordatorios con fecha entre hoy y pasado mañana (margen para errores de hora/zona)
                const q = query(
                    collection(db, getCollectionPath(user.uid, coll.name)),
                    where("fecha", ">=", format(today, 'yyyy-MM-dd')),
                    where("fecha", "<=", format(twoDaysFromNow, 'yyyy-MM-dd'))
                );
                const snapshot = await getDocs(q);
                return snapshot.docs.map(doc => {
                    const data = doc.data();
                    // Volvemos a verificar 'isTomorrow' para ser precisos con el mensaje
                    if (!data.fecha || !isTomorrow(parseISO(data.fecha))) return null;

                    let assetIdentifier;
                    if (coll.type === 'furgoneta') {
                        assetIdentifier = `la furgoneta ${data.furgonetaMatricula || data.furgonetaNombre || 'desconocida'}`;
                    } else {
                        assetIdentifier = `el láser Nº ${data.laserNumero || data.laserNombre || 'desconocido'}`;
                    }

                    const tipo = Array.isArray(data[coll.typesProp]) ? data[coll.typesProp].join(', ') : data[coll.typesProp];
                    const hora = data.hora ? ` a las ${data.hora}` : '';
                    const title = `Mañana tienes un recordatorio (${tipo}) para ${assetIdentifier}${hora}.`;
                    return { id: doc.id, date: data.fecha, title };
                }).filter(Boolean);
            });

            const tomorrowEvents = (await Promise.all(upcomingEventsPromises)).flat();

            // Combinamos todos los eventos para los banners
            setUpcomingEvents([...tomorrowEvents, ...bannerEvents]);
        };

        // Se llama a la función principal al cargar el componente
        checkAndCreateReminders();

        // Se establece un intervalo para que se vuelva a comprobar cada 6 horas
        const intervalId = setInterval(checkAndCreateReminders, 6 * 60 * 60 * 1000);

        // Se limpia el intervalo cuando el componente se desmonta
        return () => clearInterval(intervalId);

    }, [user.uid]); // No añadir más dependencias para que solo se ejecute una vez y luego por intervalo

    const handleManualClick = () => {
        if (currentPage === 'manual') {
            // Si ya estamos en el manual, volvemos a la página anterior guardada
            const lastPage = sessionStorage.getItem('lastKnownPage') || 'inicio';
            const lastItemId = sessionStorage.getItem('lastKnownItemId');
            setCurrentPage(lastPage, lastItemId);
        } else {
            // Si no estamos en el manual, vamos a él
            setCurrentPage('manual');
        }
    };

    const handleDismissBanner = (bannerId) => {
        setDismissedBanners(prev => [...prev, bannerId]);
    };


    const renderContent = () => {
        switch (currentPage) {
            case 'inicio':
                return <DashboardPage onSelectItem={(type, id) => {
                    if (type === 'furgonetaDetail') { setCurrentPage('furgonetaDetail', id); }
                    else if (type === 'laserDetail') { setCurrentPage('laserDetail', id); }
                }} setCurrentPage={setCurrentPage} user={user} />;
            case 'manual':
                return <ManualPage />;
            case 'furgonetas':
                return <FurgonetasPage onSelectItem={(id) => setCurrentPage('furgonetaDetail', id)} setCurrentPage={setCurrentPage} user={user} />;
            case 'furgonetaDetail':
                return <FurgonetaDetailPage furgonetaId={selectedItemId} onBack={() => setCurrentPage('furgonetas')} setLightboxContent={setLightboxContent} pageOptions={pageOptions} user={user} />;
            case 'talleres':
                return <TalleresPage user={user} />;
            case 'calendar':
                return <CalendarPage setCurrentPage={setCurrentPage} onCloseCalendar={onCloseCalendar} user={user} />;
            case 'mantenimiento_furgos':
                return <MantenimientoFurgosPage user={user} />;
            case 'golpes_multas':
                return <GolpesMultasPage setLightboxContent={setLightboxContent} user={user} />
            case 'recordatorios_furgos':
                return <RecordatoriosPage tipo="furgos" user={user} />;
            case 'equipos':
                return <EquiposPage onSelectItem={(id) => setCurrentPage('laserDetail', id)} setCurrentPage={setCurrentPage} user={user} pageOptions={pageOptions} />;
            case 'laserDetail':
                return <EquipoDetailPage laserId={selectedItemId} onBack={() => setCurrentPage('equipos')} setCurrentPage={setCurrentPage} pageOptions={pageOptions} user={user} />;
            case 'mantenimiento_equipos':
                return <MantenimientoLaseresPage user={user} />;
            case 'users':
                return isAdmin ? <UserManagementPage user={user} /> : <PlaceholderPage title="Acceso Denegado" />;
            case 'correduria_seguros':
                return <CorreduriaPage user={user} />;
            case 'recordatorios_equipos':
                return <RecordatoriosPage tipo="equipos" user={user} />;
            case 'trucos_equipos':
                return <TrucosMilesmanPage setLightboxContent={setLightboxContent} user={user} />;
            default:
                return <DashboardPage onSelectItem={(type, id) => {
                    if (type === 'furgonetaDetail') { setCurrentPage('furgonetaDetail', id); }
                    else if (type.startsWith('equipmentDetail')) { const typeId = type.split('/')[1]; setCurrentPage('equipmentDetail', id, { equipmentTypeId: typeId }); }
                }} setCurrentPage={setCurrentPage} />;
        }
    };

    const visibleEvents = upcomingEvents.filter(event => !dismissedBanners.includes(event.id));

    return (
        <main className={`flex-1 p-4 sm:p-6 md:p-8 bg-gray-100 ${isSidebarOpen && window.innerWidth < 1024 ? 'overflow-hidden' : 'overflow-y-auto'}`}>
            <UpcomingEventBanner
                events={visibleEvents.filter(event => !dismissedBanners.includes(event.id))}
                onDismiss={handleDismissBanner}
                onOpenItvAppointmentModal={onOpenItvAppointmentModal}
                onCancelItvAppointment={onCancelItvAppointment}
                onDeleteInsuranceReminder={onDeleteInsuranceReminder}
            />
            <div className="flex justify-between items-center mb-6 relative">
                <button onClick={toggleSidebar} className="lg:hidden text-gray-600 hover:text-gray-900">
                    <MenuIcon />
                </button>
                <div className="flex-grow flex justify-end items-center gap-2 sm:gap-4">
                    <button onClick={() => setCurrentPage('inicio')} className="flex items-center bg-orange-500 text-white shadow-sm border rounded-lg px-2 sm:px-4 py-2 text-sm font-semibold hover:bg-orange-600">
                        <HomeIcon />
                        <span className="ml-2 hidden sm:inline">Inicio</span>
                    </button>
                    <button onClick={handleManualClick} className={`flex items-center shadow-sm border rounded-lg px-2 sm:px-4 py-2 text-sm font-semibold transition-colors ${currentPage === 'manual' ? 'bg-orange-100 text-orange-700 border-orange-300' : 'bg-white text-gray-700 hover:bg-gray-50'}`}>
                        <BookOpenIcon />
                        <span className="ml-2 hidden sm:inline">Manual</span>
                    </button>
                    <button onClick={() => setCurrentPage('calendar')} className="flex items-center bg-white shadow-sm border rounded-lg px-2 sm:px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50">
                        <CalendarIcon />
                        <span className="ml-2 hidden sm:inline">Calendario</span>
                    </button>
                </div>
            </div>
            {renderContent()}
        </main>
    );
};

const DashboardPage = ({ onSelectItem, setCurrentPage, user }) => {
    // Referencias para los componentes que se cargarán de forma diferida
    const [furgonetasRef, furgonetasInView] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [laseresRef, laseresInView] = useInView({ triggerOnce: true, threshold: 0.1 });

    return (
        <div className="space-y-8">
            <div className="bg-white p-4 sm:p-6 rounded-xl shadow-md" ref={furgonetasRef}>
                {furgonetasInView ? (
                    <FurgonetasPage onSelectItem={(id) => onSelectItem('furgonetaDetail', id)} setCurrentPage={setCurrentPage} user={user} />
                ) : (
                    <div className="h-48 flex items-center justify-center text-gray-500">Cargando furgonetas...</div>
                )}
            </div>
            <div className="bg-white p-4 sm:p-6 rounded-xl shadow-md" ref={laseresRef}>
                {laseresInView ? (
                    <EquiposPage onSelectItem={(id) => onSelectItem('laserDetail', id)} setCurrentPage={setCurrentPage} user={user} />
                ) : (
                    <div className="h-48 flex items-center justify-center text-gray-500">Cargando equipos...</div>
                )}
            </div>
        </div>
    );
};


const RecordatoriosPage = ({ tipo, user }) => {
    const [recordatorios, setRecordatorios] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [itemToEdit, setItemToEdit] = useState(null);
    const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [linkedAsset, setLinkedAsset] = useState(null); // To store furgoneta/laser object for modals
    const [isMantenimientoModalOpen, setIsMantenimientoModalOpen] = useState(false); // For "Hecho" button
    const [descriptionModalContent, setDescriptionModalContent] = useState(null); // Para el modal de descripción

    const collectionName = `recordatorios_${tipo}`;
    useEffect(() => {
        const q = query(collection(db, getCollectionPath(user.uid, collectionName)));
        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setRecordatorios(data);
        });
        return () => unsub();
    }, [collectionName, user.uid]);

    const handleEditClick = async (recordatorio) => {
        setItemToEdit(recordatorio); // Guardamos el recordatorio a editar
        // Fetch the linked furgoneta or laser data
        const assetId = tipo === 'furgos' ? recordatorio.furgonetaId : recordatorio.laserId;
        const assetCollectionName = tipo === 'furgos' ? 'furgonetas' : 'equipos';

        if (assetId) {
            const docRef = doc(db, getCollectionPath(user.uid, assetCollectionName), assetId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setLinkedAsset({ id: docSnap.id, ...docSnap.data() });
                setIsEditModalOpen(true);
            } else {
                console.error("No se encontró el vehículo/láser asociado para el recordatorio:", recordatorio);
                alert("No se pudo encontrar el vehículo/equipo asociado. No se puede editar el recordatorio.");
                setLinkedAsset(null);
            }
        } else {
            alert("Recordatorio no asociado a ningún vehículo/equipo. No se puede editar.");
            setLinkedAsset(null);
        }
    };

    const handleDeleteClick = (recordatorio) => {
        setItemToDelete(recordatorio);
        setIsConfirmDeleteOpen(true);
    };

    const handleMarkReminderDone = async (recordatorio) => {
        setItemToEdit(recordatorio);
        const assetId = tipo === 'furgos' ? recordatorio.furgonetaId : recordatorio.laserId;
        const assetCollection = tipo === 'furgos' ? 'furgonetas' : 'equipos';

        if (assetId) {
            const docRef = doc(db, getCollectionPath(user.uid, assetCollection), assetId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setLinkedAsset({ id: docSnap.id, ...docSnap.data() });
                setIsMantenimientoModalOpen(true);
            } else {
                console.error("No se encontró el vehículo/láser asociado para el recordatorio:", recordatorio);
                alert("No se pudo encontrar el vehículo/equipo asociado. No se puede crear el mantenimiento.");
                setLinkedAsset(null);
            }
        } else {
            alert("Recordatorio no asociado a ningún vehículo/equipo. No se puede crear el mantenimiento.");
            setLinkedAsset(null);
        }
    };

    const confirmDelete = async () => {
        if (itemToDelete) {
            try {
                await deleteDoc(doc(db, getCollectionPath(user.uid, collectionName), itemToDelete.id));
                setIsConfirmDeleteOpen(false);
                setItemToDelete(null);
            } catch (error) {
                console.error("Error deleting recordatorio:", error);
            }
        }
    };

    const handleViewDescription = (description) => {
        setDescriptionModalContent(description);
    };

    let pageTitle = "Recordatorios";
    if (tipo === 'furgos') pageTitle = "Recordatorios para Furgonetas";
    else if (tipo === 'equipos') pageTitle = "Recordatorios para Equipos";

    return (
        <div>
            <div className="mb-6">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">{pageTitle}</h2>
            </div>
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md">
                {/* Desktop Table View */}
                <div className="overflow-x-auto hidden md:block">
                    <table className="min-w-full">
                        <thead className="border-b-2 border-gray-200 bg-gray-50">
                            <tr>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Vehículo/Equipo</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Fecha</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Tipo</th>
                                <th className="p-3 text-left text-sm font-semibold text-gray-500">Aviso</th>
                                <th className="p-3 text-center text-sm font-semibold text-gray-500">Descripción</th>
                                <th className="p-3 text-right text-sm font-semibold text-gray-500">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordatorios.length > 0 ? (
                                recordatorios.map(r => (
                                    <tr key={r.id} className="border-b border-gray-100">
                                        <td className="p-3 text-sm font-medium whitespace-nowrap">{r.furgonetaNombre || r.laserNombre}</td>
                                        <td className="p-3 text-sm whitespace-nowrap">{format(new Date(r.fecha), 'dd/MM/yyyy')}</td>
                                        <td className="p-3 text-sm">{r.tipos ? r.tipos.join(', ') : r.tipo}</td>
                                        <td className="p-3 text-sm whitespace-nowrap">
                                            {r.sourceEventId ? (
                                                <span className="font-semibold text-blue-600">Automático</span>
                                            ) : (
                                                `${r.aviso} días antes`
                                            )}
                                        </td>
                                        <td className="p-3 text-center text-sm whitespace-nowrap">
                                            {r.descripcion && (
                                                <button onClick={() => handleViewDescription(r.descripcion)} className="bg-gray-200 text-gray-700 text-xs font-bold py-1 px-2 rounded-md hover:bg-gray-300">
                                                    Ver
                                                </button>
                                            )}
                                        </td>
                                        <td className="p-3 text-right text-sm font-medium whitespace-nowrap">
                                            <button onClick={() => handleMarkReminderDone(r)} className="bg-green-500 text-white text-xs font-bold py-1 px-2 rounded-md hover:bg-green-600 transition-colors">Hecho</button>
                                            <button onClick={() => handleEditClick(r)} className="text-orange-600 hover:text-orange-900 p-2"><PencilIcon /></button>
                                            <button onClick={() => handleDeleteClick(r)} className="text-red-600 hover:text-red-900 p-2 ml-2"><TrashIcon /></button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center py-8 text-gray-500">No hay recordatorios pendientes.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {/* Mobile Card View */}
                <div className="md:hidden space-y-4 p-2 sm:p-0">
                    {recordatorios.length > 0 ? (
                        recordatorios.map(r => (
                            <div key={r.id} className="bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-200">
                                <div className="flex justify-between items-start">
                                    <div className="flex-1 overflow-hidden">
                                        <p className="font-bold text-gray-800">{r.furgonetaNombre || r.laserNombre}</p>
                                        <p className="text-sm text-gray-600">{format(new Date(r.fecha), 'dd/MM/yyyy')}</p>
                                    </div>
                                    <div className="flex gap-2">
                                        <button onClick={() => handleMarkReminderDone(r)} className="bg-green-500 text-white text-xs font-bold py-1 px-2 rounded-md hover:bg-green-600 transition-colors">Hecho</button>
                                        <button onClick={() => handleEditClick(r)} className="text-orange-600 hover:text-orange-900 p-1"><PencilIcon /></button>
                                        <button onClick={() => handleDeleteClick(r)} className="text-red-600 hover:text-red-900 p-1"><TrashIcon /></button>
                                    </div>
                                </div>
                                <div className="mt-3 border-t pt-3 space-y-1">
                                    <p className="text-sm"><span className="font-semibold text-gray-600">Tipo:</span> {r.tipos ? r.tipos.join(', ') : r.tipo}</p>
                                    <p className="text-sm">
                                        <span className="font-semibold text-gray-600">Aviso:</span>{' '}
                                        {r.sourceEventId ? (
                                            <span className="font-semibold text-blue-600">Automático</span>
                                        ) : (
                                            `${r.aviso} días antes`
                                        )}
                                    </p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center py-8 text-gray-500">No hay recordatorios pendientes.</p>
                    )}
                </div>
            </div>

            {tipo === 'furgos' && (
                <AddMantenimientoModal
                    isOpen={isMantenimientoModalOpen}
                    onClose={() => setIsMantenimientoModalOpen(false)}
                    onMantenimientoSaved={() => setIsMantenimientoModalOpen(false)}
                    furgoneta={linkedAsset} // Pass the fetched furgoneta
                    user={user}
                    fromRecordatorio={itemToEdit} // Use fromRecordatorio to pass data
                />
            )}
            {tipo === 'equipos' && (
                <AddMantenimientoEquipoModal
                    isOpen={isMantenimientoModalOpen}
                    onClose={() => setIsMantenimientoModalOpen(false)}
                    onMantenimientoSaved={() => setIsMantenimientoModalOpen(false)}
                    laser={linkedAsset} // Pass the fetched laser
                    user={user}
                    fromRecordatorio={itemToEdit} // Use fromRecordatorio to pass data
                />
            )}

            {tipo === 'furgos' && (
                <AddRecordatorioModal
                    isOpen={isEditModalOpen}
                    onClose={() => setIsEditModalOpen(false)}
                    onRecordatorioSaved={() => setIsEditModalOpen(false)}
                    furgoneta={linkedAsset} // Pass the fetched furgoneta
                    recordatorioToEdit={itemToEdit}
                    user={user}
                />
            )}
            {tipo === 'equipos' && (
                <AddRecordatorioEquipoModal
                    isOpen={isEditModalOpen}
                    onClose={() => setIsEditModalOpen(false)}
                    onRecordatorioSaved={() => setIsEditModalOpen(false)}
                    laser={linkedAsset}
                    recordatorioToEdit={itemToEdit}
                    user={user}
                />
            )}
            <ConfirmationModal
                isOpen={isConfirmDeleteOpen}
                onClose={() => setIsConfirmDeleteOpen(false)}
                onConfirm={confirmDelete}
                title="Confirmar Borrado de Recordatorio"
                message={`¿Estás seguro de que quieres borrar el recordatorio para "${itemToDelete?.furgonetaNombre || itemToDelete?.laserNombre}" sobre "${itemToDelete?.tipos?.join(', ') || itemToDelete?.tipo}"? Esta acción no se puede deshacer.`}
            />
            <InfoModal
                isOpen={!!descriptionModalContent}
                onClose={() => setDescriptionModalContent(null)}
                title="Descripción del Recordatorio"
                content={descriptionModalContent}
            />
        </div>
    );
};

export default function App() {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [currentPage, _setCurrentPage] = useState(() => sessionStorage.getItem('currentPage') || 'inicio');
    const [selectedItemId, setSelectedItemId] = useState(() => sessionStorage.getItem('selectedItemId'));
    const [loading, setLoading] = useState(true);
    const [authError, setAuthError] = useState(null); // Nuevo estado para errores de autenticación
    const [lightboxContent, setLightboxContent] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // --- NUEVOS ESTADOS PARA EL MODAL DE CITA ITV ---
    const [isItvAppointmentModalOpen, setIsItvAppointmentModalOpen] = useState(false);
    const [furgonetaForItvAppointment, setFurgonetaForItvAppointment] = useState(null);

    // --- NUEVOS ESTADOS PARA EL MODAL DE MANTENIMIENTO DESDE "ITV PASADA" ---
    const [isItvPasadaModalOpen, setIsItvPasadaModalOpen] = useState(false);
    const [furgonetaForItvPasada, setFurgonetaForItvPasada] = useState(null);


    const [pageOptions, setPageOptions] = useState(() => {
        const storedOptions = sessionStorage.getItem('pageOptions');
        return storedOptions ? JSON.parse(storedOptions) : null;
    });

    const setCurrentPage = (page, itemId = null, options = null) => {
        // Cuando navegamos al calendario o al manual, guardamos la página actual para poder volver.
        if ((page === 'calendar' && currentPage !== 'calendar') || (page === 'manual' && currentPage !== 'manual')) {
            sessionStorage.setItem('lastKnownPage', currentPage);
            if (selectedItemId) {
                sessionStorage.setItem('lastKnownItemId', selectedItemId);
            } else {
                sessionStorage.removeItem('lastKnownItemId');
            }
        }
        _setCurrentPage(page);
        setSelectedItemId(itemId);
        setPageOptions(options);
    };

    const handleCloseCalendar = () => {
        const lastPage = sessionStorage.getItem('lastKnownPage') || 'inicio';
        const lastItemId = sessionStorage.getItem('lastKnownItemId');
        setCurrentPage(lastPage, lastItemId);
    };

    // --- NUEVAS FUNCIONES PARA GESTIONAR LA CITA DE ITV ---
    const handleOpenItvAppointmentModal = (furgoneta) => {
        setFurgonetaForItvAppointment(furgoneta);
        setIsItvAppointmentModalOpen(true);
    };

    const handleSaveItvAppointment = async (furgonetaId, fecha, hora) => {
        const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), furgonetaId);
        try {
            await updateDoc(furgonetaRef, {
                itvAppointmentDate: fecha,
                itvAppointmentTime: hora
            });
            setIsItvAppointmentModalOpen(false);
        } catch (error) {
            console.error("Error al guardar la cita de la ITV:", error);
        }
    };

    const handleDeleteInsuranceReminder = async (event) => {
        if (!event || !event.furgoneta || !event.furgoneta.id || !event.furgoneta.latestPolicy?.dueDate) {
            console.error("Datos insuficientes para borrar el recordatorio de seguro.");
            return;
        }
        const furgoneta = event.furgoneta;
        const reminderUniqueId = `autogen-seguro-${furgoneta.id}-${furgoneta.latestPolicy.dueDate}`;

        try {
            const remindersRef = collection(db, getCollectionPath(user.uid, 'recordatorios_furgos'));
            const q = query(remindersRef, where("sourceEventId", "==", reminderUniqueId));
            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                const deletePromises = snapshot.docs.map(doc => deleteDoc(doc.ref));
                await Promise.all(deletePromises);
                console.log(`Eliminado ${snapshot.size} recordatorio(s) de seguro para ${furgoneta.matricula}.`);
            } else {
                console.warn(`No se encontró un recordatorio de seguro para eliminar con sourceEventId: ${reminderUniqueId}`);
            }
            // Guardamos una marca en localStorage para que no vuelva a aparecer el banner en este ciclo.
            // Al renovar la póliza, la fecha de vencimiento cambiará, generando un reminderUniqueId diferente,
            // por lo que el recordatorio del próximo año sí aparecerá.
            localStorage.setItem(reminderUniqueId, 'dismissed');

        } catch (error) {
            console.error("Error al eliminar el recordatorio de seguro:", error);
        }
    };

    const handleCancelItvAppointment = (furgoneta) => {
        if (!furgoneta || !furgoneta.id) {
            console.error("No se ha proporcionado la furgoneta para la acción 'ITV Pasada'.");
            return;
        }
        setFurgonetaForItvPasada(furgoneta);
        setIsItvPasadaModalOpen(true);
    };

    const handleItvMantenimientoSaved = async () => {
        // Esta función se llama DESPUÉS de que el modal de mantenimiento guarda el registro.
        // Ahora actualizamos la furgoneta con la nueva fecha de ITV.
        if (!furgonetaForItvPasada) return;

        const furgoneta = furgonetaForItvPasada;
        const furgonetaRef = doc(db, getCollectionPath(user.uid, 'furgonetas'), furgoneta.id);
        const today = new Date();
        const frequencyMonths = furgoneta.itvFrequency === 'Cada 6 Meses' ? 6 : 12;
        const newItvDueDate = addMonths(today, frequencyMonths);

        // --- START: Calculate the specific ID of the reminder to delete ---
        // This logic must exactly match the creation logic in MainContent to find the correct reminder.
        let dateForOldReminder = parseISO(furgoneta.itvDueDate);
        while (dateForOldReminder < today) {
            dateForOldReminder = addMonths(dateForOldReminder, frequencyMonths);
        }
        const oldReminderSourceId = `autogen-itv-${furgoneta.id}-${format(dateForOldReminder, 'yyyy-MM-dd')}`;
        // --- END ---

        console.log(`Actualizando furgoneta ${furgoneta.matricula} a nueva fecha ITV: ${format(newItvDueDate, 'yyyy-MM-dd')}`);
        try {
            // 1. Actualizar la furgoneta con la nueva fecha de ITV y limpiar la cita.
            await updateDoc(furgonetaRef, {
                itvDueDate: format(newItvDueDate, 'yyyy-MM-dd'),
                itvAppointmentDate: deleteField(),
                itvAppointmentTime: deleteField()
            });

            // 2. Buscar y eliminar el recordatorio automático específico que acabamos de completar.
            const remindersRef = collection(db, getCollectionPath(user.uid, 'recordatorios_furgos'));
            const q = query(remindersRef, where("sourceEventId", "==", oldReminderSourceId));

            const oldRemindersSnapshot = await getDocs(q);
            if (!oldRemindersSnapshot.empty) {
                const deletePromises = oldRemindersSnapshot.docs.map(doc => deleteDoc(doc.ref));
                await Promise.all(deletePromises);
                console.log(`Eliminado ${oldRemindersSnapshot.size} recordatorio automático de ITV para ${furgoneta.matricula}.`);
            } else {
                console.warn(`No se encontró un recordatorio para eliminar con sourceEventId: ${oldReminderSourceId}`);
            }
        } catch (error) {
            console.error("Error al actualizar la fecha de ITV y/o eliminar recordatorios:", error);
        } finally {
            // Cerramos el modal y reseteamos el estado
            setIsItvPasadaModalOpen(false);
            setFurgonetaForItvPasada(null);
        }
    };

    useEffect(() => {
        if (currentPage === 'inicio') {
            sessionStorage.removeItem('currentPage');
            sessionStorage.removeItem('selectedItemId');
            sessionStorage.removeItem('pageOptions');
        } else {
            sessionStorage.setItem('currentPage', currentPage);
            if (selectedItemId) {
                sessionStorage.setItem('selectedItemId', selectedItemId);
            } else {
                sessionStorage.removeItem('selectedItemId');
            }
            if (pageOptions) {
                sessionStorage.setItem('pageOptions', JSON.stringify(pageOptions));
            } else {
                sessionStorage.removeItem('pageOptions');
            }
        }
    }, [currentPage, selectedItemId, pageOptions]);

    // --- LÓGICA DE ARRANQUE Y AUTENTICACIÓN ---
    useEffect(() => {
        let unsubscribe;

        const initializeAuth = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            const isTokenLoginFlow = !!token;

            // PASO 1: Si hay un token, intentamos el login. La clave es que 'await' pausa la ejecución aquí.
            if (isTokenLoginFlow) {
                try {
                    await signInWithCustomToken(auth, token);
                    window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
                } catch (error) {
                    console.error("Error al iniciar sesión con el token:", error);
                    setAuthError("El pase de acceso es inválido o ha caducado.");
                    // Si el token falla, onAuthStateChanged se encargará de poner loading a false y mostrar la página de login.
                }
            }

            // PASO 2: Configuramos el oyente que reaccionará al estado de autenticación.
            // Este oyente es la ÚNICA fuente de verdad para cambiar el estado de 'loading' a 'false'
            // en un flujo de login con token.
            unsubscribe = onAuthStateChanged(auth, async (authUser) => {
                if (authUser) {
                    // --- SEGURIDAD EN TIEMPO REAL ---
                    // Si el admin desactiva el enlace mágico (borra el usuario), cerramos sesión al instante.
                    onSnapshot(doc(db, 'users', authUser.uid), (snapshot) => {
                        if (!snapshot.exists()) {
                            console.warn("Usuario desactivado remotamente. Cerrando sesión...");
                            window.location.reload();
                        }
                    });

                    const userDocRef = doc(db, "users", authUser.uid); // Asumiendo que tienes una colección 'users'
                    const userDocSnap = await getDoc(userDocRef);
                    const baseUser = { uid: authUser.uid, email: authUser.email, displayName: authUser.displayName };

                    if (userDocSnap.exists()) {
                        setUser({ ...baseUser, ...userDocSnap.data() });
                        setIsAdmin(userDocSnap.data().isAdmin === true || userDocSnap.data().email === 'info@sisinvello.com'); // Lógica de admin
                    } else {
                        setUser(baseUser);
                        setIsAdmin(baseUser.email === 'info@sisinvello.com'); // Lógica de admin para usuarios sin perfil
                    }
                } else {
                    setUser(null);
                    setIsAdmin(false);
                }
                setLoading(false); // La fuente de verdad final para el estado de carga.
            });
        };

        initializeAuth();

        // La función de limpieza se ejecutará cuando el componente se desmonte.
        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);

    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = 'data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><text x=%2250%%22 y=%2290%%22 style=%22font-size:90px;text-anchor:middle;%22>🚐</text></svg>';
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    if (loading) {
        // Muestra un spinner simple mientras se procesa la autenticación.
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <svg className="animate-spin h-12 w-12 text-orange-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            </div>
        );
    }

    if (!user) {
        return <LoginPage authError={authError} />;
    }

    return (
        <div className="flex h-screen bg-gray-100 font-sans overflow-hidden">
            <style>{`
                @keyframes ring {
                    0% { transform: rotate(0); } 10% { transform: rotate(30deg); }
                    20% { transform: rotate(-28deg); } 30% { transform: rotate(34deg); }
                    40% { transform: rotate(-32deg); } 50% { transform: rotate(30deg); }
                    60% { transform: rotate(-28deg); } 70% { transform: rotate(34deg); }
                    80% { transform: rotate(-32deg); } 90% { transform: rotate(30deg); }
                    100% { transform: rotate(0); }
                }
                .animate-bell { animation: ring 1.5s ease-in-out infinite; }
            `}</style>
            <Sidebar
                user={user}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                isOpen={isSidebarOpen}
                setIsOpen={setIsSidebarOpen}
            />
            <div className="flex-1 flex flex-col">
                <MainContent
                    currentPage={currentPage}
                    user={user}
                    isAdmin={isAdmin}
                    setCurrentPage={setCurrentPage}
                    selectedItemId={selectedItemId}
                    setLightboxContent={setLightboxContent}
                    toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
                    pageOptions={pageOptions}
                    isSidebarOpen={isSidebarOpen}
                    onCloseCalendar={handleCloseCalendar}
                    onOpenItvAppointmentModal={handleOpenItvAppointmentModal} // Prop para abrir modal de cita
                    onCancelItvAppointment={handleCancelItvAppointment} // Prop para cancelar cita
                    onDeleteInsuranceReminder={handleDeleteInsuranceReminder} // Prop para borrar recordatorio de seguro
                    auth={auth}
                />
            </div>
            <Lightbox content={lightboxContent} onClose={() => setLightboxContent(null)} />
            <SetItvAppointmentModal
                isOpen={isItvAppointmentModalOpen}
                onClose={() => setIsItvAppointmentModalOpen(false)}
                onSave={handleSaveItvAppointment}
                furgoneta={furgonetaForItvAppointment}
                user={user}
            />
            {isItvPasadaModalOpen && (
                <AddMantenimientoModal
                    isOpen={isItvPasadaModalOpen}
                    onClose={() => {
                        setIsItvPasadaModalOpen(false);
                        setFurgonetaForItvPasada(null);
                    }}
                    onMantenimientoSaved={handleItvMantenimientoSaved}
                    furgoneta={furgonetaForItvPasada}
                    fromRecordatorio={{
                        tipos: ['ITV'],
                        descripcion: 'ITV PASADA',
                        kilometraje: furgonetaForItvPasada?.kilometraje || ''
                    }}
                    user={user}
                />
            )}
        </div>
    );
}